(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}],2:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*******************************************************************************
 * Copyright 2017 Adobe
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ******************************************************************************/
if (window.Element && !Element.prototype.closest) {
  // eslint valid-jsdoc: "off"
  Element.prototype.closest = function (s) {
    "use strict";

    var matches = (this.document || this.ownerDocument).querySelectorAll(s);
    var el = this;
    var i;
    do {
      i = matches.length;
      while (--i >= 0 && matches.item(i) !== el) {
        // continue
      }
    } while (i < 0 && (el = el.parentElement));
    return el;
  };
}
if (window.Element && !Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    "use strict";

    var matches = (this.document || this.ownerDocument).querySelectorAll(s);
    var i = matches.length;
    while (--i >= 0 && matches.item(i) !== this) {
      // continue
    }
    return i > -1;
  };
}
if (!Object.assign) {
  Object.assign = function (target, varArgs) {
    // .length of function is 2
    "use strict";

    if (target === null) {
      throw new TypeError("Cannot convert undefined or null to object");
    }
    var to = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];
      if (nextSource !== null) {
        for (var nextKey in nextSource) {
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}
(function (arr) {
  "use strict";

  arr.forEach(function (item) {
    if (Object.prototype.hasOwnProperty.call(item, "remove")) {
      return;
    }
    Object.defineProperty(item, "remove", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/*******************************************************************************
* Copyright 2016 Adobe
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*     http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
******************************************************************************/
(function () {
  "use strict";

  var devicePixelRatio = window.devicePixelRatio || 1;
  function SmartImage(noScriptElement, options) {
    var that = this;
    var showsLazyLoader = false;
    var image;
    var container;
    var anchor;
    var dropContainer;
    var initDone = false;
    that.defaults = {
      loadHidden: false,
      imageSelector: "img",
      containerSelector: ".cmp-image",
      sourceAttribute: "src",
      lazyEnabled: true,
      lazyThreshold: 0,
      lazyEmptyPixel: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      lazyLoaderClass: "loading",
      lazyLoaderStyle: {
        "height": 0,
        "padding-bottom": "" // will get replaced with ratio in %
      }
    };
    function init() {
      var tmp = document.createElement("div");
      tmp.innerHTML = decodeNoScript(noScriptElement.textContent.trim());
      var imageElement = tmp.firstElementChild;
      var source = imageElement.getAttribute(options.sourceAttribute);
      imageElement.removeAttribute(options.sourceAttribute);
      imageElement.setAttribute("data-src-disabled", source);
      container.insertBefore(imageElement, noScriptElement);
      noScriptElement.remove();
      if (container.matches(options.imageSelector)) {
        image = container;
      } else {
        image = imageElement;
      }
      that.container = container;
      that.options = options;
      that.image = image;
      if (options.lazyEnabled) {
        addLazyLoader();
      }
      window.addEventListener("scroll", that.update);
      window.addEventListener("resize", that.update);
      window.addEventListener("update", that.update);
      image.addEventListener("cmp-image-redraw", that.update);
      that.update();
    }
    function loadImage() {
      if (options.smartSizes && options.smartImages && options.smartSizes.length > 0) {
        if (options.smartSizes.length === options.smartImages.length) {
          var containerWidth = 0;
          if (container.tagName.toLowerCase() === "a") {
            containerWidth = container.parentElement.clientWidth;
          } else {
            containerWidth = container.clientWidth;
          }
          var optimalSize = containerWidth * devicePixelRatio;
          var len = options.smartSizes.length;
          var key = 0;
          while (key < len - 1 && options.smartSizes[key] < optimalSize) {
            key++;
          }
          if (image.getAttribute(options.sourceAttribute) !== options.smartImages[key]) {
            image.setAttribute(options.sourceAttribute, options.smartImages[key]);
            image.removeAttribute("data-src-disabled");
            window.removeEventListener("scroll", that.update);
          }
        }
      } else {
        if (!initDone) {
          image.setAttribute(options.sourceAttribute, image.getAttribute("data-src-disabled"));
          image.removeAttribute("data-src-disabled");
          window.removeEventListener("scroll", that.update);
          initDone = true;
        }
      }
      if (showsLazyLoader) {
        image.addEventListener("load", removeLazyLoader);
      }
    }
    function addLazyLoader() {
      var width = image.getAttribute("width");
      var height = image.getAttribute("height");
      if (width && height) {
        var ratio = height / width * 100;
        var styles = options.lazyLoaderStyle;
        styles["padding-bottom"] = ratio + "%";
        for (var s in styles) {
          if (Object.prototype.hasOwnProperty.call(styles, s)) {
            image.style[s] = styles[s];
          }
        }
      }
      image.setAttribute(options.sourceAttribute, options.lazyEmptyPixel);
      image.classList.add(options.lazyLoaderClass);
      showsLazyLoader = true;
    }
    function removeLazyLoader() {
      image.classList.remove(options.lazyLoaderClass);
      for (var property in options.lazyLoaderStyle) {
        if (Object.prototype.hasOwnProperty.call(options.lazyLoaderStyle, property)) {
          image.style[property] = "";
        }
      }
      image.removeEventListener("load", removeLazyLoader);
      showsLazyLoader = false;
    }
    function isLazyVisible() {
      if (container.offsetParent === null) {
        return false;
      }
      var wt = window.pageYOffset;
      var wb = wt + document.documentElement.clientHeight;
      var et = container.getBoundingClientRect().top + wt;
      var eb = et + container.clientHeight;
      return eb >= wt - options.lazyThreshold && et <= wb + options.lazyThreshold;
    }
    that.update = function () {
      if (options.lazyEnabled) {
        if (isLazyVisible() || options.loadHidden) {
          loadImage();
        }
      } else {
        loadImage();
      }
    };
    options = Object.assign(that.defaults, options);
    container = noScriptElement.closest(options.containerSelector);
    if (container) {
      dropContainer = noScriptElement.closest(".cq-dd-image");
      if (dropContainer) {
        container = dropContainer;
      }
      anchor = container.querySelector(".cmp-image--link");
      if (anchor !== null) {
        container = anchor;
      }
      init();
    }
  }
  document.addEventListener("DOMContentLoaded", function () {
    var imageElements = document.querySelectorAll("noscript[data-cmp-image]");
    var images = [];
    for (var index = 0; index < imageElements.length; index++) {
      var noScriptElement = imageElements[index];
      var imageOptions = noScriptElement.dataset.cmpImage;
      noScriptElement.removeAttribute("data-cmp-image");
      images.push(new SmartImage(noScriptElement, JSON.parse(imageOptions)));
    }
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    var body = document.querySelector("body");
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        // needed for IE
        var nodesArray = [].slice.call(mutation.addedNodes);
        if (nodesArray.length > 0) {
          nodesArray.forEach(function (addedNode) {
            if (addedNode.querySelectorAll) {
              var noScriptArray = [].slice.call(addedNode.querySelectorAll("noscript[data-cmp-image]"));
              noScriptArray.forEach(function (noScriptElement) {
                var imageOptions = JSON.parse(noScriptElement.dataset.cmpImage);
                noScriptElement.removeAttribute("data-cmp-image");
                images.push(new SmartImage(noScriptElement, imageOptions));
              });
            }
          });
        }
      });
    });
    observer.observe(body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  });

  /*
       on drag & drop of the component into a parsys, noscript's content will be escaped multiple times by the editor which creates
       the DOM for editing; the HTML parser cannot be used here due to the multiple escaping
   */
  function decodeNoScript(text) {
    text = text.replace(/&(amp;)*lt;/g, "<");
    text = text.replace(/&(amp;)*gt;/g, ">");
    return text;
  }
})();

/*******************************************************************************
* Copyright 2016 Adobe
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*     http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
******************************************************************************/
(function () {
  "use strict";

  function documentReady(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }
  var INPUT_FIELD = ".cmp-form-field input";
  var REQUIRED_MSG_ATTRIBUTE = "data-cmp-required";
  var CONSTRAINT_MSG_ATTRIBUTE = "data-cmp-constraint";
  documentReady(function () {
    var inputFields = document.querySelectorAll(INPUT_FIELD);
    var inputField;
    var index;
    for (index = 0; index < inputFields.length; index++) {
      inputField = inputFields[index];
      inputField.addEventListener("invalid", function (e) {
        e.target.setCustomValidity("");
        if (e.target.validity.typeMismatch) {
          if (inputField.hasAttribute(CONSTRAINT_MSG_ATTRIBUTE)) {
            e.target.setCustomValidity(inputField.getAttribute(CONSTRAINT_MSG_ATTRIBUTE));
          }
        } else if (e.target.validity.valueMissing) {
          if (inputField.hasAttribute(REQUIRED_MSG_ATTRIBUTE)) {
            e.target.setCustomValidity(inputField.getAttribute(REQUIRED_MSG_ATTRIBUTE));
          }
        }
      });
      inputField.addEventListener("input", function (e) {
        e.target.setCustomValidity("");
      });
    }
  });
})();

//JavaScript HTML Sanitizer v2.0.2, (c) Alexander Yumashev, Jitbit Software.

//homepage https://github.com/jitbit/HtmlSanitizer

//License: MIT https://github.com/jitbit/HtmlSanitizer/blob/master/LICENSE
'use strict';
window.HtmlSanitizer = new function () {
  var _tagWhitelist = {
    'A': true,
    'ABBR': true,
    'B': true,
    'BLOCKQUOTE': true,
    'BODY': true,
    'BR': true,
    'CENTER': true,
    'CODE': true,
    'DD': true,
    'DIV': true,
    'DL': true,
    'DT': true,
    'EM': true,
    'FONT': true,
    'H1': true,
    'H2': true,
    'H3': true,
    'H4': true,
    'H5': true,
    'H6': true,
    'HR': true,
    'I': true,
    'IMG': true,
    'LABEL': true,
    'LI': true,
    'OL': true,
    'P': true,
    'PRE': true,
    'SMALL': true,
    'SOURCE': true,
    'SPAN': true,
    'STRONG': true,
    'SUB': true,
    'SUP': true,
    'TABLE': true,
    'TBODY': true,
    'TR': true,
    'TD': true,
    'TH': true,
    'THEAD': true,
    'UL': true,
    'U': true,
    'VIDEO': true
  };
  var _contentTagWhiteList = {
    'FORM': true,
    'GOOGLE-SHEETS-HTML-ORIGIN': true
  }; //tags that will be converted to DIVs

  var _attributeWhitelist = {
    'align': true,
    'color': true,
    'controls': true,
    'height': true,
    'href': true,
    'id': true,
    'src': true,
    'style': true,
    'target': true,
    'title': true,
    'type': true,
    'width': true
  };
  var _cssWhitelist = {
    'background-color': true,
    'color': true,
    'font-size': true,
    'font-weight': true,
    'text-align': true,
    'text-decoration': true,
    'width': true
  };
  var _schemaWhiteList = ['http:', 'https:', 'data:', 'm-files:', 'file:', 'ftp:', 'mailto:', 'pw:']; //which "protocols" are allowed in "href", "src" etc

  var _uriAttributes = {
    'href': true,
    'action': true
  };
  var _parser = new DOMParser();
  this.SanitizeHtml = function (input, extraSelector) {
    input = input.trim();
    if (input == "") return ""; //to save performance

    //firefox "bogus node" workaround for wysiwyg's
    if (input == "<br>") return "";
    if (input.indexOf("<body") == -1) input = "<body>" + input + "</body>"; //add "body" otherwise some tags are skipped, like <style>

    var doc = _parser.parseFromString(input, "text/html");

    //DOM clobbering check (damn you firefox)
    if (doc.body.tagName !== 'BODY') doc.body.remove();
    if (typeof doc.createElement !== 'function') doc.createElement.remove();
    function makeSanitizedCopy(node) {
      var newNode;
      if (node.nodeType == Node.TEXT_NODE) {
        newNode = node.cloneNode(true);
      } else if (node.nodeType == Node.ELEMENT_NODE && (_tagWhitelist[node.tagName] || _contentTagWhiteList[node.tagName] || extraSelector && node.matches(extraSelector))) {
        //is tag allowed?

        if (_contentTagWhiteList[node.tagName]) newNode = doc.createElement('DIV'); //convert to DIV
        else newNode = doc.createElement(node.tagName);
        for (var i = 0; i < node.attributes.length; i++) {
          var attr = node.attributes[i];
          if (_attributeWhitelist[attr.name]) {
            if (attr.name == "style") {
              for (var s = 0; s < node.style.length; s++) {
                var styleName = node.style[s];
                if (_cssWhitelist[styleName]) newNode.style.setProperty(styleName, node.style.getPropertyValue(styleName));
              }
            } else {
              if (_uriAttributes[attr.name]) {
                //if this is a "uri" attribute, that can have "javascript:" or something
                if (attr.value.indexOf(":") > -1 && !startsWithAny(attr.value, _schemaWhiteList)) continue;
              }
              newNode.setAttribute(attr.name, attr.value);
            }
          }
        }
        for (var _i = 0; _i < node.childNodes.length; _i++) {
          var subCopy = makeSanitizedCopy(node.childNodes[_i]);
          newNode.appendChild(subCopy, false);
        }

        //remove useless empty spans (lots of those when pasting from MS Outlook)
        if ((newNode.tagName == "SPAN" || newNode.tagName == "B" || newNode.tagName == "I" || newNode.tagName == "U") && newNode.innerHTML.trim() == "") {
          return doc.createDocumentFragment();
        }
      } else {
        newNode = doc.createDocumentFragment();
      }
      return newNode;
    }
    ;
    var resultElement = makeSanitizedCopy(doc.body);
    return resultElement.innerHTML.replace(/<br[^>]*>(\S)/g, "<br>\n$1").replace(/div><div/g, "div>\n<div"); //replace is just for cleaner code
  };
  function startsWithAny(str, substrings) {
    for (var i = 0; i < substrings.length; i++) {
      if (str.indexOf(substrings[i]) == 0) {
        return true;
      }
    }
    return false;
  }
  this.AllowedTags = _tagWhitelist;
  this.AllowedAttributes = _attributeWhitelist;
  this.AllowedCssStyles = _cssWhitelist;
  this.AllowedSchemas = _schemaWhiteList;
}();
$(document).ready(function () {
  setTimeout(function () {
    $('#fading-circle').hide();
    $('.agent-fading-overlay').hide();
  }, 2500);
});
$(window).on('load', function () {
  var responsiveContainer = $('.s7responsiveContainer');
  var responsiveWrapper = $('.s7dm-dynamic-media');
  var chImage = $('.ch-hero-img');

  // Fetching the alt text from data-alt attribute and assigning it to image
  responsiveContainer.each(function () {
    var altText = $(this).parent().attr('data-alt');
    assignAlt($(this), altText);
  });
  responsiveWrapper.each(function () {
    var altText = $(this).attr('data-alt');
    assignAlt($(this), altText);
  });
  chImage.each(function () {
    var altText = $(this).attr('alt');
    if (altText && altText.length > 0) {
      $(this).attr('alt', altText);
    } else {
      $(this).attr('alt', "");
    }
  });
  function assignAlt(ele, altText) {
    if (altText && altText.length > 0) {
      ele.find('img').attr('alt', altText);
    } else {
      ele.find('img').attr('alt', "");
    }
  }
});

/***********************
* browser info
***********************/
var browserSpecifics;
var whichBrowser;
var whichUserAgent;
var mBrowserVersion;
var specialVarForOpera;
specialVarForOpera = navigator.userAgent.substring(0, 5);
var isIE6 = false;
var isIE7 = false;
var isIE8 = false;
var isIE8CO = false;
var isIE9 = false;
jQuery.browser = {};
jQuery.browser.mozilla = /mozilla/.test(navigator.userAgent.toLowerCase()) && !/webkit/.test(navigator.userAgent.toLowerCase());
jQuery.browser.webkit = /webkit/.test(navigator.userAgent.toLowerCase());
jQuery.browser.opera = /opera/.test(navigator.userAgent.toLowerCase());
jQuery.browser.msie = /msie/.test(navigator.userAgent.toLowerCase());
if (navigator.appVersion.indexOf("MSIE 6.") != -1) {
  isIE6 = true;
}
if (navigator.appVersion.indexOf("MSIE 7.") != -1) {
  isIE7 = true;
}
if (navigator.appVersion.indexOf("MSIE 8.") != -1) {
  isIE8 = true;
}
if (navigator.appVersion.indexOf("MSIE 9.") != -1) {
  isIE9 = true;
}
var OSName = "";
if (navigator.appVersion.indexOf("Win") != -1) OSName = "win";
if (navigator.appVersion.indexOf("Mac") != -1) OSName = "mac";
if (navigator.appVersion.indexOf("X11") != -1) OSName = "unix";
if (navigator.appVersion.indexOf("Linux") != -1) OSName = "linux";
if (navigator.appName == "Netscape") {
  if (navigator.userAgent.indexOf("Chrome") != -1) {
    whichBrowser = "Chrome";
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    whichBrowser = "Safari";
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    whichBrowser = "Firefox";
  } else if (specialVarForOpera == "Opera") {
    whichBrowser = specialVarForOpera;
  } else {}
} else if (navigator.appName == "Microsoft Internet Explorer") {
  whichBrowser = "IE";
}
whichUserAgent = navigator.userAgent;
browserSpecifics = whichUserAgent;
var mDetect = function mDetect() {
  var N = navigator.appName,
    ua = navigator.userAgent,
    tem;
  var M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
  if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) M[2] = tem[1];
  M = M ? [M[1], M[2]] : [N, navigator.appVersion, '-?'];
  return M + "";
};
$(document).ready(function () {
  if (navigator.appName == "Microsoft Internet Explorer") {
    var out = "";
    try {
      var b = document.getElementsByTagName("body")[0];
      var s = document.createElement("div");
      s.innerHTML = "<div style='behavior:url(#default#clientCaps)' ID='oClientCaps' ></div>";
      b.appendChild(s);
      var clids = Array('{3af36230-a269-11d1-b5bf-0000f8051515}');
      out += oClientCaps.getComponentVersion(clids[0], "ComponentID");
    } catch (e) {
      out += "clientCaps failed" + e;
    }
    var searchOut = out.search("18702");
    if (searchOut != -1) {
      isIE8CO = true;
    } else {
      isIE8CO = false;
    }
  }
  mBrowserVersion = mDetect();
});

/***********************
* sourceid starts here
***********************/

var mSplitVarArray = new Array();
$(document).ready(function () {
  // cypher through url to find directory and file name
  var mReceivedUrl = document.URL;
  mSplitVarArray = mReceivedUrl.split('/');
  if (mSplitVarArray[mSplitVarArray.length - 1] == "" || typeof mSplitVarArray[mSplitVarArray.length - 1] == "undefined") {
    mSplitVarArray[mSplitVarArray.length - 1] = "index.html";
  }
});
var refUrl;

// this function will be invoked only from the Test region stub in order to pass the referrer
function setCookiesForTestStubPage(expiredays, testRefUrl) {
  refUrl = testRefUrl;
  setCookies(expiredays);
}
function setCookies(expiredays) {
  var value = queryString('sourceid');
  if (value) {
    createCookie('SourceID', value, expiredays);
  } else {
    //	 pushed in per Mel to create only one cookie if paid search has search referral URLs
    if (refUrl == null) {
      refUrl = escape(document.referrer);
    }
    var value = null;
    if (refUrl.indexOf('google.com') != -1) {
      value = 'GOOC0000001';
    } else if (refUrl.indexOf('bing.com') != -1) {
      value = 'MSNC0000001';
    } else if (refUrl.indexOf('yahoo.com') != -1) {
      value = 'YAHC0000001';
    } else if (refUrl.indexOf('ask.com') != -1) {
      value = 'ASKC0000001';
    } else if (refUrl.indexOf('aol.com') != -1) {
      value = 'AOLC0000001';
    }
    if (value != null) {
      createCookie('SESourceID', value, expiredays);
    } else {
      // for testing in local from the 'Sample' column of Source Id checklist.xls
      //refUrl = escape('Referer: http://www.farmersinsurance.com');
      // for testing in local
      refUrl = escape(document.referrer);
      value = 'FC000000001';
      if (refUrl.indexOf('farmersinsurance.com') != -1) {
        value = 'FINS0000001';
      } else if (refUrl.indexOf('farmershawaii.com') != -1) {
        value = 'FAHW0000001';
      } else if (refUrl.indexOf('21st.com') != -1) {
        value = '21ST0000001';
      } else if (refUrl.indexOf('universityoffarmers.com') != -1) {
        value = 'UFDC001L001';
      }
      if (value != null) {
        createCookie('FASourceID', value, expiredays);
      }
    }
  }
}
function createCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setTime(exdate.getTime());
  expiredays = expiredays * 1000 * 60 * 60 * 24;
  var expiry_date = new Date(exdate.getTime() + expiredays);
  if (getCookie(c_name) == null || getCookie(c_name) == "") {
    // this is for deployment with farmers.com domain
    if (whichBrowser == "Chrome") {
      // alert("mSplitVarArray[0]:"+mSplitVarArray[0]+" "+"mSplitVarArray[1]:"+mSplitVarArray[1]);
      if ((mSplitVarArray[0] == "index.html" || mSplitVarArray[0] == "") && (mSplitVarArray[mSplitVarArray.length - 2] == "www.farmers.com" || mSplitVarArray[mSplitVarArray.length - 2] == "farmers.com")) {
        document.cookie = c_name + "=" + escape(value) + (expiredays == null ? "" : ";expires=" + expiry_date.toGMTString()) + ";";
      } else {
        document.cookie = c_name + "=" + escape(value) + (expiredays == null ? "" : ";expires=" + expiry_date.toGMTString()) + ";path=/";
      }
    } else {
      document.cookie = c_name + "=" + escape(value) + (expiredays == null ? "" : ";expires=" + expiry_date.toGMTString()) + ";path=/";
    }
    // this is for deployment with farmers.com domain

    //	document.cookie=c_name+ "=" +escape(value)+((expiredays==null) ? "" : ";expires="+expiry_date.toGMTString())+";path=/";
  }
}
function queryString(parameter) {
  var loc = location.search.substring(1, location.search.length);
  var param_value = false;
  var params = loc.split("&");
  for (var i = 0; i < params.length; i++) {
    var param_name = params[i].substring(0, params[i].indexOf('='));
    if (param_name.toLowerCase() == parameter) {
      param_value = params[i].substring(params[i].indexOf('=') + 1);
    }
  }
  if (param_value) {
    return param_value;
  } else {
    return false; //Here determine return if no parameter is found
  }
}
function getCookie(c_name) {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == c_name) {
      return unescape(y);
    }
  }
  return null;
}
$(document).ready(function () {
  var a = 2;
  setCookies(a);
});
$(document).ready(function () {
  var headingLfe = $("h1");
  $("img[border='0']").remove();
  $('br, hr').attr('aria-hidden', 'true');
  $("a[target='_blank']").each(function () {
    var text = $(this).text();
    var ariaAttr = $(this).attr('aria-label');
    var targetText = ' opens in new window';
    var label = text + targetText;
    if (_typeof(ariaAttr) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) && ariaAttr !== false) {
      $(this).attr('aria-label', ariaAttr + targetText);
    } else {
      $(this).attr('aria-label', label);
    }
  });
  var focusable = $(document).find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  var lastFocusable = focusable[focusable.length - 1];
  $(lastFocusable).focusout(function () {
    $(window).scrollTop(0, 0);
  });
  $('.sticky-header .heading').click(function () {
    openDialogSetTabindex();
  });
  $('.business-nav .close').click(function () {
    closeDialogSetTabindex();
  });

  //Check if lfe richtext have h1 to add attr
  if (headingLfe.length) {
    headingLfe.attr('data-swiftype-name', 'title').attr('data-swiftype-type', 'string');
  }
  var nonModalNodes;
  var preAriaHiddenEle;
  function openDialogSetTabindex() {
    var modalNodes = [].slice.call(document.querySelectorAll('.business-nav.open *'));
    preAriaHiddenEle = $("[aria-hidden=true]");
    nonModalNodes = document.querySelectorAll('body *:not(dialog):not([tabindex="-1"])');
    for (var i = 0; i < nonModalNodes.length; i++) {
      var node = nonModalNodes[i];
      if (!(jQuery.inArray(node, modalNodes) !== -1)) {
        node._prevTabindex = node.getAttribute('tabindex');
        node.setAttribute('tabindex', '-1');
        node.setAttribute('aria-hidden', 'true');
      }
    }
    $('.business-nav.open').removeAttr("tabindex");
    $('.business-nav.open').removeAttr("aria-hidden");
    $('.business-nav.open').parents().removeAttr("tabindex");
    $('.business-nav.open').parents().removeAttr("aria-hidden");
  }
  function closeDialogSetTabindex() {
    for (var i = 0; i < nonModalNodes.length; i++) {
      var node = nonModalNodes[i];
      if (node._prevTabindex) {
        node.setAttribute('tabindex', node._prevTabindex);
        node._prevTabindex = null;
      } else {
        node.removeAttribute('tabindex');
      }
      node.removeAttribute('aria-hidden');
    }
    if (preAriaHiddenEle.length) {
      for (var i = 0; i < preAriaHiddenEle.length; i++) {
        preAriaHiddenEle[i].setAttribute("aria-hidden", true);
      }
    }
  }
});
window.HtmlSanitizer.AllowedAttributes['data-email'] = true;
window.HtmlSanitizer.AllowedAttributes['data-name'] = true;
window.HtmlSanitizer.AllowedAttributes['data-insurancechoice'] = true;
window.HtmlSanitizer.AllowedAttributes['data-groupselect'] = true;
window.HtmlSanitizer.AllowedAttributes['data-href'] = true;
window.HtmlSanitizer.AllowedAttributes.alt = true;
window.HtmlSanitizer.AllowedAttributes.loading = true;
window.HtmlSanitizer.AllowedAttributes.rel = true;
window.HtmlSanitizer.AllowedSchemas.push('tel:');
var isMobile = false; //initiate as false
/** Start Code for disabling double Tap   **/
var lastTouchEnd = 0;
document.addEventListener('touchend', function (event) {
  var now = new Date().getTime();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);
/************ END       *******************/
function addPlatFormSpeciifcClass(language) {
  var device_class = "";
  if (navigator.userAgent.match(/(iPhone)/i)) {
    device_class = "iphone";
  } else if (navigator.userAgent.match(/(iPad)/i)) {
    device_class = "ipad";
  } else if (navigator.userAgent.match(/android/i)) {
    device_class = "andriod";
  } else if (navigator.userAgent.match(/mac/i)) {
    device_class = "mac";
  } else if (navigator.userAgent.match(/armv/i)) {
    device_class = "armv";
  } else if (navigator.userAgent.match(/Trident/i)) {
    device_class = "ie";
  }
  if (device_class != "") {
    $("body").addClass(device_class);
  }
}
addPlatFormSpeciifcClass();

// JS for superscript link functionality
$(document).ready(function () {
  var linkSup = $("a[href*='#'] > sup, .bottom-hyperlink a[href*='#']");
  var topLinkMargin = 110;
  if ($(window).width() < 767) {
    topLinkMargin = 55;
  }
  linkSup.each(function (index, obj) {
    $(obj).off('click').on('click', function () {
      setTimeout(function () {
        var current = $(window).scrollTop();
        $(window).scrollTop(current - topLinkMargin);
      }, 95);
    });
  });
});

/* --------------------------------------------------------------- */
/* -- ANALYTICS -------------------------------------------------- */
/* --------------------------------------------------------------- */

/* Arrays for holding zip, section and file to send to webtrends */
var varArray = [];
var mReceivedUrl = document.URL;
varArray = mReceivedUrl.split('/');
if (varArray[varArray.length - 1] === "" || typeof varArray[varArray.length - 1] == "undefined") {
  varArray[varArray.length - 1] = "index.html";
}
var tempZipArr = [];
tempZipArr[0] = 10000;
var tempActionArr = [];
tempActionArr[0] = "";
var tempMethodArr = [];
tempMethodArr[0] = "";
var mHeader = document.getElementsByTagName("head")[0];
var alreadyLoadedGoogle = [];
alreadyLoadedGoogle[0] = "false";
var mGetCookieArr = [];
var jqryCookieArr = [];
jqryCookieArr[0] = "false";
// all code commented out was deleted or blocked because similar functions were both to body and head 
//     function gtmTracking(){
//         gtmRegEx = new RegExp('(.*)gtm\.js'); 
//         for(var mGT = 0; mGT < document.getElementsByTagName("script").length; mGT++){
//                 var tempGT = document.getElementsByTagName("script")[mGT].src;
//                 if(gtmRegEx.test(tempGT)){
//                     alreadyLoadedGoogle[0] = "true";
//                 }
//         }

//         if(alreadyLoadedGoogle[0] == "false"){
//             var tagManagerID = 'GTM-WJ8XW6';
//             //Call the Tag Management Script
//             loadTagManager(window, document, 'script', 'dataLayer', tagManagerID);
//             //End Tag Manager
//         }
//     }

//     //Tag Manager function dynamically injects Google's script with the appropriate variables.
//     function loadTagManager(w, d, s, l, i) {
//         w[l] = w[l] || [];
//         w[l].push({
//             'gtm.start': new Date().getTime(),
//             'event': 'gtm.js'
//         });
//         var f = d.getElementsByTagName(s)[0],
//             j = d.createElement(s),
//             dl = l != 'dataLayer' ? '&l=' + l : '';
//         j.async = true;
//         j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
//         f.parentNode.insertBefore(j, f);
//     }

/* Start Quote button listener */
function primaryBtnListener() {
  if ($('form.component-find-a-quote button.btn-primary')[0]) {
    $('form.component-find-a-quote button.btn-primary').on('mousedown', function (event) {
      tempZipArr[0] = $('input[name="Zip_Code"]').val();
    });
  }
}

/* Listen for form submission */
function componentFindQuote() {
  $('form.component-find-an-quote').submit(function (event) {
    tempZipArr[0] = $('input[name="Zip_Code"]').val();
  });
}
function componentFindAgent() {
  $('form.component-find-an-agent').submit(function (event) {
    tempZipArr[0] = $('input[name="q"]').val();
  });
}

// Create environment hashmap
var environment = {};
jQuery.expr[':'].regex = function (elem, index, match) {
  var matchParams = match[3].split(','),
    validLabels = /^(data|css):/,
    attr = {
      method: matchParams[0].match(validLabels) ? matchParams[0].split(':')[0] : 'attr',
      property: matchParams.shift().replace(validLabels, '')
    },
    regexFlags = 'ig',
    regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g, ''), regexFlags);
  return regex.test(jQuery(elem)[attr.method](attr.property));
};

// Add environments to the hashmap
environment['cssta'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '/AFTquote/ffq/directlandingpage.jsf ',
  ffqLink: '/AFTquote/ffq/directlandingpage.jsf',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/mi61/login',
  loginTarget: 'https://cssta.farmers.com/redirectMI61.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/mi61/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit8-sit-948.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstb'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/tsv1/login',
  loginTarget: 'https://csstb.farmers.com/redirectTB.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/tsv1/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit6-sit-946.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstc'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/tl21/login',
  loginTarget: 'https://csstc.farmers.com/redirectTU.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/tl21/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit7-sit-947.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstd'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  ffqGetAQuote: 'https://csstd.farmers.com/PRFquote/ffq/landingpage.jsf',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqLink: 'https://ffqperf.farmers.com/FFQ3_PRF/ffq/directlandingpage.jsf',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/qs11/login',
  loginTarget: 'https://csstd.farmers.com/redirectDDM.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/qs11/registration',
  searchLink: '',
  liveChatEnv: 'https://souat1-souat1-farmersinsuranceliveagent.cs9.force.com',
  liveChatName: 'so_chat@integration.user.souat1',
  liveChatValue: 'srmchat#souat1',
  LiveChatUrl: 'https://sofa-uat-farmers--souat1.cs9.my.salesforce.com',
  paymentusiframe: 'https://secure2.paymentus.com/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csste'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://soaplafuncnonacce.farmersinsurance.com:7005/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'https://csste.farmers.com/TEquote/ffq/landingpage.jsf',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginTarget: 'https://csste.farmers.com/redirectTE.html',
  loginLink: '/ms61/login',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/ms61/registration',
  searchLink: '',
  paymentusiframe: '',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstg'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'https://csstg.farmers.com/GDEVquote/ffq/landingpage.jsf',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/te71/login',
  loginTarget: 'https://csstg.farmers.com/redirectSTMAIT.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/te71/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit10-sit-4237.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['cssth'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/mn91/login',
  loginTarget: 'https://cssth.farmers.com/redirectTU.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/mn91/registration',
  searchLink: '',
  paymentusiframe: '',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['cssti'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: "return validateContactUsForm_update('https://farmerssrm--sodev3.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')",
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'https://csstg.farmers.com/MAquote/ffq/landingpage.jsf',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/tsk1/login',
  loginTarget: 'https://cssti.farmers.com/redirectTI.html',
  paymentLink: '/customerselfservice/CSSPayment#/billing/authentication',
  registerlinkURL: '/tsk1/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit6-sit-946.paymentus.io/rotp/fr14',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstl'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: "return validateContactUsForm_update('https://farmerssrm--srmqa2.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')",
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'https://csstn.farmers.com/REGTNquote/ffq/landingpage.jsf',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/ma61/login',
  loginTarget: 'https://csstu.farmers.com/redirectTU.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/ma61/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit16-sit-4519.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstn'] = {
  cantAccesslinkURL: '/customerselfservice/CSSU#/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/tso1/login',
  loginTarget: 'https://csstn.farmers.com/redirectTN.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/tso1/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit13-sit-3858.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstp'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: "return validateContactUsForm_update('https://farmerssrm--sodev3.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')",
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '/PETquote/ffq/landingpage.jsf',
  ffqLink: '/PETquote/ffq/directlandingpage.jsf',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/rs11/login',
  loginTarget: 'https://csstp.farmers.com/redirectTP.html',
  paymentLink: '/customerselfservice/CSSPayment#/billing/authentication',
  registerlinkURL: '/rs11/registration',
  searchLink: '/search',
  liveChatEnv: 'https://souat1-souat1-farmersinsuranceliveagent.cs9.force.com',
  liveChatName: 'so_chat@integration.user.souat1',
  liveChatValue: 'srmchat#souat1',
  LiveChatUrl: 'https://sofa-uat-farmers--souat1.cs9.my.salesforce.com',
  paymentusiframe: 'https://frms-pet2-sit-2570.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstq'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'https://csstq.farmers.com/AITquote/ffq/landingpage.jsf',
  ffqLink: '/AITquote/ffq/directlandingpage.jsf',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/tu91/login',
  loginTarget: 'https://csstq.farmers.com/redirectTQ.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/tu91/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit-1647.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstr'] = {
  HP_forgot_primary: '',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '/REGquote/ffq/landingpage.jsf',
  ffqLink: '/REGquote/ffq/directlandingpage.jsf',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/login',
  loginTarget: 'https://csstr.farmers.com/MI11.html',
  paymentLink: '',
  registerlinkURL: '',
  searchLink: '',
  paymentusiframe: '',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['cssts'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/mi51/login',
  loginTarget: 'https://cssts.farmers.com/redirectFABAIT.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/mi51/registration',
  searchLink: '/search',
  paymentusiframe: 'https://frms-pet-sit-2343.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstt'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: "return validateContactUsForm_update('https://farmerssrm--sosit1.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')",
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/ra61/login',
  loginTarget: 'https://csstt.farmers.com/redirectTT.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/ra61/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit17-sit-4520.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstu'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: "return validateContactUsForm_update('https://farmerssrm--srmqa.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')",
  fccURL: 'http://soafunc.farmersinsurance.com/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'https://cssta.farmers.com/AFTquote/ffq/landingpage.jsf',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/ma11/login',
  loginTarget: 'https://csstu.farmers.com/redirectTU.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/ma11/registration',
  searchLink: '',
  liveChatEnv: 'https://souat1-souat1-farmersinsuranceliveagent.cs9.force.com',
  liveChatName: 'so_chat@integration.user.souat1',
  liveChatValue: 'srmchat#souat1',
  LiveChatUrl: 'https://sofa-uat-farmers--souat1.cs9.my.salesforce.com',
  paymentusiframe: '  https://frms-sit5-sit-945.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstv'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: "return validateContactUsForm_update('https://sofa-uat-farmers--souat1.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')",
  fccURL: 'http://soaplareg.farmersinsurance.com:7009/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'https://csstr.farmers.com/REGquote/ffq/landingpage.jsf',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/ra11/login',
  loginTarget: 'https://csstv.farmers.com/redirectTT_uat3.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/ra11/registration',
  searchLink: '',
  liveChatEnv: 'https://souat1-souat1-farmersinsuranceliveagent.cs9.force.com',
  liveChatName: 'so_chat@integration.user.souat1',
  liveChatValue: 'srmchat#souat1',
  LiveChatUrl: 'https://sofa-uat-farmers--souat1.cs9.my.salesforce.com',
  paymentusiframe: 'https://frms-sit-3758.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstw'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: "return validateContactUsForm_update('https://sofa-sit-farmers--SOSIT1.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')",
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'https://csstq.farmers.com/AITquote/ffq/landingpage.jsf',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/tsj1/login',
  loginTarget: 'https://csstw.farmers.com/redirectAIT.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/tsj1/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit11-sit-4239.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstx'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: "return validateContactUsForm_update('https://farmerssrm--sosit1.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8')",
  fccURL: 'https://prodfix-farmers.cs27.force.com/customerselfservice/CSSPayment',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/ms81/login',
  loginTarget: 'https://csstx.farmers.com/redirectTX.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/ms81/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit12-sit-4240.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['cssty'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: 'http://cssty.farmers.com/TYquote/ffq/landingpage.jsf',
  ffqLink: 'https://ffqperf.farmers.com/FFQ3_PRF/ffq/directlandingpage.jsf',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/tn91/login',
  loginTarget: 'https://cssty.farmers.com/redirectTY.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/tn91/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit5-sit-945.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};
environment['csstz'] = {
  HP_forgot_primary: '',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: 'https://csstd.farmers.com/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/login',
  loginTarget: 'https://csstd.farmers.com/redirectDV.html',
  paymentLink: '',
  registerlinkURL: '',
  searchLink: '',
  paymentusiframe: '',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};

//default to aft
environment['cssstm'] = {
  HP_forgot_primary: '/css/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: '/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: '/ml91/login',
  loginTarget: 'https://cssstm.farmers.com/redirectSTMAC2.html',
  paymentLink: '/customerselfservice/CSSPayment',
  registerlinkURL: '/ml91/registration',
  searchLink: '',
  paymentusiframe: 'https://frms-sit18-sit-4525.paymentus.io/rotp/frms',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  personalLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p',
  commercialLogoutSurveyFeedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_bPcg46cWOh7R1R4'
};

//aft
environment['cssstm_aft'] = {
  HP_forgot_primary: 'https://configdev2-farmers.cs14.force.com/customerselfservice/CSSU#/forgotuserpassword',
  claimReport: 'https://uat4-farmers.cs16.force.com/cmp/s/filealoss?SO=01',
  claimStatus: 'https://uat4-farmers.cs16.force.com/cmp/s/login/',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: 'https://cssstm.farmers.com/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: 'https://cssstm_aft.farmers.com/login',
  loginTarget: 'https://cssstm.farmers.com/redirectSTMAFT.html',
  paymentLink: '',
  registerlinkURL: 'https://configdev2-farmers.cs14.force.com/customerselfservice/CSSU#/registration/policyinfo',
  searchLink: '',
  paymentusiframe: '',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p'
};
//reg
environment['cssstm_reg'] = {
  HP_forgot_primary: 'https://configdev2-farmers.cs14.force.com/customerselfservice/CSSU#/forgotuserpassword',
  claimReport: '',
  claimStatus: '',
  contactUsURL: '',
  fccURL: 'http://alsb.farmersinsurance.com:81/restapi/v1/customerconsentmanager/fccdisclaimer/customerconsentdata',
  ffqGetAQuote: '',
  ffqLink: '',
  loginAction: 'https://cssstm.farmers.com/siteminderagent/selfreg/loginandregister.fcc',
  loginLink: 'https://cssstm_reg.farmers.com/login',
  loginTarget: 'https://cssstm.farmers.com/redirectSTMREG.html',
  paymentLink: '',
  registerlinkURL: 'https://configdev2-farmers.cs14.force.com/customerselfservice/CSSU#/registration/policyinfo',
  searchLink: '',
  paymentusiframe: '',
  feedbackButtonLink: 'https://farmers.qualtrics.com/jfe/form/SV_06YazVcz7plfX4p'
};
// Add more hosts here

// Identify hostname and region - 'hostname_region'
var region = getParameterByName('region');
var hostname = window.location.hostname;
if (region != null) {
  hostname = hostname + "_" + region;
}

// Custom identifier functions
function getParameterByName(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

// Identify environment and configure links
$(document).ready(function () {
  for (var x in environment) {
    if (hostname.indexOf(x) >= 0) {
      var env = environment[x];

      // Configure Personal lines CSS logout survey qualtrics feedback URL 
      if (null != env['personalLogoutSurveyFeedbackButtonLink'] && undefined != env['personalLogoutSurveyFeedbackButtonLink']) {
        $("#logoutsurvey").attr("data-feedback", env['personalLogoutSurveyFeedbackButtonLink']);
      }
      // Configure Commercial lines CSS logout survey qualtrics feedback URL 
      if (null != env['commercialLogoutSurveyFeedbackButtonLink'] && undefined != env['commercialLogoutSurveyFeedbackButtonLink']) {
        $("#logoutsurvey").attr("data-business", env['commercialLogoutSurveyFeedbackButtonLink']);
      }

      // Configure forgot username / password link (/login)
      if (null != env['HP_forgot_primary'] != env['HP_forgot_primary']) {
        if (env['HP_forgot_primary'] == "") {
          $("#hp_forgot_primary").attr("href", "#");
        } else {
          $("#hp_forgot_primary").attr("href", env['HP_forgot_primary']);
        }
      }

      // Configure contact-us (/contact-us/send-message)
      if (null != env['contactUsURL'] && undefined != env['contactUsURL']) {
        if (env['contactUsURL'] == "") {
          $("#sendMessageBtn").removeAttr("onclick");
        } else {
          $("#sendMessageBtn").attr("onclick", env['contactUsURL']);
        }
      }

      // Configure FCC URL (/contact-us/send-message)
      if (null != env['fccURL'] && undefined != env['fccURL']) {
        if (env['fccURL'] == "") {
          $("#fccDisclaimerURL").removeAttr("value");
        } else {
          $("#fccDisclaimerURL").val(env['fccURL']);
        }
      }

      // ffq link ( homepage-2 )
      if (null != env['ffqLink'] && undefined != env['ffqLink']) {
        if (env['ffqLink'] == "") {
          $("#hero_quote_form").removeAttr("action");
          $("#hero_quote_form").removeAttr("method");
        } else {
          $("#hero_quote_form").attr("action", env['ffqLink']);
        }
      }

      // ffq link ( homepage-2 )
      if (null != env['ffqGetAQuote'] && undefined != env['ffqGetAQuote']) {
        if (env['ffqGetAQuote'] == "") {
          $("#get_a_quote").attr("href", "#");
        } else {
          $("#get_a_quote").attr("href", env['ffqGetAQuote']);
        }
      }

      // Configure login action (/login)
      if (null != env['loginAction'] && undefined != env['loginAction']) {
        if (env['loginAction'] == "") {
          $("#UtilLoginForm").removeAttr("action");
        } else {
          $("#UtilLoginForm").attr("action", env['loginAction']);
        }
      }

      // loginLink from homepage ( global header )
      if (null != env['loginLink'] && undefined != env['loginLink']) {
        if (env['loginLink'] == "") {
          $("#login_link").attr("href", "#");
        } else {
          $("#login_link").attr("href", env['loginLink']);
        }
      }

      // Configure login targetlink (/login)
      if (null != env['loginTarget'] && undefined != env['loginTarget']) {
        if (env['loginTarget'] == "") {
          $('#target_id').removeAttr('value');
        } else {
          $('#target_id').val(env['loginTarget']);
        }
      }

      // Configure payment Links (/payments)
      if (null != env['paymentLink'] && undefined != env['paymentLink']) {
        if (env['paymentLink'] == "") {
          $("#payment_link").attr("href", "#");
        } else {
          $("#payment_link").attr("href", env['paymentLink']);
        }
      }

      // Configure payment Links (/payments)
      if (null != env['paymentLink'] && undefined != env['paymentLink']) {
        if (env['paymentLink'] == "") {
          $("#payment_link2").attr("href", "#");
        } else {
          $("#payment_link2").attr("href", env['paymentLink']);
        }
      }

      // Configure registration link (global header )
      if (null != env['registerlinkURL'] && undefined != env['registerlinkURL']) {
        if (env['registerlinkURL'] == "") {
          $("#register_link").attr("href", "#");
        } else {
          $("#register_link").attr("href", env['registerlinkURL']);
        }
      }

      // Configure registration link (/login Register for My Farmers)
      if (null != env['registerlinkURL'] && undefined != env['registerlinkURL']) {
        if (env['registerlinkURL'] == "") {
          $("#register_link2").attr("href", "#");
        } else {
          $("#register_link2").attr("href", env['registerlinkURL']);
        }
      }

      // Configure registration link (/login REGISTER ACCOUNT)
      if (null != env['registerlinkURL'] && undefined != env['registerlinkURL']) {
        if (env['registerlinkURL'] == "") {
          $("#register_link3").attr("href", "#");
        } else {
          $("#register_link3").attr("href", env['registerlinkURL']);
        }
      }

      // searchLink (/homepage-search)
      if (null != env['searchLink'] && undefined != env['searchLink']) {
        if (env['searchLink'] == "") {
          $("#search_link").attr("href", "#");
        } else {
          $("#search_link").attr("href", env['searchLink']);
        }
      }

      // Paymentus (/paymentus)
      if (null != env['paymentusiframe'] && undefined != env['paymentusiframe']) {
        if (env['paymentusiframe'] !== '') {
          $("#paymentusiframe").attr("src", env['paymentusiframe'] + '?iframe=yes');
        }
      }

      // file and report a claim
      if (null != env['claimReport'] && undefined != env['claimReport']) {
        if (env['claimReport'] == "") {
          $("#report_claim").attr("href", "#");
        } else {
          $("#report_claim").attr("href", env['claimReport']);
        }
      }

      // search for a claim
      if (null != env['claimStatus'] && undefined != env['claimStatus']) {
        if (env['claimReport'] == "") {
          $("#claim_status").attr("href", "#");
        } else {
          $("#claim_status").attr("href", env['claimStatus']);
        }
      }

      // search for a feedback Button
      if (null != env['feedbackButtonLink'] && undefined != env['feedbackButtonLink']) {
        if (env['feedbackButtonLink'] !== '') {
          $("#yessurvey").attr("data-href", env['feedbackButtonLink']);
        }
      }

      // live chat environment
      if (null != env['liveChatEnv'] && undefined != env['liveChatEnv']) {
        $("#liveChatData").attr("url", env['liveChatEnv']);
      }

      // live chat environment
      if (null != env['LiveChatUrl'] && undefined != env['LiveChatUrl']) {
        $("#liveChatData").attr("prechaturl", env['LiveChatUrl']);
      }

      // live chat username
      if (null != env['liveChatName'] && undefined != env['liveChatName']) {
        $("#liveChatData").attr("username", env['liveChatName']);
      }

      // live chat password
      if (null != env['liveChatValue'] && undefined != env['liveChatValue']) {
        $("#liveChatData").attr("password", env['liveChatValue']);
      }

      // Configure 'pay bill' link on homepage-2 header
      $("a[href*='https://www.farmers.com/payments/']").each(function () {
        this.href = "https://" + x + ".farmers.com/payments/";
      });

      // Replace all hrefs to be the current environment
      var href_links = $(':regex(href,(w{3})\.farmers\.com)');
      href_links.each(function () {
        if ($(this).context !== undefined && typeof $(this).context.href !== 'undefined') {
          var parts = $(this).context.href.match(/((.*)w{3}\.)?(farmers.*)/);
          $(this).context.href = parts[2] + x + "." + parts[3];
        } else if ($(this).context !== undefined && $(this).context.getAttribute("href") != 'undefined') {
          var parts = $(this).context.getAttribute("href").match(/((.*)w{3}\.)?(farmers.*)/);
          $(this).context.setAttribute("href", parts[2] + x + "." + parts[3]);
        }
      });
      var action_links = $(':regex(action,(w{3})\.farmers\.com)');
      action_links.each(function () {
        if ($(this).context !== undefined && typeof $(this).context.action != 'undefined') {
          var parts = $(this).context.action.match(/((.*)w{3}\.)?(farmers.*)/);
          $(this).context.action = parts[2] + x + "." + parts[3];
        }
      });
      var data_mobile_action_links = $(':regex(data-mobile-action,(w{3})\.farmers\.com)');
      data_mobile_action_links.each(function () {
        if (typeof $(this).data('mobileAction') != 'undefined') {
          var parts = $(this).data('mobileAction').match(/((.*)w{3}\.)?(farmers.*)/);
          $(this).context.setAttribute('data-mobile-action', parts[2] + x + "." + parts[3]);
        }
      });
      var onclick_links = $(':regex(onclick,(w{3})\.farmers\.com)');
      onclick_links.each(function () {
        if (typeof $(this).context.getAttribute("onclick") != 'undefined') {
          var parts = $(this).context.getAttribute("onclick").match(/((.*)w{3}\.)?(farmers.*)/);
          $(this).context.setAttribute("onclick", parts[2] + x + "." + parts[3]);
        }
      });
      var value_links = $(':regex(value,(w{3})\.farmers\.com)');
      value_links.each(function () {
        if (typeof $(this).context.getAttribute("value") != 'undefined') {
          var parts = $(this).context.getAttribute("value").match(/((.*)w{3}\.)?(farmers.*)/);
          $(this).context.setAttribute("value", parts[2] + x + "." + parts[3]);
        }
      });
      var rte_links = $(':regex(_rte_href,(w{3})\.farmers\.com)');
      rte_links.each(function () {
        if (typeof $(this).context.getAttribute("_rte_href") != 'undefined') {
          var parts = $(this).context.getAttribute("_rte_href").match(/((.*)w{3}\.)?(farmers.*)/);
          $(this).context.setAttribute("_rte_href", parts[2] + x + "." + parts[3]);
        }
      });
      break;
    }
  }
});
!function (i) {
  "use strict";

  "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery);
}(function (i) {
  "use strict";

  var e = window.Slick || {};
  (e = function () {
    var e = 0;
    return function (t, o) {
      var s,
        n = this;
      n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(t),
        appendDots: i(t),
        arrows: !0,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function customPaging(e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: .35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3
      }, n.initials = {
        animating: !1,
        dragging: !1,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: !1,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: !1,
        slideOffset: 0,
        swipeLeft: null,
        swiping: !1,
        $list: null,
        touchObject: {},
        transformsEnabled: !1,
        unslicked: !1
      }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
    };
  }()).prototype.activateADA = function () {
    this.$slideTrack.find(".slick-active").attr({
      "aria-hidden": "false"
    }).find("a, input, button, select").attr({
      tabindex: "0"
    });
  }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
    var s = this;
    if ("boolean" == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;
    s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
      i(t).attr("data-slick-index", e);
    }), s.$slidesCache = s.$slides, s.reinit();
  }, e.prototype.animateHeight = function () {
    var i = this;
    if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.animate({
        height: e
      }, i.options.speed);
    }
  }, e.prototype.animateSlide = function (e, t) {
    var o = {},
      s = this;
    s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
      left: e
    }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
      top: e
    }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({
      animStart: s.currentLeft
    }).animate({
      animStart: e
    }, {
      duration: s.options.speed,
      easing: s.options.easing,
      step: function step(i) {
        i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o));
      },
      complete: function complete() {
        t && t.call();
      }
    })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
      s.disableTransition(), t.call();
    }, s.options.speed));
  }, e.prototype.getNavTarget = function () {
    var e = this,
      t = e.options.asNavFor;
    return t && null !== t && (t = i(t).not(e.$slider)), t;
  }, e.prototype.asNavFor = function (e) {
    var t = this.getNavTarget();
    null !== t && "object" == _typeof(t) && t.each(function () {
      var t = i(this).slick("getSlick");
      t.unslicked || t.slideHandler(e, !0);
    });
  }, e.prototype.applyTransition = function (i) {
    var e = this,
      t = {};
    !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.autoPlay = function () {
    var i = this;
    i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
  }, e.prototype.autoPlayClear = function () {
    var i = this;
    i.autoPlayTimer && clearInterval(i.autoPlayTimer);
  }, e.prototype.autoPlayIterator = function () {
    var i = this,
      e = i.currentSlide + i.options.slidesToScroll;
    i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e));
  }, e.prototype.buildArrows = function () {
    var e = this;
    !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
      "aria-disabled": "true",
      tabindex: "-1"
    }));
  }, e.prototype.buildDots = function () {
    var e,
      t,
      o = this;
    if (!0 === o.options.dots) {
      for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
      o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active");
    }
  }, e.prototype.buildOut = function () {
    var e = this;
    e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
      i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "");
    }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable");
  }, e.prototype.buildRows = function () {
    var i,
      e,
      t,
      o,
      s,
      n,
      r,
      l = this;
    if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
      for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
        var d = document.createElement("div");
        for (e = 0; e < l.options.rows; e++) {
          var a = document.createElement("div");
          for (t = 0; t < l.options.slidesPerRow; t++) {
            var c = i * r + (e * l.options.slidesPerRow + t);
            n.get(c) && a.appendChild(n.get(c));
          }
          d.appendChild(a);
        }
        o.appendChild(d);
      }
      l.$slider.empty().append(o), l.$slider.children().children().children().css({
        width: 100 / l.options.slidesPerRow + "%",
        display: "inline-block"
      });
    }
  }, e.prototype.checkResponsive = function (e, t) {
    var o,
      s,
      n,
      r = this,
      l = !1,
      d = r.$slider.width(),
      a = window.innerWidth || i(window).width();
    if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
      s = null;
      for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
      null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
    }
  }, e.prototype.changeSlide = function (e, t) {
    var o,
      s,
      n,
      r = this,
      l = i(e.currentTarget);
    switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
      case "previous":
        s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
        break;
      case "next":
        s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
        break;
      case "index":
        var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
        r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
        break;
      default:
        return;
    }
  }, e.prototype.checkNavigable = function (i) {
    var e, t;
    if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];else for (var o in e) {
      if (i < e[o]) {
        i = t;
        break;
      }
      t = e[o];
    }
    return i;
  }, e.prototype.cleanUpEvents = function () {
    var e = this;
    e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
  }, e.prototype.cleanUpSlideEvents = function () {
    var e = this;
    e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
  }, e.prototype.cleanUpRows = function () {
    var i,
      e = this;
    e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i));
  }, e.prototype.clickHandler = function (i) {
    !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
  }, e.prototype.destroy = function (e) {
    var t = this;
    t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
      i(this).attr("style", i(this).data("originalStyling"));
    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t]);
  }, e.prototype.disableTransition = function (i) {
    var e = this,
      t = {};
    t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.fadeSlide = function (i, e) {
    var t = this;
    !1 === t.cssTransitions ? (t.$slides.eq(i).css({
      zIndex: t.options.zIndex
    }), t.$slides.eq(i).animate({
      opacity: 1
    }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
      opacity: 1,
      zIndex: t.options.zIndex
    }), e && setTimeout(function () {
      t.disableTransition(i), e.call();
    }, t.options.speed));
  }, e.prototype.fadeSlideOut = function (i) {
    var e = this;
    !1 === e.cssTransitions ? e.$slides.eq(i).animate({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }));
  }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
    var e = this;
    null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
  }, e.prototype.focusHandler = function () {
    var e = this;
    e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
      t.stopImmediatePropagation();
      var o = i(this);
      setTimeout(function () {
        e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay());
      }, 0);
    });
  }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
    return this.currentSlide;
  }, e.prototype.getDotCount = function () {
    var i = this,
      e = 0,
      t = 0,
      o = 0;
    if (!0 === i.options.infinite) {
      if (i.slideCount <= i.options.slidesToShow) ++o;else for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
    } else if (!0 === i.options.centerMode) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
    return o - 1;
  }, e.prototype.getLeft = function (i) {
    var e,
      t,
      o,
      s,
      n = this,
      r = 0;
    return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e;
  }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
    return this.options[i];
  }, e.prototype.getNavigableIndexes = function () {
    var i,
      e = this,
      t = 0,
      o = 0,
      s = [];
    for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
    return s;
  }, e.prototype.getSlick = function () {
    return this;
  }, e.prototype.getSlideCount = function () {
    var e,
      t,
      o = this;
    return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
      if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1;
    }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll;
  }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
    this.changeSlide({
      data: {
        message: "index",
        index: parseInt(i)
      }
    }, e);
  }, e.prototype.init = function (e) {
    var t = this;
    i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
  }, e.prototype.initADA = function () {
    var e = this,
      t = Math.ceil(e.slideCount / e.options.slidesToShow),
      o = e.getNavigableIndexes().filter(function (i) {
        return i >= 0 && i < e.slideCount;
      });
    e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
      "aria-hidden": "true",
      tabindex: "-1"
    }).find("a, input, button, select").attr({
      tabindex: "-1"
    }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
      var s = o.indexOf(t);
      i(this).attr({
        role: "tabpanel",
        id: "slick-slide" + e.instanceUid + t,
        tabindex: -1
      }), -1 !== s && i(this).attr({
        "aria-describedby": "slick-slide-control" + e.instanceUid + s
      });
    }), e.$dots.attr("role", "tablist").find("li").each(function (s) {
      var n = o[s];
      i(this).attr({
        role: "presentation"
      }), i(this).find("button").first().attr({
        role: "tab",
        id: "slick-slide-control" + e.instanceUid + s,
        "aria-controls": "slick-slide" + e.instanceUid + n,
        "aria-label": s + 1 + " of " + t,
        "aria-selected": null,
        tabindex: "-1"
      });
    }).eq(e.currentSlide).find("button").attr({
      "aria-selected": "true",
      tabindex: "0"
    }).end());
    for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.$slides.eq(s).attr("tabindex", 0);
    e.activateADA();
  }, e.prototype.initArrowEvents = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
      message: "previous"
    }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {
      message: "next"
    }, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)));
  }, e.prototype.initDotEvents = function () {
    var e = this;
    !0 === e.options.dots && (i("li", e.$dots).on("click.slick", {
      message: "index"
    }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
  }, e.prototype.initSlideEvents = function () {
    var e = this;
    e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
  }, e.prototype.initializeEvents = function () {
    var e = this;
    e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
      action: "start"
    }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
      action: "move"
    }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
      action: "end"
    }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
      action: "end"
    }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition);
  }, e.prototype.initUI = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
  }, e.prototype.keyHandler = function (i) {
    var e = this;
    i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
      data: {
        message: !0 === e.options.rtl ? "next" : "previous"
      }
    }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
      data: {
        message: !0 === e.options.rtl ? "previous" : "next"
      }
    }));
  }, e.prototype.lazyLoad = function () {
    function e(e) {
      i("img[data-lazy]", e).each(function () {
        var e = i(this),
          t = i(this).attr("data-lazy"),
          o = i(this).attr("data-srcset"),
          s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
          r = document.createElement("img");
        r.onload = function () {
          e.animate({
            opacity: 0
          }, 100, function () {
            o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({
              opacity: 1
            }, 200, function () {
              e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
            }), n.$slider.trigger("lazyLoaded", [n, e, t]);
          });
        }, r.onerror = function () {
          e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t]);
        }, r.src = t;
      });
    }
    var t,
      o,
      s,
      n = this;
    if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad) for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++) r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++;
    e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow));
  }, e.prototype.loadSlider = function () {
    var i = this;
    i.setPosition(), i.$slideTrack.css({
      opacity: 1
    }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
  }, e.prototype.next = e.prototype.slickNext = function () {
    this.changeSlide({
      data: {
        message: "next"
      }
    });
  }, e.prototype.orientationChange = function () {
    var i = this;
    i.checkResponsive(), i.setPosition();
  }, e.prototype.pause = e.prototype.slickPause = function () {
    var i = this;
    i.autoPlayClear(), i.paused = !0;
  }, e.prototype.play = e.prototype.slickPlay = function () {
    var i = this;
    i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
  }, e.prototype.postSlide = function (e) {
    var t = this;
    t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
  }, e.prototype.prev = e.prototype.slickPrev = function () {
    this.changeSlide({
      data: {
        message: "previous"
      }
    });
  }, e.prototype.preventDefault = function (i) {
    i.preventDefault();
  }, e.prototype.progressiveLazyLoad = function (e) {
    e = e || 1;
    var t,
      o,
      s,
      n,
      r,
      l = this,
      d = i("img[data-lazy]", l.$slider);
    d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () {
      s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad();
    }, r.onerror = function () {
      e < 3 ? setTimeout(function () {
        l.progressiveLazyLoad(e + 1);
      }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad());
    }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l]);
  }, e.prototype.refresh = function (e) {
    var t,
      o,
      s = this;
    o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
      currentSlide: t
    }), s.init(), e || s.changeSlide({
      data: {
        message: "index",
        index: t
      }
    }, !1);
  }, e.prototype.registerBreakpoints = function () {
    var e,
      t,
      o,
      s = this,
      n = s.options.responsive || null;
    if ("array" === i.type(n) && n.length) {
      s.respondTo = s.options.respondTo || "window";
      for (e in n) if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
        for (t = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
        s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
      }
      s.breakpoints.sort(function (i, e) {
        return s.options.mobileFirst ? i - e : e - i;
      });
    }
  }, e.prototype.reinit = function () {
    var e = this;
    e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e]);
  }, e.prototype.resize = function () {
    var e = this;
    i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
      e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
    }, 50));
  }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
    var o = this;
    if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;
    o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit();
  }, e.prototype.setCSS = function (i) {
    var e,
      t,
      o = this,
      s = {};
    !0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)));
  }, e.prototype.setDimensions = function () {
    var i = this;
    !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
      padding: "0px " + i.options.centerPadding
    }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({
      padding: i.options.centerPadding + " 0px"
    })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
    var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
    !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
  }, e.prototype.setFade = function () {
    var e,
      t = this;
    t.$slides.each(function (o, s) {
      e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({
        position: "relative",
        right: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      }) : i(s).css({
        position: "relative",
        left: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      });
    }), t.$slides.eq(t.currentSlide).css({
      zIndex: t.options.zIndex - 1,
      opacity: 1
    });
  }, e.prototype.setHeight = function () {
    var i = this;
    if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.css("height", e);
    }
  }, e.prototype.setOption = e.prototype.slickSetOption = function () {
    var e,
      t,
      o,
      s,
      n,
      r = this,
      l = !1;
    if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s;else if ("multiple" === n) i.each(o, function (i, e) {
      r.options[i] = e;
    });else if ("responsive" === n) for (t in s) if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
      for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
      r.options.responsive.push(s[t]);
    }
    l && (r.unload(), r.reinit());
  }, e.prototype.setPosition = function () {
    var i = this;
    i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]);
  }, e.prototype.setProps = function () {
    var i = this,
      e = document.body.style;
    i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType;
  }, e.prototype.setSlideClasses = function (i) {
    var e,
      t,
      o,
      s,
      n = this;
    if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) {
      var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
      e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center");
    } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
    "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad();
  }, e.prototype.setupInfinite = function () {
    var e,
      t,
      o,
      s = this;
    if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
      for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
      for (e = 0; e < o + s.slideCount; e += 1) t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
      s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
        i(this).attr("id", "");
      });
    }
  }, e.prototype.interrupt = function (i) {
    var e = this;
    i || e.autoPlay(), e.interrupted = i;
  }, e.prototype.selectHandler = function (e) {
    var t = this,
      o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
      s = parseInt(o.attr("data-slick-index"));
    s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s);
  }, e.prototype.slideHandler = function (i, e, t) {
    var o,
      s,
      n,
      r,
      l,
      d = null,
      a = this;
    if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i)) if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o));else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o));else {
      if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
        a.postSlide(s);
      })) : a.postSlide(s), void a.animateHeight();
      !0 !== t ? a.animateSlide(d, function () {
        a.postSlide(s);
      }) : a.postSlide(s);
    }
  }, e.prototype.startLoad = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading");
  }, e.prototype.swipeDirection = function () {
    var i,
      e,
      t,
      o,
      s = this;
    return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical";
  }, e.prototype.swipeEnd = function (i) {
    var e,
      t,
      o = this;
    if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
    if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
    if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
      switch (t = o.swipeDirection()) {
        case "left":
        case "down":
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
          break;
        case "right":
        case "up":
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;
      }
      "vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]));
    } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
  }, e.prototype.swipeHandler = function (i) {
    var e = this;
    if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
      case "start":
        e.swipeStart(i);
        break;
      case "move":
        e.swipeMove(i);
        break;
      case "end":
        e.swipeEnd(i);
    }
  }, e.prototype.swipeMove = function (i) {
    var e,
      t,
      o,
      s,
      n,
      r,
      l = this;
    return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))));
  }, e.prototype.swipeStart = function (i) {
    var e,
      t = this;
    if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;
    void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0;
  }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
    var i = this;
    null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
  }, e.prototype.unload = function () {
    var e = this;
    i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
  }, e.prototype.unslick = function (i) {
    var e = this;
    e.$slider.trigger("unslick", [e, i]), e.destroy();
  }, e.prototype.updateArrows = function () {
    var i = this;
    Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
  }, e.prototype.updateDots = function () {
    var i = this;
    null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"));
  }, e.prototype.visibility = function () {
    var i = this;
    i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
  }, i.fn.slick = function () {
    var i,
      t,
      o = this,
      s = arguments[0],
      n = Array.prototype.slice.call(arguments, 1),
      r = o.length;
    for (i = 0; i < r; i++) if ("object" == _typeof(s) || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
    return o;
  };
});
!function (i) {
  "use strict";

  "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery);
}(function (i) {
  "use strict";

  var e = window.Slick || {};
  (e = function () {
    var e = 0;
    return function (t, o) {
      var s,
        n = this;
      n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(t),
        appendDots: i(t),
        arrows: !0,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function customPaging(e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: .35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3
      }, n.initials = {
        animating: !1,
        dragging: !1,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: !1,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: !1,
        slideOffset: 0,
        swipeLeft: null,
        swiping: !1,
        $list: null,
        touchObject: {},
        transformsEnabled: !1,
        unslicked: !1
      }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
    };
  }()).prototype.activateADA = function () {
    this.$slideTrack.find(".slick-active").attr({
      "aria-hidden": "false"
    }).find("a, input, button, select").attr({
      tabindex: "0"
    });
  }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
    var s = this;
    if ("boolean" == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;
    s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
      i(t).attr("data-slick-index", e);
    }), s.$slidesCache = s.$slides, s.reinit();
  }, e.prototype.animateHeight = function () {
    var i = this;
    if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.animate({
        height: e
      }, i.options.speed);
    }
  }, e.prototype.animateSlide = function (e, t) {
    var o = {},
      s = this;
    s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
      left: e
    }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
      top: e
    }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({
      animStart: s.currentLeft
    }).animate({
      animStart: e
    }, {
      duration: s.options.speed,
      easing: s.options.easing,
      step: function step(i) {
        i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o));
      },
      complete: function complete() {
        t && t.call();
      }
    })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
      s.disableTransition(), t.call();
    }, s.options.speed));
  }, e.prototype.getNavTarget = function () {
    var e = this,
      t = e.options.asNavFor;
    return t && null !== t && (t = i(t).not(e.$slider)), t;
  }, e.prototype.asNavFor = function (e) {
    var t = this.getNavTarget();
    null !== t && "object" == _typeof(t) && t.each(function () {
      var t = i(this).slick("getSlick");
      t.unslicked || t.slideHandler(e, !0);
    });
  }, e.prototype.applyTransition = function (i) {
    var e = this,
      t = {};
    !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.autoPlay = function () {
    var i = this;
    i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
  }, e.prototype.autoPlayClear = function () {
    var i = this;
    i.autoPlayTimer && clearInterval(i.autoPlayTimer);
  }, e.prototype.autoPlayIterator = function () {
    var i = this,
      e = i.currentSlide + i.options.slidesToScroll;
    i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e));
  }, e.prototype.buildArrows = function () {
    var e = this;
    !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
      "aria-disabled": "true",
      tabindex: "-1"
    }));
  }, e.prototype.buildDots = function () {
    var e,
      t,
      o = this;
    if (!0 === o.options.dots) {
      for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
      o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active");
    }
  }, e.prototype.buildOut = function () {
    var e = this;
    e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
      i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "");
    }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable");
  }, e.prototype.buildRows = function () {
    var i,
      e,
      t,
      o,
      s,
      n,
      r,
      l = this;
    if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
      for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
        var d = document.createElement("div");
        for (e = 0; e < l.options.rows; e++) {
          var a = document.createElement("div");
          for (t = 0; t < l.options.slidesPerRow; t++) {
            var c = i * r + (e * l.options.slidesPerRow + t);
            n.get(c) && a.appendChild(n.get(c));
          }
          d.appendChild(a);
        }
        o.appendChild(d);
      }
      l.$slider.empty().append(o), l.$slider.children().children().children().css({
        width: 100 / l.options.slidesPerRow + "%",
        display: "inline-block"
      });
    }
  }, e.prototype.checkResponsive = function (e, t) {
    var o,
      s,
      n,
      r = this,
      l = !1,
      d = r.$slider.width(),
      a = window.innerWidth || i(window).width();
    if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
      s = null;
      for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
      null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
    }
  }, e.prototype.changeSlide = function (e, t) {
    var o,
      s,
      n,
      r = this,
      l = i(e.currentTarget);
    switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
      case "previous":
        s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
        break;
      case "next":
        s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
        break;
      case "index":
        var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
        r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
        break;
      default:
        return;
    }
  }, e.prototype.checkNavigable = function (i) {
    var e, t;
    if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];else for (var o in e) {
      if (i < e[o]) {
        i = t;
        break;
      }
      t = e[o];
    }
    return i;
  }, e.prototype.cleanUpEvents = function () {
    var e = this;
    e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
  }, e.prototype.cleanUpSlideEvents = function () {
    var e = this;
    e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
  }, e.prototype.cleanUpRows = function () {
    var i,
      e = this;
    e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i));
  }, e.prototype.clickHandler = function (i) {
    !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
  }, e.prototype.destroy = function (e) {
    var t = this;
    t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
      i(this).attr("style", i(this).data("originalStyling"));
    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t]);
  }, e.prototype.disableTransition = function (i) {
    var e = this,
      t = {};
    t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.fadeSlide = function (i, e) {
    var t = this;
    !1 === t.cssTransitions ? (t.$slides.eq(i).css({
      zIndex: t.options.zIndex
    }), t.$slides.eq(i).animate({
      opacity: 1
    }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
      opacity: 1,
      zIndex: t.options.zIndex
    }), e && setTimeout(function () {
      t.disableTransition(i), e.call();
    }, t.options.speed));
  }, e.prototype.fadeSlideOut = function (i) {
    var e = this;
    !1 === e.cssTransitions ? e.$slides.eq(i).animate({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }));
  }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
    var e = this;
    null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
  }, e.prototype.focusHandler = function () {
    var e = this;
    e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
      t.stopImmediatePropagation();
      var o = i(this);
      setTimeout(function () {
        e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay());
      }, 0);
    });
  }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
    return this.currentSlide;
  }, e.prototype.getDotCount = function () {
    var i = this,
      e = 0,
      t = 0,
      o = 0;
    if (!0 === i.options.infinite) {
      if (i.slideCount <= i.options.slidesToShow) ++o;else for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
    } else if (!0 === i.options.centerMode) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
    return o - 1;
  }, e.prototype.getLeft = function (i) {
    var e,
      t,
      o,
      s,
      n = this,
      r = 0;
    return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e;
  }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
    return this.options[i];
  }, e.prototype.getNavigableIndexes = function () {
    var i,
      e = this,
      t = 0,
      o = 0,
      s = [];
    for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
    return s;
  }, e.prototype.getSlick = function () {
    return this;
  }, e.prototype.getSlideCount = function () {
    var e,
      t,
      o = this;
    return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
      if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1;
    }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll;
  }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
    this.changeSlide({
      data: {
        message: "index",
        index: parseInt(i)
      }
    }, e);
  }, e.prototype.init = function (e) {
    var t = this;
    i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
  }, e.prototype.initADA = function () {
    var e = this,
      t = Math.ceil(e.slideCount / e.options.slidesToShow),
      o = e.getNavigableIndexes().filter(function (i) {
        return i >= 0 && i < e.slideCount;
      });
    e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
      "aria-hidden": "true",
      tabindex: "-1"
    }).find("a, input, button, select").attr({
      tabindex: "-1"
    }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
      var s = o.indexOf(t);
      i(this).attr({
        role: "tabpanel",
        id: "slick-slide" + e.instanceUid + t,
        tabindex: -1
      }), -1 !== s && i(this).attr({
        "aria-describedby": "slick-slide-control" + e.instanceUid + s
      });
    }), e.$dots.attr("role", "tablist").find("li").each(function (s) {
      var n = o[s];
      i(this).attr({
        role: "presentation"
      }), i(this).find("button").first().attr({
        role: "tab",
        id: "slick-slide-control" + e.instanceUid + s,
        "aria-controls": "slick-slide" + e.instanceUid + n,
        "aria-label": s + 1 + " of " + t,
        "aria-selected": null,
        tabindex: "-1"
      });
    }).eq(e.currentSlide).find("button").attr({
      "aria-selected": "true",
      tabindex: "0"
    }).end());
    for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.$slides.eq(s).attr("tabindex", 0);
    e.activateADA();
  }, e.prototype.initArrowEvents = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
      message: "previous"
    }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {
      message: "next"
    }, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)));
  }, e.prototype.initDotEvents = function () {
    var e = this;
    !0 === e.options.dots && (i("li", e.$dots).on("click.slick", {
      message: "index"
    }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
  }, e.prototype.initSlideEvents = function () {
    var e = this;
    e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
  }, e.prototype.initializeEvents = function () {
    var e = this;
    e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
      action: "start"
    }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
      action: "move"
    }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
      action: "end"
    }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
      action: "end"
    }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition);
  }, e.prototype.initUI = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
  }, e.prototype.keyHandler = function (i) {
    var e = this;
    i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
      data: {
        message: !0 === e.options.rtl ? "next" : "previous"
      }
    }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
      data: {
        message: !0 === e.options.rtl ? "previous" : "next"
      }
    }));
  }, e.prototype.lazyLoad = function () {
    function e(e) {
      i("img[data-lazy]", e).each(function () {
        var e = i(this),
          t = i(this).attr("data-lazy"),
          o = i(this).attr("data-srcset"),
          s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
          r = document.createElement("img");
        r.onload = function () {
          e.animate({
            opacity: 0
          }, 100, function () {
            o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({
              opacity: 1
            }, 200, function () {
              e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
            }), n.$slider.trigger("lazyLoaded", [n, e, t]);
          });
        }, r.onerror = function () {
          e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t]);
        }, r.src = t;
      });
    }
    var t,
      o,
      s,
      n = this;
    if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad) for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++) r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++;
    e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow));
  }, e.prototype.loadSlider = function () {
    var i = this;
    i.setPosition(), i.$slideTrack.css({
      opacity: 1
    }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
  }, e.prototype.next = e.prototype.slickNext = function () {
    this.changeSlide({
      data: {
        message: "next"
      }
    });
  }, e.prototype.orientationChange = function () {
    var i = this;
    i.checkResponsive(), i.setPosition();
  }, e.prototype.pause = e.prototype.slickPause = function () {
    var i = this;
    i.autoPlayClear(), i.paused = !0;
  }, e.prototype.play = e.prototype.slickPlay = function () {
    var i = this;
    i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
  }, e.prototype.postSlide = function (e) {
    var t = this;
    t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
  }, e.prototype.prev = e.prototype.slickPrev = function () {
    this.changeSlide({
      data: {
        message: "previous"
      }
    });
  }, e.prototype.preventDefault = function (i) {
    i.preventDefault();
  }, e.prototype.progressiveLazyLoad = function (e) {
    e = e || 1;
    var t,
      o,
      s,
      n,
      r,
      l = this,
      d = i("img[data-lazy]", l.$slider);
    d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () {
      s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad();
    }, r.onerror = function () {
      e < 3 ? setTimeout(function () {
        l.progressiveLazyLoad(e + 1);
      }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad());
    }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l]);
  }, e.prototype.refresh = function (e) {
    var t,
      o,
      s = this;
    o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
      currentSlide: t
    }), s.init(), e || s.changeSlide({
      data: {
        message: "index",
        index: t
      }
    }, !1);
  }, e.prototype.registerBreakpoints = function () {
    var e,
      t,
      o,
      s = this,
      n = s.options.responsive || null;
    if ("array" === i.type(n) && n.length) {
      s.respondTo = s.options.respondTo || "window";
      for (e in n) if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
        for (t = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
        s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
      }
      s.breakpoints.sort(function (i, e) {
        return s.options.mobileFirst ? i - e : e - i;
      });
    }
  }, e.prototype.reinit = function () {
    var e = this;
    e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e]);
  }, e.prototype.resize = function () {
    var e = this;
    i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
      e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
    }, 50));
  }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
    var o = this;
    if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;
    o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit();
  }, e.prototype.setCSS = function (i) {
    var e,
      t,
      o = this,
      s = {};
    !0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)));
  }, e.prototype.setDimensions = function () {
    var i = this;
    !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
      padding: "0px " + i.options.centerPadding
    }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({
      padding: i.options.centerPadding + " 0px"
    })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
    var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
    !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
  }, e.prototype.setFade = function () {
    var e,
      t = this;
    t.$slides.each(function (o, s) {
      e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({
        position: "relative",
        right: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      }) : i(s).css({
        position: "relative",
        left: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      });
    }), t.$slides.eq(t.currentSlide).css({
      zIndex: t.options.zIndex - 1,
      opacity: 1
    });
  }, e.prototype.setHeight = function () {
    var i = this;
    if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.css("height", e);
    }
  }, e.prototype.setOption = e.prototype.slickSetOption = function () {
    var e,
      t,
      o,
      s,
      n,
      r = this,
      l = !1;
    if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s;else if ("multiple" === n) i.each(o, function (i, e) {
      r.options[i] = e;
    });else if ("responsive" === n) for (t in s) if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
      for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
      r.options.responsive.push(s[t]);
    }
    l && (r.unload(), r.reinit());
  }, e.prototype.setPosition = function () {
    var i = this;
    i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]);
  }, e.prototype.setProps = function () {
    var i = this,
      e = document.body.style;
    i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType;
  }, e.prototype.setSlideClasses = function (i) {
    var e,
      t,
      o,
      s,
      n = this;
    if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) {
      var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
      e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center");
    } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
    "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad();
  }, e.prototype.setupInfinite = function () {
    var e,
      t,
      o,
      s = this;
    if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
      for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
      for (e = 0; e < o + s.slideCount; e += 1) t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
      s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
        i(this).attr("id", "");
      });
    }
  }, e.prototype.interrupt = function (i) {
    var e = this;
    i || e.autoPlay(), e.interrupted = i;
  }, e.prototype.selectHandler = function (e) {
    var t = this,
      o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
      s = parseInt(o.attr("data-slick-index"));
    s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s);
  }, e.prototype.slideHandler = function (i, e, t) {
    var o,
      s,
      n,
      r,
      l,
      d = null,
      a = this;
    if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i)) if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o));else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o));else {
      if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
        a.postSlide(s);
      })) : a.postSlide(s), void a.animateHeight();
      !0 !== t ? a.animateSlide(d, function () {
        a.postSlide(s);
      }) : a.postSlide(s);
    }
  }, e.prototype.startLoad = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading");
  }, e.prototype.swipeDirection = function () {
    var i,
      e,
      t,
      o,
      s = this;
    return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical";
  }, e.prototype.swipeEnd = function (i) {
    var e,
      t,
      o = this;
    if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
    if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
    if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
      switch (t = o.swipeDirection()) {
        case "left":
        case "down":
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
          break;
        case "right":
        case "up":
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;
      }
      "vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]));
    } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
  }, e.prototype.swipeHandler = function (i) {
    var e = this;
    if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
      case "start":
        e.swipeStart(i);
        break;
      case "move":
        e.swipeMove(i);
        break;
      case "end":
        e.swipeEnd(i);
    }
  }, e.prototype.swipeMove = function (i) {
    var e,
      t,
      o,
      s,
      n,
      r,
      l = this;
    return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))));
  }, e.prototype.swipeStart = function (i) {
    var e,
      t = this;
    if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;
    void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0;
  }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
    var i = this;
    null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
  }, e.prototype.unload = function () {
    var e = this;
    i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
  }, e.prototype.unslick = function (i) {
    var e = this;
    e.$slider.trigger("unslick", [e, i]), e.destroy();
  }, e.prototype.updateArrows = function () {
    var i = this;
    Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
  }, e.prototype.updateDots = function () {
    var i = this;
    null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"));
  }, e.prototype.visibility = function () {
    var i = this;
    i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
  }, i.fn.slick = function () {
    var i,
      t,
      o = this,
      s = arguments[0],
      n = Array.prototype.slice.call(arguments, 1),
      r = o.length;
    for (i = 0; i < r; i++) if ("object" == _typeof(s) || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
    return o;
  };
});
var fatFooter = function () {
  'use strict';

  // Initialize the component
  function _initialize(footerContainer) {
    var expandButton = footerContainer.find('.expand-button'),
      win = $(window);

    // Shows a section on the fat footer, updates accessibility properties
    function _showSection(sectionContainer) {
      sectionContainer.addClass('is-open');
      sectionContainer.find('.expand-button').attr('aria-expanded', 'true');
      sectionContainer.find('.expand-button .fa').removeClass('fa-angle-down').addClass('fa-angle-up');
      sectionContainer.find('.section-links').attr('aria-hidden', 'false');
    }

    // Hide a section on the fat footer, updates accessibility properties
    function _hideSection(sectionContainer) {
      sectionContainer.removeClass('is-open');
      sectionContainer.find('.expand-button').attr('aria-expanded', 'false');
      sectionContainer.find('.expand-button .fa').removeClass('fa-angle-up').addClass('fa-angle-down');
      sectionContainer.find('.section-links').attr('aria-hidden', 'true');
    }

    /*
        Event listeners
    */

    // Expand or collapse a section on the mobile and tablet views
    function _toggleSection(e) {
      var element = $(e.currentTarget),
        sectionContainer = element.closest('.list-section'),
        otherOpenSection;
      if (sectionContainer.hasClass('is-open')) {
        _hideSection(sectionContainer);
      } else {
        otherOpenSection = footerContainer.find('.is-open');
        if (otherOpenSection.length > 0) {
          _hideSection(otherOpenSection);
        }
        _showSection(sectionContainer);
      }
    }

    // On dektop all the links should be visible for screen reasers
    function _setDesktop() {
      footerContainer.find('.section-links').attr('aria-hidden', false);
    }

    // Hide and show elements properly for screen readers in mobile and tablet
    function _setMobile() {
      footerContainer.find('.list-section:not(.is-open) .section-links').attr('aria-hidden', true);
    }

    // Check for changes on the viewport
    function _checkScreen() {
      if (win.width() >= 1024) {
        _setDesktop();
      } else {
        _setMobile();
      }
    }
    function _attachEvents() {
      expandButton.on('click', _toggleSection);
      win.on('resize', _checkScreen);
    }
    function _initialize() {
      if (win.width() >= 1024) {
        _setDesktop();
      }
    }
    _attachEvents();
    _initialize();
  }

  // Public methods
  function init() {
    var fatFooter = $('.footer:not([data-component-state="initialized"])');
    if (fatFooter) {
      fatFooter.each(function () {
        _initialize($(this));
        $(this).attr('data-component-state', 'initialized');
      });
    }
  }
  return {
    init: init
  };
}();
$(document).ready(fatFooter.init);
//temporary fix for link appending an extra only to this specific link and in this spefific page
// we only check property to match the our first href and then we will adjust with a new href

$("a[href='/content/falcon/en/index/learn/insurance-questions/comprehensive-insurance-and-collision-coveragee']").prop('href', '/content/falcon/en/index/learn/insurance-questions/comprehensive-insurance-and-collision-coverage');
$(document).ready(function () {
  if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    $(".LFE-top").css("padding-top", "0.3%");
  }
});
$(function () {
  if ($('.scroll-wrapper').length) {
    $(".scroll-wrapper").slice(0, 8).show();
    $(window).scroll(function (e) {
      var hidden = $('.hidden-tile');
      if (hidden.length) {
        var hT = hidden.offset().top,
          hH = hidden.outerHeight(),
          wH = $(window).height(),
          wS = $(this).scrollTop();
        if (wS > hT + hH - wH && hT > wS && wS + wH > hT + hH) {
          e.preventDefault();
          $(".scroll-wrapper:hidden").slice(0).fadeIn(2000).slideDown();
          $(window).off('scroll');
        }
      }
    });
  }
  if ($('div.categorytile').length) {
    var pageTitle = $('.categorytile .tile-container h1').text();
    $(document).prop('title', pageTitle);
  }
});
if ($(".rich-text.farmers_blue_white")[0]) {
  $(".rich-text.farmers_blue_white").parent().css("background", "#003087");
}
$(document).ready(function () {
  var d = new Date();
  var utc = d.getTime() + d.getTimezoneOffset() * 60000;
  //utc offset
  var offset = "-5";
  var nd = new Date(utc + 3600000 * offset);
  var hour = nd.getHours();
  var minutes = nd.getMinutes();
  //military time
  if (hour === 8 && minutes >= 30 || hour > 8 && hour < 22) {
    $('.uptime').show();
    $('.downtime').hide();
  } else {
    $('.downtime').show();
    $('.uptime').hide();
  }
  var firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
  var currentMonth = firstDay.toLocaleString('default', {
    month: 'long'
  });
  var currentYear = firstDay.toLocaleString('default', {
    year: 'numeric'
  });
  var firstDate = currentMonth + ' 1, ' + currentYear;
  $('.startmonth').text(firstDate);
  var lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  lastDay = lastDay.toLocaleString('default', {
    day: '2-digit'
  });
  var LastDate = currentMonth + ' ' + lastDay + ', ' + currentYear;
  $('.endmonth').text(LastDate);
  var lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 1);
  var nextMonth = lastDay.toLocaleString('default', {
    month: 'long'
  });
  var noOfdays = new Date(currentYear, d.getMonth(), 0).getDate();
  var nextMonthLastDate = nextMonth + ' ' + noOfdays + ', ' + currentYear;
  $('.nextmonthlast').text(nextMonthLastDate);
  $('.nextMon8').text(nextMonth + ' 8' + ', ' + currentYear);
  $('.nextMon16').text(nextMonth + ' 16' + ', ' + currentYear);
});
$(document).ready(function () {
  var expDouble = /[\“\”]/gm,
    expSingle = /[\']/gm;
  $('.protip .tip-image').each(function () {
    if (_typeof($(this).attr('alt')) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) || $(this).attr('alt') === false) {
      $(this).attr('alt', "");
    }
  });
  $('.protip .tip-text').each(function () {
    $(this).innerHTML = $(this).val().replace(expSingle, '\’');
  });
});
window.onscroll = function () {
  scrollFunction();
};
function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    $('.scrolltop').show();
  } else {
    $('.scrolltop').hide();
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
$(document).ready(function () {
  $('.FarmersTestImage').each(function () {
    if (_typeof($(this).attr('alt')) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) || $(this).attr('alt') === false) {
      $(this).attr('alt', "");
    }
  });
});
$(document).ready(function () {
  $('.assetCarousel').first().addClass("active").attr('aria-hidden', 'false');
  $('.thumbCarousel').first().addClass("active").attr({
    'aria-hidden': 'false',
    'aria-selected': 'true'
  });
  $('.carousel-control-next').click(function () {
    $('.video-head').trigger('pause');
    if ($("body").hasClass("ipad")) {
      $('#lfeCarousel').carousel();
      slidBinding();
    }
    $('#lfeCarousel').carousel('cycle');
  });
  $('.carousel-control-prev').click(function () {
    $('.video-head').trigger('pause');
    if ($("body").hasClass("ipad")) {
      $('#lfeCarousel').carousel();
      slidBinding();
    }
    $('#lfeCarousel').carousel('cycle');
  });
  $('#thumbnailCarousel').on('slid.bs.carousel', function () {
    $('.thumbCarousel').each(function () {
      if ($(this).hasClass('active')) {
        $(this).attr({
          'aria-hidden': 'false',
          'aria-selected': 'true'
        });
      } else {
        $(this).attr({
          'aria-hidden': 'true',
          'aria-selected': 'false'
        });
      }
    });
  });
  $('#lfeCarousel .carousel-inner .assetCarousel').each(function (index) {
    var itemIndex = index + 1;
    $(this).find("> img").attr('alt', 'slide-' + itemIndex);
  });
  slidBinding();
  captionDisplay();
});
function captionDisplay() {
  $('.lfe-cartext-wrapper .carouselText:first-child').removeClass('hidden');
  $('#lfeCarousel').on('slid.bs.carousel', function () {
    var xyz;
    $('#lfeCarousel .carousel-inner .assetCarousel').each(function () {
      if ($(this).hasClass('active')) {
        var a = $(this).attr('id');
        var splitStrings = a.split('-');
        var index = splitStrings[1];
        xyz = index;
        $(this).attr('aria-hidden', 'false');
      } else {
        $(this).attr('aria-hidden', 'true');
      }
    });
    $('.lfe-cartext-wrapper .carouselText').each(function () {
      if ($(this).attr('id') != "cap-" + xyz) {
        $(this).addClass('hidden');
        $(this).attr('aria-hidden', 'true');
      } else {
        $(this).removeClass('hidden');
        $(this).attr('aria-hidden', 'false');
      }
    });
  });
}
function slidBinding() {
  $('#lfeCarousel').on('slid.bs.carousel', function () {
    var obj = $('.carousel-inner').find('.active');
    var obj1 = obj.find('video');
    obj1.off("play").on("play", function () {
      if ($("body").hasClass("ipad")) {
        $('#lfeCarousel').carousel('dispose');
        return;
      }
      $('#lfeCarousel').carousel('pause');
    });
    obj1.off("pause").on("pause", function () {
      if ($("body").hasClass("ipad")) {
        $('#lfeCarousel').carousel();
        slidBinding();
      }
      $('#lfeCarousel').carousel('cycle');
    });
  });
}
$(window).on('load', function () {
  $('#thumbnailCarousel .carousel-item.thumbCarousel').each(function () {
    if (!($(this).children().length > 0)) {
      $(this).remove();
    }
  });
});
$(document).ready(function () {
  var handleRightRailBehavior = function handleRightRailBehavior(frameworkElement) {
    var rightRailElement = frameworkElement.find('.right-rail');
    var navHeight;
    var frameworkOffsetTop;
    var frameworkHeight;
    var rightRailHeight;
    var upperThreshold;
    var lowerThreshold;
    var windowResizeTimer;
    var breakpointSmall = 768; // should equal the pixel value of @breakpoint-small as defined in the CSS
    var rightrailwidth = frameworkElement.find('.right-rail').width();
    var rightrailRightMargin = 0;
    if (frameworkElement.find(".right-rail-content").css("margin-left") !== undefined) {
      rightrailRightMargin = parseInt(frameworkElement.find(".right-rail-content").css("margin-left").replace("px", ""));
    }
    var setThresholds = function setThresholds() {
      navHeight = 74; // NOTE: this selector should be replaced with selector(s) for the real sticky nav!
      frameworkOffsetTop = frameworkElement.offset().top;
      frameworkHeight = frameworkElement.outerHeight(true); // include margin
      rightRailHeight = rightRailElement.outerHeight(true); // include margin
      upperThreshold = frameworkOffsetTop - navHeight;
      lowerThreshold = frameworkOffsetTop + frameworkHeight - rightRailHeight - navHeight;
    };

    // update right rail position on window resize (only if window resize hasn't fired in the last 300 ms)
    $(window).resize(function () {
      clearTimeout(windowResizeTimer);
      windowResizeTimer = setTimeout(function () {
        if ($(window).outerWidth() < breakpointSmall) {
          // reset right rail positioning (stacked below left column content) on mobile
          rightRailElement.css({
            'top': 'inherit',
            'bottom': 'inherit'
          });
        }
        updateRightRailPosition();
      }, 300);
      //Removing inline styles on resize.
      $(".right-rail").removeAttr("style");
    });
    var updateRightRailPosition = function updateRightRailPosition() {
      if ($(window).outerWidth() < breakpointSmall) {
        return; // no sticky behavior on mobile
      }
      setThresholds(); // reset thresholds before determining the appropriate position for the right rail
      var currentPosition = $(window).scrollTop();
      if (currentPosition + 24 > upperThreshold && currentPosition + 53 < lowerThreshold) {
        var leftmargin = frameworkElement.find('.right-rail').offset().left;
        // current scroll position is between upper & lower thresholds. make the right rail "hover" in place while scrolling.
        rightRailElement.css({
          'top': 99 + 'px',
          //80px
          'position': 'fixed',
          'left': leftmargin,
          'bottom': 'inherit',
          'width': rightrailwidth
        });
      } else if (currentPosition + 53 >= lowerThreshold) {
        // current scroll position is beyond lowerThreshold (lower on the page). fix right rail to bottom and return to "normal" scrolling behavior.
        rightRailElement.css({
          'top': 'inherit',
          'position': 'absolute',
          'left': 0,
          'bottom': 0,
          'width': rightrailwidth
        });
      } else if (currentPosition + 24 <= upperThreshold) {
        // current scroll position is before upperThreshold (higher on the page). fix right rail to top and return to "normal" scrolling behavior.
        rightRailElement.css({
          'top': 0,
          'position': 'absolute',
          'left': 0,
          'bottom': 'inherit',
          'width': rightrailwidth
        });
      }
    };
    updateRightRailPosition(); // set right rail position on init

    if (!frameworkElement.hasClass('avoidScroll')) {
      $(window).on('scroll', updateRightRailPosition);
    }
    $(window).on('resize', updateRightRailPosition);
  };

  // Find all right-rail-framework elements on the page and apply scrolling behavior to each
  var rightRailFrameworkElements = $('.right-rail-framework');
  for (var i = 0; i < rightRailFrameworkElements.length; i++) {
    var element = rightRailFrameworkElements[i];
    handleRightRailBehavior($(element));
  }
  var $window = $(window),
    largerDisplayClass = $('.rightrail').find('.large-monitor');
  function checkWidth() {
    var width = $window.width();
    if (width >= 2500) {
      var $x = width / 200;
      $('.rightrail').css('margin-top', $x + "%");
    } else if (width >= 2000 && width < 2500) {
      $x = width / 300;
      $('.rightrail').css('margin-top', $x + "%");
    } else if (width < 2000) {
      $('.rightrail').css('margin-top', "");
      $('.right-rail-framework').css('margin-top', '30px');
    }
  }
  if (largerDisplayClass.length > 0) {
    checkWidth();
    $(window).resize(checkWidth);
  }
});
$(document).ready(function () {
  $('.tile-list .imageBox img').each(function () {
    if (_typeof($(this).attr('alt')) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) || $(this).attr('alt') === false) {
      $(this).attr('alt', "");
    }
  });
});
var blueTileList = function () {
  'use strict';

  // Initialize the component
  function _initialize(element) {
    // make the cards have equal height
    function _equalHeight() {
      var containers = element.find('.contetntBoxPadding'),
        elemsHeight = 0;
      $(containers).removeAttr('style');
      if (window.outerWidth >= 1024) {
        containers.each(function () {
          var elem = $(this);
          if (elem.outerHeight() > elemsHeight) {
            elemsHeight = elem.outerHeight();
          }
        });
        containers.each(function () {
          var elem = $(this);
          elem.height(elemsHeight);
        });
      }
    }
    function _attachEvents() {
      $(window).on('resize', _equalHeight);
    }
    _equalHeight();
    _attachEvents();
  }

  // Public methods
  function init() {
    var blueTileLists = $('.tile-list.theme-blue:not([data-component-state="initialized"])');
    if (blueTileLists) {
      blueTileLists.each(function () {
        _initialize($(this));
        $(this).attr('data-component-state', 'initialized');
      });
    }
  }
  return {
    init: init
  };
}();
$(document).ready(blueTileList.init);
var transcript = function () {
  'use strict';

  // Initialize the component
  function _initialize(element) {
    function _openPopup(event) {
      event.preventDefault();
      var path = element.attr('href');
      window.open(path, 'popup', 'width=600,height=600');
    }
    function _attachEvents() {
      element.on('click', _openPopup);
    }
    _attachEvents();
  }

  // Public methods
  function init() {
    var transcripts = $('a.transcript:not([data-component-state="initialized"])');
    if (transcripts) {
      transcripts.each(function () {
        _initialize($(this));
        $(this).attr('data-component-state', 'initialized');
      });
    }
  }
  return {
    init: init
  };
}();
$(document).ready(transcript.init);
!function () {
  var n = {
      6300: function _() {}
    },
    r = {};
  function t(e) {
    var o = r[e];
    if (void 0 !== o) return o.exports;
    var u = r[e] = {
      exports: {}
    };
    return n[e](u, u.exports, t), u.exports;
  }
  t.n = function (n) {
    var r = n && n.__esModule ? function () {
      return n["default"];
    } : function () {
      return n;
    };
    return t.d(r, {
      a: r
    }), r;
  }, t.d = function (n, r) {
    for (var e in r) t.o(r, e) && !t.o(n, e) && Object.defineProperty(n, e, {
      enumerable: !0,
      get: r[e]
    });
  }, t.o = function (n, r) {
    return Object.prototype.hasOwnProperty.call(n, r);
  }, function () {
    "use strict";

    t(6300);
  }();
}();
!function () {
  var e = {
      4692: function _(e, t) {
        var n;
        !function (t, n) {
          "use strict";

          "object" == _typeof(e.exports) ? e.exports = t.document ? n(t, !0) : function (e) {
            if (!e.document) throw new Error("jQuery requires a window with a document");
            return n(e);
          } : n(t);
        }("undefined" != typeof window ? window : this, function (i, r) {
          "use strict";

          var o = [],
            a = Object.getPrototypeOf,
            s = o.slice,
            l = o.flat ? function (e) {
              return o.flat.call(e);
            } : function (e) {
              return o.concat.apply([], e);
            },
            u = o.push,
            c = o.indexOf,
            f = {},
            d = f.toString,
            p = f.hasOwnProperty,
            h = p.toString,
            v = h.call(Object),
            g = {},
            m = function m(e) {
              return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
            },
            y = function y(e) {
              return null != e && e === e.window;
            },
            b = i.document,
            x = {
              type: !0,
              src: !0,
              nonce: !0,
              noModule: !0
            };
          function w(e, t, n) {
            var i,
              r,
              o = (n = n || b).createElement("script");
            if (o.text = e, t) for (i in x) (r = t[i] || t.getAttribute && t.getAttribute(i)) && o.setAttribute(i, r);
            n.head.appendChild(o).parentNode.removeChild(o);
          }
          function C(e) {
            return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? f[d.call(e)] || "object" : _typeof(e);
          }
          var T = /HTML$/i,
            _k = function k(e, t) {
              return new _k.fn.init(e, t);
            };
          function _(e) {
            var t = !!e && "length" in e && e.length,
              n = C(e);
            return !m(e) && !y(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
          }
          function S(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
          }
          _k.fn = _k.prototype = {
            jquery: "3.7.1",
            constructor: _k,
            length: 0,
            toArray: function toArray() {
              return s.call(this);
            },
            get: function get(e) {
              return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
            },
            pushStack: function pushStack(e) {
              var t = _k.merge(this.constructor(), e);
              return t.prevObject = this, t;
            },
            each: function each(e) {
              return _k.each(this, e);
            },
            map: function map(e) {
              return this.pushStack(_k.map(this, function (t, n) {
                return e.call(t, n, t);
              }));
            },
            slice: function slice() {
              return this.pushStack(s.apply(this, arguments));
            },
            first: function first() {
              return this.eq(0);
            },
            last: function last() {
              return this.eq(-1);
            },
            even: function even() {
              return this.pushStack(_k.grep(this, function (e, t) {
                return (t + 1) % 2;
              }));
            },
            odd: function odd() {
              return this.pushStack(_k.grep(this, function (e, t) {
                return t % 2;
              }));
            },
            eq: function eq(e) {
              var t = this.length,
                n = +e + (e < 0 ? t : 0);
              return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
            },
            end: function end() {
              return this.prevObject || this.constructor();
            },
            push: u,
            sort: o.sort,
            splice: o.splice
          }, _k.extend = _k.fn.extend = function () {
            var e,
              t,
              n,
              i,
              r,
              o,
              a = arguments[0] || {},
              s = 1,
              l = arguments.length,
              u = !1;
            for ("boolean" == typeof a && (u = a, a = arguments[s] || {}, s++), "object" == _typeof(a) || m(a) || (a = {}), s === l && (a = this, s--); s < l; s++) if (null != (e = arguments[s])) for (t in e) i = e[t], "__proto__" !== t && a !== i && (u && i && (_k.isPlainObject(i) || (r = Array.isArray(i))) ? (n = a[t], o = r && !Array.isArray(n) ? [] : r || _k.isPlainObject(n) ? n : {}, r = !1, a[t] = _k.extend(u, o, i)) : void 0 !== i && (a[t] = i));
            return a;
          }, _k.extend({
            expando: "jQuery" + ("3.7.1" + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function error(e) {
              throw new Error(e);
            },
            noop: function noop() {},
            isPlainObject: function isPlainObject(e) {
              var t, n;
              return !(!e || "[object Object]" !== d.call(e)) && (!(t = a(e)) || "function" == typeof (n = p.call(t, "constructor") && t.constructor) && h.call(n) === v);
            },
            isEmptyObject: function isEmptyObject(e) {
              var t;
              for (t in e) return !1;
              return !0;
            },
            globalEval: function globalEval(e, t, n) {
              w(e, {
                nonce: t && t.nonce
              }, n);
            },
            each: function each(e, t) {
              var n,
                i = 0;
              if (_(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
              return e;
            },
            text: function text(e) {
              var t,
                n = "",
                i = 0,
                r = e.nodeType;
              if (!r) for (; t = e[i++];) n += _k.text(t);
              return 1 === r || 11 === r ? e.textContent : 9 === r ? e.documentElement.textContent : 3 === r || 4 === r ? e.nodeValue : n;
            },
            makeArray: function makeArray(e, t) {
              var n = t || [];
              return null != e && (_(Object(e)) ? _k.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n;
            },
            inArray: function inArray(e, t, n) {
              return null == t ? -1 : c.call(t, e, n);
            },
            isXMLDoc: function isXMLDoc(e) {
              var t = e && e.namespaceURI,
                n = e && (e.ownerDocument || e).documentElement;
              return !T.test(t || n && n.nodeName || "HTML");
            },
            merge: function merge(e, t) {
              for (var n = +t.length, i = 0, r = e.length; i < n; i++) e[r++] = t[i];
              return e.length = r, e;
            },
            grep: function grep(e, t, n) {
              for (var i = [], r = 0, o = e.length, a = !n; r < o; r++) !t(e[r], r) !== a && i.push(e[r]);
              return i;
            },
            map: function map(e, t, n) {
              var i,
                r,
                o = 0,
                a = [];
              if (_(e)) for (i = e.length; o < i; o++) null != (r = t(e[o], o, n)) && a.push(r);else for (o in e) null != (r = t(e[o], o, n)) && a.push(r);
              return l(a);
            },
            guid: 1,
            support: g
          }), "function" == typeof Symbol && (_k.fn[Symbol.iterator] = o[Symbol.iterator]), _k.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            f["[object " + t + "]"] = t.toLowerCase();
          });
          var E = o.pop,
            D = o.sort,
            A = o.splice,
            j = "[\\x20\\t\\r\\n\\f]",
            L = new RegExp("^" + j + "+|((?:^|[^\\\\])(?:\\\\.)*)" + j + "+$", "g");
          _k.contains = function (e, t) {
            var n = t && t.parentNode;
            return e === n || !(!n || 1 !== n.nodeType || !(e.contains ? e.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)));
          };
          var N = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
          function R(e, t) {
            return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
          }
          _k.escapeSelector = function (e) {
            return (e + "").replace(N, R);
          };
          var q = b,
            H = u;
          !function () {
            var e,
              t,
              n,
              r,
              a,
              l,
              u,
              f,
              d,
              h,
              v = H,
              m = _k.expando,
              y = 0,
              b = 0,
              x = ee(),
              w = ee(),
              C = ee(),
              T = ee(),
              _ = function _(e, t) {
                return e === t && (a = !0), 0;
              },
              N = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
              R = "(?:\\\\[\\da-fA-F]{1,6}" + j + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
              O = "\\[" + j + "*(" + R + ")(?:" + j + "*([*^$|!~]?=)" + j + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + j + "*\\]",
              M = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + O + ")*)|.*)\\)|)",
              F = new RegExp(j + "+", "g"),
              P = new RegExp("^" + j + "*," + j + "*"),
              I = new RegExp("^" + j + "*([>+~]|" + j + ")" + j + "*"),
              W = new RegExp(j + "|>"),
              $ = new RegExp(M),
              B = new RegExp("^" + R + "$"),
              z = {
                ID: new RegExp("^#(" + R + ")"),
                CLASS: new RegExp("^\\.(" + R + ")"),
                TAG: new RegExp("^(" + R + "|[*])"),
                ATTR: new RegExp("^" + O),
                PSEUDO: new RegExp("^" + M),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + j + "*(even|odd|(([+-]|)(\\d*)n|)" + j + "*(?:([+-]|)" + j + "*(\\d+)|))" + j + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + N + ")$", "i"),
                needsContext: new RegExp("^" + j + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + j + "*((?:-\\d)?\\d*)" + j + "*\\)|)(?=[^-]|$)", "i")
              },
              U = /^(?:input|select|textarea|button)$/i,
              X = /^h\d$/i,
              V = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              G = /[+~]/,
              Q = new RegExp("\\\\[\\da-fA-F]{1,6}" + j + "?|\\\\([^\\r\\n\\f])", "g"),
              Y = function Y(e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320));
              },
              K = function K() {
                le();
              },
              J = de(function (e) {
                return !0 === e.disabled && S(e, "fieldset");
              }, {
                dir: "parentNode",
                next: "legend"
              });
            try {
              v.apply(o = s.call(q.childNodes), q.childNodes), o[q.childNodes.length].nodeType;
            } catch (e) {
              v = {
                apply: function apply(e, t) {
                  H.apply(e, s.call(t));
                },
                call: function call(e) {
                  H.apply(e, s.call(arguments, 1));
                }
              };
            }
            function Z(e, t, n, i) {
              var r,
                o,
                a,
                s,
                u,
                c,
                p,
                h = t && t.ownerDocument,
                y = t ? t.nodeType : 9;
              if (n = n || [], "string" != typeof e || !e || 1 !== y && 9 !== y && 11 !== y) return n;
              if (!i && (le(t), t = t || l, f)) {
                if (11 !== y && (u = V.exec(e))) if (r = u[1]) {
                  if (9 === y) {
                    if (!(a = t.getElementById(r))) return n;
                    if (a.id === r) return v.call(n, a), n;
                  } else if (h && (a = h.getElementById(r)) && Z.contains(t, a) && a.id === r) return v.call(n, a), n;
                } else {
                  if (u[2]) return v.apply(n, t.getElementsByTagName(e)), n;
                  if ((r = u[3]) && t.getElementsByClassName) return v.apply(n, t.getElementsByClassName(r)), n;
                }
                if (!(T[e + " "] || d && d.test(e))) {
                  if (p = e, h = t, 1 === y && (W.test(e) || I.test(e))) {
                    for ((h = G.test(e) && se(t.parentNode) || t) == t && g.scope || ((s = t.getAttribute("id")) ? s = _k.escapeSelector(s) : t.setAttribute("id", s = m)), o = (c = ce(e)).length; o--;) c[o] = (s ? "#" + s : ":scope") + " " + fe(c[o]);
                    p = c.join(",");
                  }
                  try {
                    return v.apply(n, h.querySelectorAll(p)), n;
                  } catch (t) {
                    T(e, !0);
                  } finally {
                    s === m && t.removeAttribute("id");
                  }
                }
              }
              return ye(e.replace(L, "$1"), t, n, i);
            }
            function ee() {
              var e = [];
              return function n(i, r) {
                return e.push(i + " ") > t.cacheLength && delete n[e.shift()], n[i + " "] = r;
              };
            }
            function te(e) {
              return e[m] = !0, e;
            }
            function ne(e) {
              var t = l.createElement("fieldset");
              try {
                return !!e(t);
              } catch (e) {
                return !1;
              } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null;
              }
            }
            function ie(e) {
              return function (t) {
                return S(t, "input") && t.type === e;
              };
            }
            function re(e) {
              return function (t) {
                return (S(t, "input") || S(t, "button")) && t.type === e;
              };
            }
            function oe(e) {
              return function (t) {
                return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && J(t) === e : t.disabled === e : "label" in t && t.disabled === e;
              };
            }
            function ae(e) {
              return te(function (t) {
                return t = +t, te(function (n, i) {
                  for (var r, o = e([], n.length, t), a = o.length; a--;) n[r = o[a]] && (n[r] = !(i[r] = n[r]));
                });
              });
            }
            function se(e) {
              return e && void 0 !== e.getElementsByTagName && e;
            }
            function le(e) {
              var n,
                i = e ? e.ownerDocument || e : q;
              return i != l && 9 === i.nodeType && i.documentElement ? (u = (l = i).documentElement, f = !_k.isXMLDoc(l), h = u.matches || u.webkitMatchesSelector || u.msMatchesSelector, u.msMatchesSelector && q != l && (n = l.defaultView) && n.top !== n && n.addEventListener("unload", K), g.getById = ne(function (e) {
                return u.appendChild(e).id = _k.expando, !l.getElementsByName || !l.getElementsByName(_k.expando).length;
              }), g.disconnectedMatch = ne(function (e) {
                return h.call(e, "*");
              }), g.scope = ne(function () {
                return l.querySelectorAll(":scope");
              }), g.cssHas = ne(function () {
                try {
                  return l.querySelector(":has(*,:jqfake)"), !1;
                } catch (e) {
                  return !0;
                }
              }), g.getById ? (t.filter.ID = function (e) {
                var t = e.replace(Q, Y);
                return function (e) {
                  return e.getAttribute("id") === t;
                };
              }, t.find.ID = function (e, t) {
                if (void 0 !== t.getElementById && f) {
                  var n = t.getElementById(e);
                  return n ? [n] : [];
                }
              }) : (t.filter.ID = function (e) {
                var t = e.replace(Q, Y);
                return function (e) {
                  var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                  return n && n.value === t;
                };
              }, t.find.ID = function (e, t) {
                if (void 0 !== t.getElementById && f) {
                  var n,
                    i,
                    r,
                    o = t.getElementById(e);
                  if (o) {
                    if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                    for (r = t.getElementsByName(e), i = 0; o = r[i++];) if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                  }
                  return [];
                }
              }), t.find.TAG = function (e, t) {
                return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : t.querySelectorAll(e);
              }, t.find.CLASS = function (e, t) {
                if (void 0 !== t.getElementsByClassName && f) return t.getElementsByClassName(e);
              }, d = [], ne(function (e) {
                var t;
                u.appendChild(e).innerHTML = "<a id='" + m + "' href='' disabled='disabled'></a><select id='" + m + "-\r\\' disabled='disabled'><option selected=''></option></select>", e.querySelectorAll("[selected]").length || d.push("\\[" + j + "*(?:value|" + N + ")"), e.querySelectorAll("[id~=" + m + "-]").length || d.push("~="), e.querySelectorAll("a#" + m + "+*").length || d.push(".#.+[+~]"), e.querySelectorAll(":checked").length || d.push(":checked"), (t = l.createElement("input")).setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), u.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && d.push(":enabled", ":disabled"), (t = l.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || d.push("\\[" + j + "*name" + j + "*=" + j + "*(?:''|\"\")");
              }), g.cssHas || d.push(":has"), d = d.length && new RegExp(d.join("|")), _ = function _(e, t) {
                if (e === t) return a = !0, 0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n || (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !g.sortDetached && t.compareDocumentPosition(e) === n ? e === l || e.ownerDocument == q && Z.contains(q, e) ? -1 : t === l || t.ownerDocument == q && Z.contains(q, t) ? 1 : r ? c.call(r, e) - c.call(r, t) : 0 : 4 & n ? -1 : 1);
              }, l) : l;
            }
            for (e in Z.matches = function (e, t) {
              return Z(e, null, null, t);
            }, Z.matchesSelector = function (e, t) {
              if (le(e), f && !T[t + " "] && (!d || !d.test(t))) try {
                var n = h.call(e, t);
                if (n || g.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n;
              } catch (e) {
                T(t, !0);
              }
              return Z(t, l, null, [e]).length > 0;
            }, Z.contains = function (e, t) {
              return (e.ownerDocument || e) != l && le(e), _k.contains(e, t);
            }, Z.attr = function (e, n) {
              (e.ownerDocument || e) != l && le(e);
              var i = t.attrHandle[n.toLowerCase()],
                r = i && p.call(t.attrHandle, n.toLowerCase()) ? i(e, n, !f) : void 0;
              return void 0 !== r ? r : e.getAttribute(n);
            }, Z.error = function (e) {
              throw new Error("Syntax error, unrecognized expression: " + e);
            }, _k.uniqueSort = function (e) {
              var t,
                n = [],
                i = 0,
                o = 0;
              if (a = !g.sortStable, r = !g.sortStable && s.call(e, 0), D.call(e, _), a) {
                for (; t = e[o++];) t === e[o] && (i = n.push(o));
                for (; i--;) A.call(e, n[i], 1);
              }
              return r = null, e;
            }, _k.fn.uniqueSort = function () {
              return this.pushStack(_k.uniqueSort(s.apply(this)));
            }, (t = _k.expr = {
              cacheLength: 50,
              createPseudo: te,
              match: z,
              attrHandle: {},
              find: {},
              relative: {
                ">": {
                  dir: "parentNode",
                  first: !0
                },
                " ": {
                  dir: "parentNode"
                },
                "+": {
                  dir: "previousSibling",
                  first: !0
                },
                "~": {
                  dir: "previousSibling"
                }
              },
              preFilter: {
                ATTR: function ATTR(e) {
                  return e[1] = e[1].replace(Q, Y), e[3] = (e[3] || e[4] || e[5] || "").replace(Q, Y), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                },
                CHILD: function CHILD(e) {
                  return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || Z.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && Z.error(e[0]), e;
                },
                PSEUDO: function PSEUDO(e) {
                  var t,
                    n = !e[6] && e[2];
                  return z.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && $.test(n) && (t = ce(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
                }
              },
              filter: {
                TAG: function TAG(e) {
                  var t = e.replace(Q, Y).toLowerCase();
                  return "*" === e ? function () {
                    return !0;
                  } : function (e) {
                    return S(e, t);
                  };
                },
                CLASS: function CLASS(e) {
                  var t = x[e + " "];
                  return t || (t = new RegExp("(^|" + j + ")" + e + "(" + j + "|$)")) && x(e, function (e) {
                    return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "");
                  });
                },
                ATTR: function ATTR(e, t, n) {
                  return function (i) {
                    var r = Z.attr(i, e);
                    return null == r ? "!=" === t : !t || (r += "", "=" === t ? r === n : "!=" === t ? r !== n : "^=" === t ? n && 0 === r.indexOf(n) : "*=" === t ? n && r.indexOf(n) > -1 : "$=" === t ? n && r.slice(-n.length) === n : "~=" === t ? (" " + r.replace(F, " ") + " ").indexOf(n) > -1 : "|=" === t && (r === n || r.slice(0, n.length + 1) === n + "-"));
                  };
                },
                CHILD: function CHILD(e, t, n, i, r) {
                  var o = "nth" !== e.slice(0, 3),
                    a = "last" !== e.slice(-4),
                    s = "of-type" === t;
                  return 1 === i && 0 === r ? function (e) {
                    return !!e.parentNode;
                  } : function (t, n, l) {
                    var u,
                      c,
                      f,
                      d,
                      p,
                      h = o !== a ? "nextSibling" : "previousSibling",
                      v = t.parentNode,
                      g = s && t.nodeName.toLowerCase(),
                      b = !l && !s,
                      x = !1;
                    if (v) {
                      if (o) {
                        for (; h;) {
                          for (f = t; f = f[h];) if (s ? S(f, g) : 1 === f.nodeType) return !1;
                          p = h = "only" === e && !p && "nextSibling";
                        }
                        return !0;
                      }
                      if (p = [a ? v.firstChild : v.lastChild], a && b) {
                        for (x = (d = (u = (c = v[m] || (v[m] = {}))[e] || [])[0] === y && u[1]) && u[2], f = d && v.childNodes[d]; f = ++d && f && f[h] || (x = d = 0) || p.pop();) if (1 === f.nodeType && ++x && f === t) {
                          c[e] = [y, d, x];
                          break;
                        }
                      } else if (b && (x = d = (u = (c = t[m] || (t[m] = {}))[e] || [])[0] === y && u[1]), !1 === x) for (; (f = ++d && f && f[h] || (x = d = 0) || p.pop()) && (!(s ? S(f, g) : 1 === f.nodeType) || !++x || (b && ((c = f[m] || (f[m] = {}))[e] = [y, x]), f !== t)););
                      return (x -= r) === i || x % i == 0 && x / i >= 0;
                    }
                  };
                },
                PSEUDO: function PSEUDO(e, n) {
                  var i,
                    r = t.pseudos[e] || t.setFilters[e.toLowerCase()] || Z.error("unsupported pseudo: " + e);
                  return r[m] ? r(n) : r.length > 1 ? (i = [e, e, "", n], t.setFilters.hasOwnProperty(e.toLowerCase()) ? te(function (e, t) {
                    for (var i, o = r(e, n), a = o.length; a--;) e[i = c.call(e, o[a])] = !(t[i] = o[a]);
                  }) : function (e) {
                    return r(e, 0, i);
                  }) : r;
                }
              },
              pseudos: {
                not: te(function (e) {
                  var t = [],
                    n = [],
                    i = me(e.replace(L, "$1"));
                  return i[m] ? te(function (e, t, n, r) {
                    for (var o, a = i(e, null, r, []), s = e.length; s--;) (o = a[s]) && (e[s] = !(t[s] = o));
                  }) : function (e, r, o) {
                    return t[0] = e, i(t, null, o, n), t[0] = null, !n.pop();
                  };
                }),
                has: te(function (e) {
                  return function (t) {
                    return Z(e, t).length > 0;
                  };
                }),
                contains: te(function (e) {
                  return e = e.replace(Q, Y), function (t) {
                    return (t.textContent || _k.text(t)).indexOf(e) > -1;
                  };
                }),
                lang: te(function (e) {
                  return B.test(e || "") || Z.error("unsupported lang: " + e), e = e.replace(Q, Y).toLowerCase(), function (t) {
                    var n;
                    do {
                      if (n = f ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                    } while ((t = t.parentNode) && 1 === t.nodeType);
                    return !1;
                  };
                }),
                target: function target(e) {
                  var t = i.location && i.location.hash;
                  return t && t.slice(1) === e.id;
                },
                root: function root(e) {
                  return e === u;
                },
                focus: function focus(e) {
                  return e === function () {
                    try {
                      return l.activeElement;
                    } catch (e) {}
                  }() && l.hasFocus() && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: oe(!1),
                disabled: oe(!0),
                checked: function checked(e) {
                  return S(e, "input") && !!e.checked || S(e, "option") && !!e.selected;
                },
                selected: function selected(e) {
                  return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function empty(e) {
                  for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                  return !0;
                },
                parent: function parent(e) {
                  return !t.pseudos.empty(e);
                },
                header: function header(e) {
                  return X.test(e.nodeName);
                },
                input: function input(e) {
                  return U.test(e.nodeName);
                },
                button: function button(e) {
                  return S(e, "input") && "button" === e.type || S(e, "button");
                },
                text: function text(e) {
                  var t;
                  return S(e, "input") && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                },
                first: ae(function () {
                  return [0];
                }),
                last: ae(function (e, t) {
                  return [t - 1];
                }),
                eq: ae(function (e, t, n) {
                  return [n < 0 ? n + t : n];
                }),
                even: ae(function (e, t) {
                  for (var n = 0; n < t; n += 2) e.push(n);
                  return e;
                }),
                odd: ae(function (e, t) {
                  for (var n = 1; n < t; n += 2) e.push(n);
                  return e;
                }),
                lt: ae(function (e, t, n) {
                  var i;
                  for (i = n < 0 ? n + t : n > t ? t : n; --i >= 0;) e.push(i);
                  return e;
                }),
                gt: ae(function (e, t, n) {
                  for (var i = n < 0 ? n + t : n; ++i < t;) e.push(i);
                  return e;
                })
              }
            }).pseudos.nth = t.pseudos.eq, {
              radio: !0,
              checkbox: !0,
              file: !0,
              password: !0,
              image: !0
            }) t.pseudos[e] = ie(e);
            for (e in {
              submit: !0,
              reset: !0
            }) t.pseudos[e] = re(e);
            function ue() {}
            function ce(e, n) {
              var i,
                r,
                o,
                a,
                s,
                l,
                u,
                c = w[e + " "];
              if (c) return n ? 0 : c.slice(0);
              for (s = e, l = [], u = t.preFilter; s;) {
                for (a in i && !(r = P.exec(s)) || (r && (s = s.slice(r[0].length) || s), l.push(o = [])), i = !1, (r = I.exec(s)) && (i = r.shift(), o.push({
                  value: i,
                  type: r[0].replace(L, " ")
                }), s = s.slice(i.length)), t.filter) !(r = z[a].exec(s)) || u[a] && !(r = u[a](r)) || (i = r.shift(), o.push({
                  value: i,
                  type: a,
                  matches: r
                }), s = s.slice(i.length));
                if (!i) break;
              }
              return n ? s.length : s ? Z.error(e) : w(e, l).slice(0);
            }
            function fe(e) {
              for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
              return i;
            }
            function de(e, t, n) {
              var i = t.dir,
                r = t.next,
                o = r || i,
                a = n && "parentNode" === o,
                s = b++;
              return t.first ? function (t, n, r) {
                for (; t = t[i];) if (1 === t.nodeType || a) return e(t, n, r);
                return !1;
              } : function (t, n, l) {
                var u,
                  c,
                  f = [y, s];
                if (l) {
                  for (; t = t[i];) if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
                } else for (; t = t[i];) if (1 === t.nodeType || a) if (c = t[m] || (t[m] = {}), r && S(t, r)) t = t[i] || t;else {
                  if ((u = c[o]) && u[0] === y && u[1] === s) return f[2] = u[2];
                  if (c[o] = f, f[2] = e(t, n, l)) return !0;
                }
                return !1;
              };
            }
            function pe(e) {
              return e.length > 1 ? function (t, n, i) {
                for (var r = e.length; r--;) if (!e[r](t, n, i)) return !1;
                return !0;
              } : e[0];
            }
            function he(e, t, n, i, r) {
              for (var o, a = [], s = 0, l = e.length, u = null != t; s < l; s++) (o = e[s]) && (n && !n(o, i, r) || (a.push(o), u && t.push(s)));
              return a;
            }
            function ve(e, t, n, i, r, o) {
              return i && !i[m] && (i = ve(i)), r && !r[m] && (r = ve(r, o)), te(function (o, a, s, l) {
                var u,
                  f,
                  d,
                  p,
                  h = [],
                  g = [],
                  m = a.length,
                  y = o || function (e, t, n) {
                    for (var i = 0, r = t.length; i < r; i++) Z(e, t[i], n);
                    return n;
                  }(t || "*", s.nodeType ? [s] : s, []),
                  b = !e || !o && t ? y : he(y, h, e, s, l);
                if (n ? n(b, p = r || (o ? e : m || i) ? [] : a, s, l) : p = b, i) for (u = he(p, g), i(u, [], s, l), f = u.length; f--;) (d = u[f]) && (p[g[f]] = !(b[g[f]] = d));
                if (o) {
                  if (r || e) {
                    if (r) {
                      for (u = [], f = p.length; f--;) (d = p[f]) && u.push(b[f] = d);
                      r(null, p = [], u, l);
                    }
                    for (f = p.length; f--;) (d = p[f]) && (u = r ? c.call(o, d) : h[f]) > -1 && (o[u] = !(a[u] = d));
                  }
                } else p = he(p === a ? p.splice(m, p.length) : p), r ? r(null, a, p, l) : v.apply(a, p);
              });
            }
            function ge(e) {
              for (var i, r, o, a = e.length, s = t.relative[e[0].type], l = s || t.relative[" "], u = s ? 1 : 0, f = de(function (e) {
                  return e === i;
                }, l, !0), d = de(function (e) {
                  return c.call(i, e) > -1;
                }, l, !0), p = [function (e, t, r) {
                  var o = !s && (r || t != n) || ((i = t).nodeType ? f(e, t, r) : d(e, t, r));
                  return i = null, o;
                }]; u < a; u++) if (r = t.relative[e[u].type]) p = [de(pe(p), r)];else {
                if ((r = t.filter[e[u].type].apply(null, e[u].matches))[m]) {
                  for (o = ++u; o < a && !t.relative[e[o].type]; o++);
                  return ve(u > 1 && pe(p), u > 1 && fe(e.slice(0, u - 1).concat({
                    value: " " === e[u - 2].type ? "*" : ""
                  })).replace(L, "$1"), r, u < o && ge(e.slice(u, o)), o < a && ge(e = e.slice(o)), o < a && fe(e));
                }
                p.push(r);
              }
              return pe(p);
            }
            function me(e, i) {
              var r,
                o = [],
                a = [],
                s = C[e + " "];
              if (!s) {
                for (i || (i = ce(e)), r = i.length; r--;) (s = ge(i[r]))[m] ? o.push(s) : a.push(s);
                (s = C(e, function (e, i) {
                  var r = i.length > 0,
                    o = e.length > 0,
                    a = function a(_a, s, u, c, d) {
                      var p,
                        h,
                        g,
                        m = 0,
                        b = "0",
                        x = _a && [],
                        w = [],
                        C = n,
                        T = _a || o && t.find.TAG("*", d),
                        _ = y += null == C ? 1 : Math.random() || .1,
                        S = T.length;
                      for (d && (n = s == l || s || d); b !== S && null != (p = T[b]); b++) {
                        if (o && p) {
                          for (h = 0, s || p.ownerDocument == l || (le(p), u = !f); g = e[h++];) if (g(p, s || l, u)) {
                            v.call(c, p);
                            break;
                          }
                          d && (y = _);
                        }
                        r && ((p = !g && p) && m--, _a && x.push(p));
                      }
                      if (m += b, r && b !== m) {
                        for (h = 0; g = i[h++];) g(x, w, s, u);
                        if (_a) {
                          if (m > 0) for (; b--;) x[b] || w[b] || (w[b] = E.call(c));
                          w = he(w);
                        }
                        v.apply(c, w), d && !_a && w.length > 0 && m + i.length > 1 && _k.uniqueSort(c);
                      }
                      return d && (y = _, n = C), x;
                    };
                  return r ? te(a) : a;
                }(a, o))).selector = e;
              }
              return s;
            }
            function ye(e, n, i, r) {
              var o,
                a,
                s,
                l,
                u,
                c = "function" == typeof e && e,
                d = !r && ce(e = c.selector || e);
              if (i = i || [], 1 === d.length) {
                if ((a = d[0] = d[0].slice(0)).length > 2 && "ID" === (s = a[0]).type && 9 === n.nodeType && f && t.relative[a[1].type]) {
                  if (!(n = (t.find.ID(s.matches[0].replace(Q, Y), n) || [])[0])) return i;
                  c && (n = n.parentNode), e = e.slice(a.shift().value.length);
                }
                for (o = z.needsContext.test(e) ? 0 : a.length; o-- && (s = a[o], !t.relative[l = s.type]);) if ((u = t.find[l]) && (r = u(s.matches[0].replace(Q, Y), G.test(a[0].type) && se(n.parentNode) || n))) {
                  if (a.splice(o, 1), !(e = r.length && fe(a))) return v.apply(i, r), i;
                  break;
                }
              }
              return (c || me(e, d))(r, n, !f, i, !n || G.test(e) && se(n.parentNode) || n), i;
            }
            ue.prototype = t.filters = t.pseudos, t.setFilters = new ue(), g.sortStable = m.split("").sort(_).join("") === m, le(), g.sortDetached = ne(function (e) {
              return 1 & e.compareDocumentPosition(l.createElement("fieldset"));
            }), _k.find = Z, _k.expr[":"] = _k.expr.pseudos, _k.unique = _k.uniqueSort, Z.compile = me, Z.select = ye, Z.setDocument = le, Z.tokenize = ce, Z.escape = _k.escapeSelector, Z.getText = _k.text, Z.isXML = _k.isXMLDoc, Z.selectors = _k.expr, Z.support = _k.support, Z.uniqueSort = _k.uniqueSort;
          }();
          var O = function O(e, t, n) {
              for (var i = [], r = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;) if (1 === e.nodeType) {
                if (r && _k(e).is(n)) break;
                i.push(e);
              }
              return i;
            },
            M = function M(e, t) {
              for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
              return n;
            },
            F = _k.expr.match.needsContext,
            P = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function I(e, t, n) {
            return m(t) ? _k.grep(e, function (e, i) {
              return !!t.call(e, i, e) !== n;
            }) : t.nodeType ? _k.grep(e, function (e) {
              return e === t !== n;
            }) : "string" != typeof t ? _k.grep(e, function (e) {
              return c.call(t, e) > -1 !== n;
            }) : _k.filter(t, e, n);
          }
          _k.filter = function (e, t, n) {
            var i = t[0];
            return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? _k.find.matchesSelector(i, e) ? [i] : [] : _k.find.matches(e, _k.grep(t, function (e) {
              return 1 === e.nodeType;
            }));
          }, _k.fn.extend({
            find: function find(e) {
              var t,
                n,
                i = this.length,
                r = this;
              if ("string" != typeof e) return this.pushStack(_k(e).filter(function () {
                for (t = 0; t < i; t++) if (_k.contains(r[t], this)) return !0;
              }));
              for (n = this.pushStack([]), t = 0; t < i; t++) _k.find(e, r[t], n);
              return i > 1 ? _k.uniqueSort(n) : n;
            },
            filter: function filter(e) {
              return this.pushStack(I(this, e || [], !1));
            },
            not: function not(e) {
              return this.pushStack(I(this, e || [], !0));
            },
            is: function is(e) {
              return !!I(this, "string" == typeof e && F.test(e) ? _k(e) : e || [], !1).length;
            }
          });
          var W,
            $ = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          (_k.fn.init = function (e, t, n) {
            var i, r;
            if (!e) return this;
            if (n = n || W, "string" == typeof e) {
              if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : $.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
              if (i[1]) {
                if (t = t instanceof _k ? t[0] : t, _k.merge(this, _k.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : b, !0)), P.test(i[1]) && _k.isPlainObject(t)) for (i in t) m(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this;
              }
              return (r = b.getElementById(i[2])) && (this[0] = r, this.length = 1), this;
            }
            return e.nodeType ? (this[0] = e, this.length = 1, this) : m(e) ? void 0 !== n.ready ? n.ready(e) : e(_k) : _k.makeArray(e, this);
          }).prototype = _k.fn, W = _k(b);
          var B = /^(?:parents|prev(?:Until|All))/,
            z = {
              children: !0,
              contents: !0,
              next: !0,
              prev: !0
            };
          function U(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType;);
            return e;
          }
          _k.fn.extend({
            has: function has(e) {
              var t = _k(e, this),
                n = t.length;
              return this.filter(function () {
                for (var e = 0; e < n; e++) if (_k.contains(this, t[e])) return !0;
              });
            },
            closest: function closest(e, t) {
              var n,
                i = 0,
                r = this.length,
                o = [],
                a = "string" != typeof e && _k(e);
              if (!F.test(e)) for (; i < r; i++) for (n = this[i]; n && n !== t; n = n.parentNode) if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && _k.find.matchesSelector(n, e))) {
                o.push(n);
                break;
              }
              return this.pushStack(o.length > 1 ? _k.uniqueSort(o) : o);
            },
            index: function index(e) {
              return e ? "string" == typeof e ? c.call(_k(e), this[0]) : c.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function add(e, t) {
              return this.pushStack(_k.uniqueSort(_k.merge(this.get(), _k(e, t))));
            },
            addBack: function addBack(e) {
              return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            }
          }), _k.each({
            parent: function parent(e) {
              var t = e.parentNode;
              return t && 11 !== t.nodeType ? t : null;
            },
            parents: function parents(e) {
              return O(e, "parentNode");
            },
            parentsUntil: function parentsUntil(e, t, n) {
              return O(e, "parentNode", n);
            },
            next: function next(e) {
              return U(e, "nextSibling");
            },
            prev: function prev(e) {
              return U(e, "previousSibling");
            },
            nextAll: function nextAll(e) {
              return O(e, "nextSibling");
            },
            prevAll: function prevAll(e) {
              return O(e, "previousSibling");
            },
            nextUntil: function nextUntil(e, t, n) {
              return O(e, "nextSibling", n);
            },
            prevUntil: function prevUntil(e, t, n) {
              return O(e, "previousSibling", n);
            },
            siblings: function siblings(e) {
              return M((e.parentNode || {}).firstChild, e);
            },
            children: function children(e) {
              return M(e.firstChild);
            },
            contents: function contents(e) {
              return null != e.contentDocument && a(e.contentDocument) ? e.contentDocument : (S(e, "template") && (e = e.content || e), _k.merge([], e.childNodes));
            }
          }, function (e, t) {
            _k.fn[e] = function (n, i) {
              var r = _k.map(this, t, n);
              return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (r = _k.filter(i, r)), this.length > 1 && (z[e] || _k.uniqueSort(r), B.test(e) && r.reverse()), this.pushStack(r);
            };
          });
          var X = /[^\x20\t\r\n\f]+/g;
          function V(e) {
            return e;
          }
          function G(e) {
            throw e;
          }
          function Q(e, t, n, i) {
            var r;
            try {
              e && m(r = e.promise) ? r.call(e).done(t).fail(n) : e && m(r = e.then) ? r.call(e, t, n) : t.apply(void 0, [e].slice(i));
            } catch (e) {
              n.apply(void 0, [e]);
            }
          }
          _k.Callbacks = function (e) {
            e = "string" == typeof e ? function (e) {
              var t = {};
              return _k.each(e.match(X) || [], function (e, n) {
                t[n] = !0;
              }), t;
            }(e) : _k.extend({}, e);
            var t,
              n,
              i,
              r,
              o = [],
              a = [],
              s = -1,
              l = function l() {
                for (r = r || e.once, i = t = !0; a.length; s = -1) for (n = a.shift(); ++s < o.length;) !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length, n = !1);
                e.memory || (n = !1), t = !1, r && (o = n ? [] : "");
              },
              u = {
                add: function add() {
                  return o && (n && !t && (s = o.length - 1, a.push(n)), function t(n) {
                    _k.each(n, function (n, i) {
                      m(i) ? e.unique && u.has(i) || o.push(i) : i && i.length && "string" !== C(i) && t(i);
                    });
                  }(arguments), n && !t && l()), this;
                },
                remove: function remove() {
                  return _k.each(arguments, function (e, t) {
                    for (var n; (n = _k.inArray(t, o, n)) > -1;) o.splice(n, 1), n <= s && s--;
                  }), this;
                },
                has: function has(e) {
                  return e ? _k.inArray(e, o) > -1 : o.length > 0;
                },
                empty: function empty() {
                  return o && (o = []), this;
                },
                disable: function disable() {
                  return r = a = [], o = n = "", this;
                },
                disabled: function disabled() {
                  return !o;
                },
                lock: function lock() {
                  return r = a = [], n || t || (o = n = ""), this;
                },
                locked: function locked() {
                  return !!r;
                },
                fireWith: function fireWith(e, n) {
                  return r || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(n), t || l()), this;
                },
                fire: function fire() {
                  return u.fireWith(this, arguments), this;
                },
                fired: function fired() {
                  return !!i;
                }
              };
            return u;
          }, _k.extend({
            Deferred: function Deferred(e) {
              var t = [["notify", "progress", _k.Callbacks("memory"), _k.Callbacks("memory"), 2], ["resolve", "done", _k.Callbacks("once memory"), _k.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", _k.Callbacks("once memory"), _k.Callbacks("once memory"), 1, "rejected"]],
                n = "pending",
                r = {
                  state: function state() {
                    return n;
                  },
                  always: function always() {
                    return o.done(arguments).fail(arguments), this;
                  },
                  "catch": function _catch(e) {
                    return r.then(null, e);
                  },
                  pipe: function pipe() {
                    var e = arguments;
                    return _k.Deferred(function (n) {
                      _k.each(t, function (t, i) {
                        var r = m(e[i[4]]) && e[i[4]];
                        o[i[1]](function () {
                          var e = r && r.apply(this, arguments);
                          e && m(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[i[0] + "With"](this, r ? [e] : arguments);
                        });
                      }), e = null;
                    }).promise();
                  },
                  then: function then(e, n, r) {
                    var o = 0;
                    function a(e, t, n, r) {
                      return function () {
                        var s = this,
                          l = arguments,
                          u = function u() {
                            var i, u;
                            if (!(e < o)) {
                              if ((i = n.apply(s, l)) === t.promise()) throw new TypeError("Thenable self-resolution");
                              u = i && ("object" == _typeof(i) || "function" == typeof i) && i.then, m(u) ? r ? u.call(i, a(o, t, V, r), a(o, t, G, r)) : (o++, u.call(i, a(o, t, V, r), a(o, t, G, r), a(o, t, V, t.notifyWith))) : (n !== V && (s = void 0, l = [i]), (r || t.resolveWith)(s, l));
                            }
                          },
                          c = r ? u : function () {
                            try {
                              u();
                            } catch (i) {
                              _k.Deferred.exceptionHook && _k.Deferred.exceptionHook(i, c.error), e + 1 >= o && (n !== G && (s = void 0, l = [i]), t.rejectWith(s, l));
                            }
                          };
                        e ? c() : (_k.Deferred.getErrorHook ? c.error = _k.Deferred.getErrorHook() : _k.Deferred.getStackHook && (c.error = _k.Deferred.getStackHook()), i.setTimeout(c));
                      };
                    }
                    return _k.Deferred(function (i) {
                      t[0][3].add(a(0, i, m(r) ? r : V, i.notifyWith)), t[1][3].add(a(0, i, m(e) ? e : V)), t[2][3].add(a(0, i, m(n) ? n : G));
                    }).promise();
                  },
                  promise: function promise(e) {
                    return null != e ? _k.extend(e, r) : r;
                  }
                },
                o = {};
              return _k.each(t, function (e, i) {
                var a = i[2],
                  s = i[5];
                r[i[1]] = a.add, s && a.add(function () {
                  n = s;
                }, t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock), a.add(i[3].fire), o[i[0]] = function () {
                  return o[i[0] + "With"](this === o ? void 0 : this, arguments), this;
                }, o[i[0] + "With"] = a.fireWith;
              }), r.promise(o), e && e.call(o, o), o;
            },
            when: function when(e) {
              var t = arguments.length,
                n = t,
                i = Array(n),
                r = s.call(arguments),
                o = _k.Deferred(),
                a = function a(e) {
                  return function (n) {
                    i[e] = this, r[e] = arguments.length > 1 ? s.call(arguments) : n, --t || o.resolveWith(i, r);
                  };
                };
              if (t <= 1 && (Q(e, o.done(a(n)).resolve, o.reject, !t), "pending" === o.state() || m(r[n] && r[n].then))) return o.then();
              for (; n--;) Q(r[n], a(n), o.reject);
              return o.promise();
            }
          });
          var Y = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          _k.Deferred.exceptionHook = function (e, t) {
            i.console && i.console.warn && e && Y.test(e.name) && i.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
          }, _k.readyException = function (e) {
            i.setTimeout(function () {
              throw e;
            });
          };
          var K = _k.Deferred();
          function J() {
            b.removeEventListener("DOMContentLoaded", J), i.removeEventListener("load", J), _k.ready();
          }
          _k.fn.ready = function (e) {
            return K.then(e)["catch"](function (e) {
              _k.readyException(e);
            }), this;
          }, _k.extend({
            isReady: !1,
            readyWait: 1,
            ready: function ready(e) {
              (!0 === e ? --_k.readyWait : _k.isReady) || (_k.isReady = !0, !0 !== e && --_k.readyWait > 0 || K.resolveWith(b, [_k]));
            }
          }), _k.ready.then = K.then, "complete" === b.readyState || "loading" !== b.readyState && !b.documentElement.doScroll ? i.setTimeout(_k.ready) : (b.addEventListener("DOMContentLoaded", J), i.addEventListener("load", J));
          var _Z = function Z(e, t, n, i, r, o, a) {
              var s = 0,
                l = e.length,
                u = null == n;
              if ("object" === C(n)) for (s in r = !0, n) _Z(e, t, s, n[s], !0, o, a);else if (void 0 !== i && (r = !0, m(i) || (a = !0), u && (a ? (t.call(e, i), t = null) : (u = t, t = function t(e, _t2, n) {
                return u.call(_k(e), n);
              })), t)) for (; s < l; s++) t(e[s], n, a ? i : i.call(e[s], s, t(e[s], n)));
              return r ? e : u ? t.call(e) : l ? t(e[0], n) : o;
            },
            ee = /^-ms-/,
            te = /-([a-z])/g;
          function ne(e, t) {
            return t.toUpperCase();
          }
          function ie(e) {
            return e.replace(ee, "ms-").replace(te, ne);
          }
          var re = function re(e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
          };
          function oe() {
            this.expando = _k.expando + oe.uid++;
          }
          oe.uid = 1, oe.prototype = {
            cache: function cache(e) {
              var t = e[this.expando];
              return t || (t = {}, re(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
              }))), t;
            },
            set: function set(e, t, n) {
              var i,
                r = this.cache(e);
              if ("string" == typeof t) r[ie(t)] = n;else for (i in t) r[ie(i)] = t[i];
              return r;
            },
            get: function get(e, t) {
              return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][ie(t)];
            },
            access: function access(e, t, n) {
              return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function remove(e, t) {
              var n,
                i = e[this.expando];
              if (void 0 !== i) {
                if (void 0 !== t) {
                  n = (t = Array.isArray(t) ? t.map(ie) : (t = ie(t)) in i ? [t] : t.match(X) || []).length;
                  for (; n--;) delete i[t[n]];
                }
                (void 0 === t || _k.isEmptyObject(i)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
              }
            },
            hasData: function hasData(e) {
              var t = e[this.expando];
              return void 0 !== t && !_k.isEmptyObject(t);
            }
          };
          var ae = new oe(),
            se = new oe(),
            le = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            ue = /[A-Z]/g;
          function ce(e, t, n) {
            var i;
            if (void 0 === n && 1 === e.nodeType) if (i = "data-" + t.replace(ue, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(i))) {
              try {
                n = function (e) {
                  return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : le.test(e) ? JSON.parse(e) : e);
                }(n);
              } catch (e) {}
              se.set(e, t, n);
            } else n = void 0;
            return n;
          }
          _k.extend({
            hasData: function hasData(e) {
              return se.hasData(e) || ae.hasData(e);
            },
            data: function data(e, t, n) {
              return se.access(e, t, n);
            },
            removeData: function removeData(e, t) {
              se.remove(e, t);
            },
            _data: function _data(e, t, n) {
              return ae.access(e, t, n);
            },
            _removeData: function _removeData(e, t) {
              ae.remove(e, t);
            }
          }), _k.fn.extend({
            data: function data(e, t) {
              var n,
                i,
                r,
                o = this[0],
                a = o && o.attributes;
              if (void 0 === e) {
                if (this.length && (r = se.get(o), 1 === o.nodeType && !ae.get(o, "hasDataAttrs"))) {
                  for (n = a.length; n--;) a[n] && 0 === (i = a[n].name).indexOf("data-") && (i = ie(i.slice(5)), ce(o, i, r[i]));
                  ae.set(o, "hasDataAttrs", !0);
                }
                return r;
              }
              return "object" == _typeof(e) ? this.each(function () {
                se.set(this, e);
              }) : _Z(this, function (t) {
                var n;
                if (o && void 0 === t) return void 0 !== (n = se.get(o, e)) || void 0 !== (n = ce(o, e)) ? n : void 0;
                this.each(function () {
                  se.set(this, e, t);
                });
              }, null, t, arguments.length > 1, null, !0);
            },
            removeData: function removeData(e) {
              return this.each(function () {
                se.remove(this, e);
              });
            }
          }), _k.extend({
            queue: function queue(e, t, n) {
              var i;
              if (e) return t = (t || "fx") + "queue", i = ae.get(e, t), n && (!i || Array.isArray(n) ? i = ae.access(e, t, _k.makeArray(n)) : i.push(n)), i || [];
            },
            dequeue: function dequeue(e, t) {
              t = t || "fx";
              var n = _k.queue(e, t),
                i = n.length,
                r = n.shift(),
                o = _k._queueHooks(e, t);
              "inprogress" === r && (r = n.shift(), i--), r && ("fx" === t && n.unshift("inprogress"), delete o.stop, r.call(e, function () {
                _k.dequeue(e, t);
              }, o)), !i && o && o.empty.fire();
            },
            _queueHooks: function _queueHooks(e, t) {
              var n = t + "queueHooks";
              return ae.get(e, n) || ae.access(e, n, {
                empty: _k.Callbacks("once memory").add(function () {
                  ae.remove(e, [t + "queue", n]);
                })
              });
            }
          }), _k.fn.extend({
            queue: function queue(e, t) {
              var n = 2;
              return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? _k.queue(this[0], e) : void 0 === t ? this : this.each(function () {
                var n = _k.queue(this, e, t);
                _k._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && _k.dequeue(this, e);
              });
            },
            dequeue: function dequeue(e) {
              return this.each(function () {
                _k.dequeue(this, e);
              });
            },
            clearQueue: function clearQueue(e) {
              return this.queue(e || "fx", []);
            },
            promise: function promise(e, t) {
              var n,
                i = 1,
                r = _k.Deferred(),
                o = this,
                a = this.length,
                s = function s() {
                  --i || r.resolveWith(o, [o]);
                };
              for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;) (n = ae.get(o[a], e + "queueHooks")) && n.empty && (i++, n.empty.add(s));
              return s(), r.promise(t);
            }
          });
          var fe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            de = new RegExp("^(?:([+-])=|)(" + fe + ")([a-z%]*)$", "i"),
            pe = ["Top", "Right", "Bottom", "Left"],
            he = b.documentElement,
            ve = function ve(e) {
              return _k.contains(e.ownerDocument, e);
            },
            ge = {
              composed: !0
            };
          he.getRootNode && (ve = function ve(e) {
            return _k.contains(e.ownerDocument, e) || e.getRootNode(ge) === e.ownerDocument;
          });
          var me = function me(e, t) {
            return "none" === (e = t || e).style.display || "" === e.style.display && ve(e) && "none" === _k.css(e, "display");
          };
          function ye(e, t, n, i) {
            var r,
              o,
              a = 20,
              s = i ? function () {
                return i.cur();
              } : function () {
                return _k.css(e, t, "");
              },
              l = s(),
              u = n && n[3] || (_k.cssNumber[t] ? "" : "px"),
              c = e.nodeType && (_k.cssNumber[t] || "px" !== u && +l) && de.exec(_k.css(e, t));
            if (c && c[3] !== u) {
              for (l /= 2, u = u || c[3], c = +l || 1; a--;) _k.style(e, t, c + u), (1 - o) * (1 - (o = s() / l || .5)) <= 0 && (a = 0), c /= o;
              c *= 2, _k.style(e, t, c + u), n = n || [];
            }
            return n && (c = +c || +l || 0, r = n[1] ? c + (n[1] + 1) * n[2] : +n[2], i && (i.unit = u, i.start = c, i.end = r)), r;
          }
          var be = {};
          function xe(e) {
            var t,
              n = e.ownerDocument,
              i = e.nodeName,
              r = be[i];
            return r || (t = n.body.appendChild(n.createElement(i)), r = _k.css(t, "display"), t.parentNode.removeChild(t), "none" === r && (r = "block"), be[i] = r, r);
          }
          function we(e, t) {
            for (var n, i, r = [], o = 0, a = e.length; o < a; o++) (i = e[o]).style && (n = i.style.display, t ? ("none" === n && (r[o] = ae.get(i, "display") || null, r[o] || (i.style.display = "")), "" === i.style.display && me(i) && (r[o] = xe(i))) : "none" !== n && (r[o] = "none", ae.set(i, "display", n)));
            for (o = 0; o < a; o++) null != r[o] && (e[o].style.display = r[o]);
            return e;
          }
          _k.fn.extend({
            show: function show() {
              return we(this, !0);
            },
            hide: function hide() {
              return we(this);
            },
            toggle: function toggle(e) {
              return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
                me(this) ? _k(this).show() : _k(this).hide();
              });
            }
          });
          var Ce,
            Te,
            ke = /^(?:checkbox|radio)$/i,
            _e = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            Se = /^$|^module$|\/(?:java|ecma)script/i;
          Ce = b.createDocumentFragment().appendChild(b.createElement("div")), (Te = b.createElement("input")).setAttribute("type", "radio"), Te.setAttribute("checked", "checked"), Te.setAttribute("name", "t"), Ce.appendChild(Te), g.checkClone = Ce.cloneNode(!0).cloneNode(!0).lastChild.checked, Ce.innerHTML = "<textarea>x</textarea>", g.noCloneChecked = !!Ce.cloneNode(!0).lastChild.defaultValue, Ce.innerHTML = "<option></option>", g.option = !!Ce.lastChild;
          var Ee = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
          };
          function De(e, t) {
            var n;
            return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && S(e, t) ? _k.merge([e], n) : n;
          }
          function Ae(e, t) {
            for (var n = 0, i = e.length; n < i; n++) ae.set(e[n], "globalEval", !t || ae.get(t[n], "globalEval"));
          }
          Ee.tbody = Ee.tfoot = Ee.colgroup = Ee.caption = Ee.thead, Ee.th = Ee.td, g.option || (Ee.optgroup = Ee.option = [1, "<select multiple='multiple'>", "</select>"]);
          var je = /<|&#?\w+;/;
          function Le(e, t, n, i, r) {
            for (var o, a, s, l, u, c, f = t.createDocumentFragment(), d = [], p = 0, h = e.length; p < h; p++) if ((o = e[p]) || 0 === o) if ("object" === C(o)) _k.merge(d, o.nodeType ? [o] : o);else if (je.test(o)) {
              for (a = a || f.appendChild(t.createElement("div")), s = (_e.exec(o) || ["", ""])[1].toLowerCase(), l = Ee[s] || Ee._default, a.innerHTML = l[1] + _k.htmlPrefilter(o) + l[2], c = l[0]; c--;) a = a.lastChild;
              _k.merge(d, a.childNodes), (a = f.firstChild).textContent = "";
            } else d.push(t.createTextNode(o));
            for (f.textContent = "", p = 0; o = d[p++];) if (i && _k.inArray(o, i) > -1) r && r.push(o);else if (u = ve(o), a = De(f.appendChild(o), "script"), u && Ae(a), n) for (c = 0; o = a[c++];) Se.test(o.type || "") && n.push(o);
            return f;
          }
          var Ne = /^([^.]*)(?:\.(.+)|)/;
          function Re() {
            return !0;
          }
          function qe() {
            return !1;
          }
          function He(e, t, n, i, r, o) {
            var a, s;
            if ("object" == _typeof(t)) {
              for (s in "string" != typeof n && (i = i || n, n = void 0), t) He(e, s, n, i, t[s], o);
              return e;
            }
            if (null == i && null == r ? (r = n, i = n = void 0) : null == r && ("string" == typeof n ? (r = i, i = void 0) : (r = i, i = n, n = void 0)), !1 === r) r = qe;else if (!r) return e;
            return 1 === o && (a = r, (r = function r(e) {
              return _k().off(e), a.apply(this, arguments);
            }).guid = a.guid || (a.guid = _k.guid++)), e.each(function () {
              _k.event.add(this, t, r, i, n);
            });
          }
          function Oe(e, t, n) {
            n ? (ae.set(e, t, !1), _k.event.add(e, t, {
              namespace: !1,
              handler: function handler(e) {
                var n,
                  i = ae.get(this, t);
                if (1 & e.isTrigger && this[t]) {
                  if (i) (_k.event.special[t] || {}).delegateType && e.stopPropagation();else if (i = s.call(arguments), ae.set(this, t, i), this[t](), n = ae.get(this, t), ae.set(this, t, !1), i !== n) return e.stopImmediatePropagation(), e.preventDefault(), n;
                } else i && (ae.set(this, t, _k.event.trigger(i[0], i.slice(1), this)), e.stopPropagation(), e.isImmediatePropagationStopped = Re);
              }
            })) : void 0 === ae.get(e, t) && _k.event.add(e, t, Re);
          }
          _k.event = {
            global: {},
            add: function add(e, t, n, i, r) {
              var o,
                a,
                s,
                l,
                u,
                c,
                f,
                d,
                p,
                h,
                v,
                g = ae.get(e);
              if (re(e)) for (n.handler && (n = (o = n).handler, r = o.selector), r && _k.find.matchesSelector(he, r), n.guid || (n.guid = _k.guid++), (l = g.events) || (l = g.events = Object.create(null)), (a = g.handle) || (a = g.handle = function (t) {
                return void 0 !== _k && _k.event.triggered !== t.type ? _k.event.dispatch.apply(e, arguments) : void 0;
              }), u = (t = (t || "").match(X) || [""]).length; u--;) p = v = (s = Ne.exec(t[u]) || [])[1], h = (s[2] || "").split(".").sort(), p && (f = _k.event.special[p] || {}, p = (r ? f.delegateType : f.bindType) || p, f = _k.event.special[p] || {}, c = _k.extend({
                type: p,
                origType: v,
                data: i,
                handler: n,
                guid: n.guid,
                selector: r,
                needsContext: r && _k.expr.match.needsContext.test(r),
                namespace: h.join(".")
              }, o), (d = l[p]) || ((d = l[p] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, i, h, a) || e.addEventListener && e.addEventListener(p, a)), f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), r ? d.splice(d.delegateCount++, 0, c) : d.push(c), _k.event.global[p] = !0);
            },
            remove: function remove(e, t, n, i, r) {
              var o,
                a,
                s,
                l,
                u,
                c,
                f,
                d,
                p,
                h,
                v,
                g = ae.hasData(e) && ae.get(e);
              if (g && (l = g.events)) {
                for (u = (t = (t || "").match(X) || [""]).length; u--;) if (p = v = (s = Ne.exec(t[u]) || [])[1], h = (s[2] || "").split(".").sort(), p) {
                  for (f = _k.event.special[p] || {}, d = l[p = (i ? f.delegateType : f.bindType) || p] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = d.length; o--;) c = d[o], !r && v !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (d.splice(o, 1), c.selector && d.delegateCount--, f.remove && f.remove.call(e, c));
                  a && !d.length && (f.teardown && !1 !== f.teardown.call(e, h, g.handle) || _k.removeEvent(e, p, g.handle), delete l[p]);
                } else for (p in l) _k.event.remove(e, p + t[u], n, i, !0);
                _k.isEmptyObject(l) && ae.remove(e, "handle events");
              }
            },
            dispatch: function dispatch(e) {
              var t,
                n,
                i,
                r,
                o,
                a,
                s = new Array(arguments.length),
                l = _k.event.fix(e),
                u = (ae.get(this, "events") || Object.create(null))[l.type] || [],
                c = _k.event.special[l.type] || {};
              for (s[0] = l, t = 1; t < arguments.length; t++) s[t] = arguments[t];
              if (l.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, l)) {
                for (a = _k.event.handlers.call(this, l, u), t = 0; (r = a[t++]) && !l.isPropagationStopped();) for (l.currentTarget = r.elem, n = 0; (o = r.handlers[n++]) && !l.isImmediatePropagationStopped();) l.rnamespace && !1 !== o.namespace && !l.rnamespace.test(o.namespace) || (l.handleObj = o, l.data = o.data, void 0 !== (i = ((_k.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, s)) && !1 === (l.result = i) && (l.preventDefault(), l.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, l), l.result;
              }
            },
            handlers: function handlers(e, t) {
              var n,
                i,
                r,
                o,
                a,
                s = [],
                l = t.delegateCount,
                u = e.target;
              if (l && u.nodeType && !("click" === e.type && e.button >= 1)) for (; u !== this; u = u.parentNode || this) if (1 === u.nodeType && ("click" !== e.type || !0 !== u.disabled)) {
                for (o = [], a = {}, n = 0; n < l; n++) void 0 === a[r = (i = t[n]).selector + " "] && (a[r] = i.needsContext ? _k(r, this).index(u) > -1 : _k.find(r, this, null, [u]).length), a[r] && o.push(i);
                o.length && s.push({
                  elem: u,
                  handlers: o
                });
              }
              return u = this, l < t.length && s.push({
                elem: u,
                handlers: t.slice(l)
              }), s;
            },
            addProp: function addProp(e, t) {
              Object.defineProperty(_k.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: m(t) ? function () {
                  if (this.originalEvent) return t(this.originalEvent);
                } : function () {
                  if (this.originalEvent) return this.originalEvent[e];
                },
                set: function set(t) {
                  Object.defineProperty(this, e, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: t
                  });
                }
              });
            },
            fix: function fix(e) {
              return e[_k.expando] ? e : new _k.Event(e);
            },
            special: {
              load: {
                noBubble: !0
              },
              click: {
                setup: function setup(e) {
                  var t = this || e;
                  return ke.test(t.type) && t.click && S(t, "input") && Oe(t, "click", !0), !1;
                },
                trigger: function trigger(e) {
                  var t = this || e;
                  return ke.test(t.type) && t.click && S(t, "input") && Oe(t, "click"), !0;
                },
                _default: function _default(e) {
                  var t = e.target;
                  return ke.test(t.type) && t.click && S(t, "input") && ae.get(t, "click") || S(t, "a");
                }
              },
              beforeunload: {
                postDispatch: function postDispatch(e) {
                  void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                }
              }
            }
          }, _k.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
          }, _k.Event = function (e, t) {
            if (!(this instanceof _k.Event)) return new _k.Event(e, t);
            e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Re : qe, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && _k.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[_k.expando] = !0;
          }, _k.Event.prototype = {
            constructor: _k.Event,
            isDefaultPrevented: qe,
            isPropagationStopped: qe,
            isImmediatePropagationStopped: qe,
            isSimulated: !1,
            preventDefault: function preventDefault() {
              var e = this.originalEvent;
              this.isDefaultPrevented = Re, e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function stopPropagation() {
              var e = this.originalEvent;
              this.isPropagationStopped = Re, e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function stopImmediatePropagation() {
              var e = this.originalEvent;
              this.isImmediatePropagationStopped = Re, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
            }
          }, _k.each({
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            "char": !0,
            code: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: !0
          }, _k.event.addProp), _k.each({
            focus: "focusin",
            blur: "focusout"
          }, function (e, t) {
            function n(e) {
              if (b.documentMode) {
                var n = ae.get(this, "handle"),
                  i = _k.event.fix(e);
                i.type = "focusin" === e.type ? "focus" : "blur", i.isSimulated = !0, n(e), i.target === i.currentTarget && n(i);
              } else _k.event.simulate(t, e.target, _k.event.fix(e));
            }
            _k.event.special[e] = {
              setup: function setup() {
                var i;
                if (Oe(this, e, !0), !b.documentMode) return !1;
                (i = ae.get(this, t)) || this.addEventListener(t, n), ae.set(this, t, (i || 0) + 1);
              },
              trigger: function trigger() {
                return Oe(this, e), !0;
              },
              teardown: function teardown() {
                var e;
                if (!b.documentMode) return !1;
                (e = ae.get(this, t) - 1) ? ae.set(this, t, e) : (this.removeEventListener(t, n), ae.remove(this, t));
              },
              _default: function _default(t) {
                return ae.get(t.target, e);
              },
              delegateType: t
            }, _k.event.special[t] = {
              setup: function setup() {
                var i = this.ownerDocument || this.document || this,
                  r = b.documentMode ? this : i,
                  o = ae.get(r, t);
                o || (b.documentMode ? this.addEventListener(t, n) : i.addEventListener(e, n, !0)), ae.set(r, t, (o || 0) + 1);
              },
              teardown: function teardown() {
                var i = this.ownerDocument || this.document || this,
                  r = b.documentMode ? this : i,
                  o = ae.get(r, t) - 1;
                o ? ae.set(r, t, o) : (b.documentMode ? this.removeEventListener(t, n) : i.removeEventListener(e, n, !0), ae.remove(r, t));
              }
            };
          }), _k.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
          }, function (e, t) {
            _k.event.special[e] = {
              delegateType: t,
              bindType: t,
              handle: function handle(e) {
                var n,
                  i = this,
                  r = e.relatedTarget,
                  o = e.handleObj;
                return r && (r === i || _k.contains(i, r)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
              }
            };
          }), _k.fn.extend({
            on: function on(e, t, n, i) {
              return He(this, e, t, n, i);
            },
            one: function one(e, t, n, i) {
              return He(this, e, t, n, i, 1);
            },
            off: function off(e, t, n) {
              var i, r;
              if (e && e.preventDefault && e.handleObj) return i = e.handleObj, _k(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
              if ("object" == _typeof(e)) {
                for (r in e) this.off(r, t, e[r]);
                return this;
              }
              return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = qe), this.each(function () {
                _k.event.remove(this, e, n, t);
              });
            }
          });
          var Me = /<script|<style|<link/i,
            Fe = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Pe = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
          function Ie(e, t) {
            return S(e, "table") && S(11 !== t.nodeType ? t : t.firstChild, "tr") && _k(e).children("tbody")[0] || e;
          }
          function We(e) {
            return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
          }
          function $e(e) {
            return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
          }
          function Be(e, t) {
            var n, i, r, o, a, s;
            if (1 === t.nodeType) {
              if (ae.hasData(e) && (s = ae.get(e).events)) for (r in ae.remove(t, "handle events"), s) for (n = 0, i = s[r].length; n < i; n++) _k.event.add(t, r, s[r][n]);
              se.hasData(e) && (o = se.access(e), a = _k.extend({}, o), se.set(t, a));
            }
          }
          function ze(e, t) {
            var n = t.nodeName.toLowerCase();
            "input" === n && ke.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
          }
          function Ue(e, t, n, i) {
            t = l(t);
            var r,
              o,
              a,
              s,
              u,
              c,
              f = 0,
              d = e.length,
              p = d - 1,
              h = t[0],
              v = m(h);
            if (v || d > 1 && "string" == typeof h && !g.checkClone && Fe.test(h)) return e.each(function (r) {
              var o = e.eq(r);
              v && (t[0] = h.call(this, r, o.html())), Ue(o, t, n, i);
            });
            if (d && (o = (r = Le(t, e[0].ownerDocument, !1, e, i)).firstChild, 1 === r.childNodes.length && (r = o), o || i)) {
              for (s = (a = _k.map(De(r, "script"), We)).length; f < d; f++) u = r, f !== p && (u = _k.clone(u, !0, !0), s && _k.merge(a, De(u, "script"))), n.call(e[f], u, f);
              if (s) for (c = a[a.length - 1].ownerDocument, _k.map(a, $e), f = 0; f < s; f++) u = a[f], Se.test(u.type || "") && !ae.access(u, "globalEval") && _k.contains(c, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? _k._evalUrl && !u.noModule && _k._evalUrl(u.src, {
                nonce: u.nonce || u.getAttribute("nonce")
              }, c) : w(u.textContent.replace(Pe, ""), u, c));
            }
            return e;
          }
          function Xe(e, t, n) {
            for (var i, r = t ? _k.filter(t, e) : e, o = 0; null != (i = r[o]); o++) n || 1 !== i.nodeType || _k.cleanData(De(i)), i.parentNode && (n && ve(i) && Ae(De(i, "script")), i.parentNode.removeChild(i));
            return e;
          }
          _k.extend({
            htmlPrefilter: function htmlPrefilter(e) {
              return e;
            },
            clone: function clone(e, t, n) {
              var i,
                r,
                o,
                a,
                s = e.cloneNode(!0),
                l = ve(e);
              if (!(g.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || _k.isXMLDoc(e))) for (a = De(s), i = 0, r = (o = De(e)).length; i < r; i++) ze(o[i], a[i]);
              if (t) if (n) for (o = o || De(e), a = a || De(s), i = 0, r = o.length; i < r; i++) Be(o[i], a[i]);else Be(e, s);
              return (a = De(s, "script")).length > 0 && Ae(a, !l && De(e, "script")), s;
            },
            cleanData: function cleanData(e) {
              for (var t, n, i, r = _k.event.special, o = 0; void 0 !== (n = e[o]); o++) if (re(n)) {
                if (t = n[ae.expando]) {
                  if (t.events) for (i in t.events) r[i] ? _k.event.remove(n, i) : _k.removeEvent(n, i, t.handle);
                  n[ae.expando] = void 0;
                }
                n[se.expando] && (n[se.expando] = void 0);
              }
            }
          }), _k.fn.extend({
            detach: function detach(e) {
              return Xe(this, e, !0);
            },
            remove: function remove(e) {
              return Xe(this, e);
            },
            text: function text(e) {
              return _Z(this, function (e) {
                return void 0 === e ? _k.text(this) : this.empty().each(function () {
                  1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
                });
              }, null, e, arguments.length);
            },
            append: function append() {
              return Ue(this, arguments, function (e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Ie(this, e).appendChild(e);
              });
            },
            prepend: function prepend() {
              return Ue(this, arguments, function (e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                  var t = Ie(this, e);
                  t.insertBefore(e, t.firstChild);
                }
              });
            },
            before: function before() {
              return Ue(this, arguments, function (e) {
                this.parentNode && this.parentNode.insertBefore(e, this);
              });
            },
            after: function after() {
              return Ue(this, arguments, function (e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
              });
            },
            empty: function empty() {
              for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (_k.cleanData(De(e, !1)), e.textContent = "");
              return this;
            },
            clone: function clone(e, t) {
              return e = null != e && e, t = null == t ? e : t, this.map(function () {
                return _k.clone(this, e, t);
              });
            },
            html: function html(e) {
              return _Z(this, function (e) {
                var t = this[0] || {},
                  n = 0,
                  i = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !Me.test(e) && !Ee[(_e.exec(e) || ["", ""])[1].toLowerCase()]) {
                  e = _k.htmlPrefilter(e);
                  try {
                    for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (_k.cleanData(De(t, !1)), t.innerHTML = e);
                    t = 0;
                  } catch (e) {}
                }
                t && this.empty().append(e);
              }, null, e, arguments.length);
            },
            replaceWith: function replaceWith() {
              var e = [];
              return Ue(this, arguments, function (t) {
                var n = this.parentNode;
                _k.inArray(this, e) < 0 && (_k.cleanData(De(this)), n && n.replaceChild(t, this));
              }, e);
            }
          }), _k.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
          }, function (e, t) {
            _k.fn[e] = function (e) {
              for (var n, i = [], r = _k(e), o = r.length - 1, a = 0; a <= o; a++) n = a === o ? this : this.clone(!0), _k(r[a])[t](n), u.apply(i, n.get());
              return this.pushStack(i);
            };
          });
          var Ve = new RegExp("^(" + fe + ")(?!px)[a-z%]+$", "i"),
            Ge = /^--/,
            Qe = function Qe(e) {
              var t = e.ownerDocument.defaultView;
              return t && t.opener || (t = i), t.getComputedStyle(e);
            },
            Ye = function Ye(e, t, n) {
              var i,
                r,
                o = {};
              for (r in t) o[r] = e.style[r], e.style[r] = t[r];
              for (r in i = n.call(e), t) e.style[r] = o[r];
              return i;
            },
            Ke = new RegExp(pe.join("|"), "i");
          function Je(e, t, n) {
            var i,
              r,
              o,
              a,
              s = Ge.test(t),
              l = e.style;
            return (n = n || Qe(e)) && (a = n.getPropertyValue(t) || n[t], s && a && (a = a.replace(L, "$1") || void 0), "" !== a || ve(e) || (a = _k.style(e, t)), !g.pixelBoxStyles() && Ve.test(a) && Ke.test(t) && (i = l.width, r = l.minWidth, o = l.maxWidth, l.minWidth = l.maxWidth = l.width = a, a = n.width, l.width = i, l.minWidth = r, l.maxWidth = o)), void 0 !== a ? a + "" : a;
          }
          function Ze(e, t) {
            return {
              get: function get() {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
              }
            };
          }
          !function () {
            function e() {
              if (c) {
                u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", he.appendChild(u).appendChild(c);
                var e = i.getComputedStyle(c);
                n = "1%" !== e.top, l = 12 === t(e.marginLeft), c.style.right = "60%", a = 36 === t(e.right), r = 36 === t(e.width), c.style.position = "absolute", o = 12 === t(c.offsetWidth / 3), he.removeChild(u), c = null;
              }
            }
            function t(e) {
              return Math.round(parseFloat(e));
            }
            var n,
              r,
              o,
              a,
              s,
              l,
              u = b.createElement("div"),
              c = b.createElement("div");
            c.style && (c.style.backgroundClip = "content-box", c.cloneNode(!0).style.backgroundClip = "", g.clearCloneStyle = "content-box" === c.style.backgroundClip, _k.extend(g, {
              boxSizingReliable: function boxSizingReliable() {
                return e(), r;
              },
              pixelBoxStyles: function pixelBoxStyles() {
                return e(), a;
              },
              pixelPosition: function pixelPosition() {
                return e(), n;
              },
              reliableMarginLeft: function reliableMarginLeft() {
                return e(), l;
              },
              scrollboxSize: function scrollboxSize() {
                return e(), o;
              },
              reliableTrDimensions: function reliableTrDimensions() {
                var e, t, n, r;
                return null == s && (e = b.createElement("table"), t = b.createElement("tr"), n = b.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", t.style.cssText = "box-sizing:content-box;border:1px solid", t.style.height = "1px", n.style.height = "9px", n.style.display = "block", he.appendChild(e).appendChild(t).appendChild(n), r = i.getComputedStyle(t), s = parseInt(r.height, 10) + parseInt(r.borderTopWidth, 10) + parseInt(r.borderBottomWidth, 10) === t.offsetHeight, he.removeChild(e)), s;
              }
            }));
          }();
          var et = ["Webkit", "Moz", "ms"],
            tt = b.createElement("div").style,
            nt = {};
          function it(e) {
            var t = _k.cssProps[e] || nt[e];
            return t || (e in tt ? e : nt[e] = function (e) {
              for (var t = e[0].toUpperCase() + e.slice(1), n = et.length; n--;) if ((e = et[n] + t) in tt) return e;
            }(e) || e);
          }
          var rt = /^(none|table(?!-c[ea]).+)/,
            ot = {
              position: "absolute",
              visibility: "hidden",
              display: "block"
            },
            at = {
              letterSpacing: "0",
              fontWeight: "400"
            };
          function st(e, t, n) {
            var i = de.exec(t);
            return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
          }
          function lt(e, t, n, i, r, o) {
            var a = "width" === t ? 1 : 0,
              s = 0,
              l = 0,
              u = 0;
            if (n === (i ? "border" : "content")) return 0;
            for (; a < 4; a += 2) "margin" === n && (u += _k.css(e, n + pe[a], !0, r)), i ? ("content" === n && (l -= _k.css(e, "padding" + pe[a], !0, r)), "margin" !== n && (l -= _k.css(e, "border" + pe[a] + "Width", !0, r))) : (l += _k.css(e, "padding" + pe[a], !0, r), "padding" !== n ? l += _k.css(e, "border" + pe[a] + "Width", !0, r) : s += _k.css(e, "border" + pe[a] + "Width", !0, r));
            return !i && o >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - l - s - .5)) || 0), l + u;
          }
          function ut(e, t, n) {
            var i = Qe(e),
              r = (!g.boxSizingReliable() || n) && "border-box" === _k.css(e, "boxSizing", !1, i),
              o = r,
              a = Je(e, t, i),
              s = "offset" + t[0].toUpperCase() + t.slice(1);
            if (Ve.test(a)) {
              if (!n) return a;
              a = "auto";
            }
            return (!g.boxSizingReliable() && r || !g.reliableTrDimensions() && S(e, "tr") || "auto" === a || !parseFloat(a) && "inline" === _k.css(e, "display", !1, i)) && e.getClientRects().length && (r = "border-box" === _k.css(e, "boxSizing", !1, i), (o = s in e) && (a = e[s])), (a = parseFloat(a) || 0) + lt(e, t, n || (r ? "border" : "content"), o, i, a) + "px";
          }
          function ct(e, t, n, i, r) {
            return new ct.prototype.init(e, t, n, i, r);
          }
          _k.extend({
            cssHooks: {
              opacity: {
                get: function get(e, t) {
                  if (t) {
                    var n = Je(e, "opacity");
                    return "" === n ? "1" : n;
                  }
                }
              }
            },
            cssNumber: {
              animationIterationCount: !0,
              aspectRatio: !0,
              borderImageSlice: !0,
              columnCount: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              scale: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
              fillOpacity: !0,
              floodOpacity: !0,
              stopOpacity: !0,
              strokeMiterlimit: !0,
              strokeOpacity: !0
            },
            cssProps: {},
            style: function style(e, t, n, i) {
              if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r,
                  o,
                  a,
                  s = ie(t),
                  l = Ge.test(t),
                  u = e.style;
                if (l || (t = it(s)), a = _k.cssHooks[t] || _k.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (r = a.get(e, !1, i)) ? r : u[t];
                "string" === (o = _typeof(n)) && (r = de.exec(n)) && r[1] && (n = ye(e, t, r), o = "number"), null != n && n == n && ("number" !== o || l || (n += r && r[3] || (_k.cssNumber[s] ? "" : "px")), g.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, i)) || (l ? u.setProperty(t, n) : u[t] = n));
              }
            },
            css: function css(e, t, n, i) {
              var r,
                o,
                a,
                s = ie(t);
              return Ge.test(t) || (t = it(s)), (a = _k.cssHooks[t] || _k.cssHooks[s]) && "get" in a && (r = a.get(e, !0, n)), void 0 === r && (r = Je(e, t, i)), "normal" === r && t in at && (r = at[t]), "" === n || n ? (o = parseFloat(r), !0 === n || isFinite(o) ? o || 0 : r) : r;
            }
          }), _k.each(["height", "width"], function (e, t) {
            _k.cssHooks[t] = {
              get: function get(e, n, i) {
                if (n) return !rt.test(_k.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ut(e, t, i) : Ye(e, ot, function () {
                  return ut(e, t, i);
                });
              },
              set: function set(e, n, i) {
                var r,
                  o = Qe(e),
                  a = !g.scrollboxSize() && "absolute" === o.position,
                  s = (a || i) && "border-box" === _k.css(e, "boxSizing", !1, o),
                  l = i ? lt(e, t, i, s, o) : 0;
                return s && a && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - lt(e, t, "border", !1, o) - .5)), l && (r = de.exec(n)) && "px" !== (r[3] || "px") && (e.style[t] = n, n = _k.css(e, t)), st(0, n, l);
              }
            };
          }), _k.cssHooks.marginLeft = Ze(g.reliableMarginLeft, function (e, t) {
            if (t) return (parseFloat(Je(e, "marginLeft")) || e.getBoundingClientRect().left - Ye(e, {
              marginLeft: 0
            }, function () {
              return e.getBoundingClientRect().left;
            })) + "px";
          }), _k.each({
            margin: "",
            padding: "",
            border: "Width"
          }, function (e, t) {
            _k.cssHooks[e + t] = {
              expand: function expand(n) {
                for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) r[e + pe[i] + t] = o[i] || o[i - 2] || o[0];
                return r;
              }
            }, "margin" !== e && (_k.cssHooks[e + t].set = st);
          }), _k.fn.extend({
            css: function css(e, t) {
              return _Z(this, function (e, t, n) {
                var i,
                  r,
                  o = {},
                  a = 0;
                if (Array.isArray(t)) {
                  for (i = Qe(e), r = t.length; a < r; a++) o[t[a]] = _k.css(e, t[a], !1, i);
                  return o;
                }
                return void 0 !== n ? _k.style(e, t, n) : _k.css(e, t);
              }, e, t, arguments.length > 1);
            }
          }), _k.Tween = ct, ct.prototype = {
            constructor: ct,
            init: function init(e, t, n, i, r, o) {
              this.elem = e, this.prop = n, this.easing = r || _k.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = o || (_k.cssNumber[n] ? "" : "px");
            },
            cur: function cur() {
              var e = ct.propHooks[this.prop];
              return e && e.get ? e.get(this) : ct.propHooks._default.get(this);
            },
            run: function run(e) {
              var t,
                n = ct.propHooks[this.prop];
              return this.options.duration ? this.pos = t = _k.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : ct.propHooks._default.set(this), this;
            }
          }, ct.prototype.init.prototype = ct.prototype, ct.propHooks = {
            _default: {
              get: function get(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = _k.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
              },
              set: function set(e) {
                _k.fx.step[e.prop] ? _k.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !_k.cssHooks[e.prop] && null == e.elem.style[it(e.prop)] ? e.elem[e.prop] = e.now : _k.style(e.elem, e.prop, e.now + e.unit);
              }
            }
          }, ct.propHooks.scrollTop = ct.propHooks.scrollLeft = {
            set: function set(e) {
              e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            }
          }, _k.easing = {
            linear: function linear(e) {
              return e;
            },
            swing: function swing(e) {
              return .5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing"
          }, _k.fx = ct.prototype.init, _k.fx.step = {};
          var ft,
            dt,
            pt = /^(?:toggle|show|hide)$/,
            ht = /queueHooks$/;
          function vt() {
            dt && (!1 === b.hidden && i.requestAnimationFrame ? i.requestAnimationFrame(vt) : i.setTimeout(vt, _k.fx.interval), _k.fx.tick());
          }
          function gt() {
            return i.setTimeout(function () {
              ft = void 0;
            }), ft = Date.now();
          }
          function mt(e, t) {
            var n,
              i = 0,
              r = {
                height: e
              };
            for (t = t ? 1 : 0; i < 4; i += 2 - t) r["margin" + (n = pe[i])] = r["padding" + n] = e;
            return t && (r.opacity = r.width = e), r;
          }
          function yt(e, t, n) {
            for (var i, r = (bt.tweeners[t] || []).concat(bt.tweeners["*"]), o = 0, a = r.length; o < a; o++) if (i = r[o].call(n, t, e)) return i;
          }
          function bt(e, t, n) {
            var i,
              r,
              o = 0,
              a = bt.prefilters.length,
              s = _k.Deferred().always(function () {
                delete l.elem;
              }),
              l = function l() {
                if (r) return !1;
                for (var t = ft || gt(), n = Math.max(0, u.startTime + u.duration - t), i = 1 - (n / u.duration || 0), o = 0, a = u.tweens.length; o < a; o++) u.tweens[o].run(i);
                return s.notifyWith(e, [u, i, n]), i < 1 && a ? n : (a || s.notifyWith(e, [u, 1, 0]), s.resolveWith(e, [u]), !1);
              },
              u = s.promise({
                elem: e,
                props: _k.extend({}, t),
                opts: _k.extend(!0, {
                  specialEasing: {},
                  easing: _k.easing._default
                }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: ft || gt(),
                duration: n.duration,
                tweens: [],
                createTween: function createTween(t, n) {
                  var i = _k.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
                  return u.tweens.push(i), i;
                },
                stop: function stop(t) {
                  var n = 0,
                    i = t ? u.tweens.length : 0;
                  if (r) return this;
                  for (r = !0; n < i; n++) u.tweens[n].run(1);
                  return t ? (s.notifyWith(e, [u, 1, 0]), s.resolveWith(e, [u, t])) : s.rejectWith(e, [u, t]), this;
                }
              }),
              c = u.props;
            for (!function (e, t) {
              var n, i, r, o, a;
              for (n in e) if (r = t[i = ie(n)], o = e[n], Array.isArray(o) && (r = o[1], o = e[n] = o[0]), n !== i && (e[i] = o, delete e[n]), (a = _k.cssHooks[i]) && "expand" in a) for (n in o = a.expand(o), delete e[i], o) n in e || (e[n] = o[n], t[n] = r);else t[i] = r;
            }(c, u.opts.specialEasing); o < a; o++) if (i = bt.prefilters[o].call(u, e, c, u.opts)) return m(i.stop) && (_k._queueHooks(u.elem, u.opts.queue).stop = i.stop.bind(i)), i;
            return _k.map(c, yt, u), m(u.opts.start) && u.opts.start.call(e, u), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always), _k.fx.timer(_k.extend(l, {
              elem: e,
              anim: u,
              queue: u.opts.queue
            })), u;
          }
          _k.Animation = _k.extend(bt, {
            tweeners: {
              "*": [function (e, t) {
                var n = this.createTween(e, t);
                return ye(n.elem, e, de.exec(t), n), n;
              }]
            },
            tweener: function tweener(e, t) {
              m(e) ? (t = e, e = ["*"]) : e = e.match(X);
              for (var n, i = 0, r = e.length; i < r; i++) n = e[i], bt.tweeners[n] = bt.tweeners[n] || [], bt.tweeners[n].unshift(t);
            },
            prefilters: [function (e, t, n) {
              var i,
                r,
                o,
                a,
                s,
                l,
                u,
                c,
                f = "width" in t || "height" in t,
                d = this,
                p = {},
                h = e.style,
                v = e.nodeType && me(e),
                g = ae.get(e, "fxshow");
              for (i in n.queue || (null == (a = _k._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () {
                a.unqueued || s();
              }), a.unqueued++, d.always(function () {
                d.always(function () {
                  a.unqueued--, _k.queue(e, "fx").length || a.empty.fire();
                });
              })), t) if (r = t[i], pt.test(r)) {
                if (delete t[i], o = o || "toggle" === r, r === (v ? "hide" : "show")) {
                  if ("show" !== r || !g || void 0 === g[i]) continue;
                  v = !0;
                }
                p[i] = g && g[i] || _k.style(e, i);
              }
              if ((l = !_k.isEmptyObject(t)) || !_k.isEmptyObject(p)) for (i in f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (u = g && g.display) && (u = ae.get(e, "display")), "none" === (c = _k.css(e, "display")) && (u ? c = u : (we([e], !0), u = e.style.display || u, c = _k.css(e, "display"), we([e]))), ("inline" === c || "inline-block" === c && null != u) && "none" === _k.css(e, "float") && (l || (d.done(function () {
                h.display = u;
              }), null == u && (c = h.display, u = "none" === c ? "" : c)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", d.always(function () {
                h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
              })), l = !1, p) l || (g ? "hidden" in g && (v = g.hidden) : g = ae.access(e, "fxshow", {
                display: u
              }), o && (g.hidden = !v), v && we([e], !0), d.done(function () {
                for (i in v || we([e]), ae.remove(e, "fxshow"), p) _k.style(e, i, p[i]);
              })), l = yt(v ? g[i] : 0, i, d), i in g || (g[i] = l.start, v && (l.end = l.start, l.start = 0));
            }],
            prefilter: function prefilter(e, t) {
              t ? bt.prefilters.unshift(e) : bt.prefilters.push(e);
            }
          }), _k.speed = function (e, t, n) {
            var i = e && "object" == _typeof(e) ? _k.extend({}, e) : {
              complete: n || !n && t || m(e) && e,
              duration: e,
              easing: n && t || t && !m(t) && t
            };
            return _k.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in _k.fx.speeds ? i.duration = _k.fx.speeds[i.duration] : i.duration = _k.fx.speeds._default), null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function () {
              m(i.old) && i.old.call(this), i.queue && _k.dequeue(this, i.queue);
            }, i;
          }, _k.fn.extend({
            fadeTo: function fadeTo(e, t, n, i) {
              return this.filter(me).css("opacity", 0).show().end().animate({
                opacity: t
              }, e, n, i);
            },
            animate: function animate(e, t, n, i) {
              var r = _k.isEmptyObject(e),
                o = _k.speed(t, n, i),
                a = function a() {
                  var t = bt(this, _k.extend({}, e), o);
                  (r || ae.get(this, "finish")) && t.stop(!0);
                };
              return a.finish = a, r || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
            },
            stop: function stop(e, t, n) {
              var i = function i(e) {
                var t = e.stop;
                delete e.stop, t(n);
              };
              return "string" != typeof e && (n = t, t = e, e = void 0), t && this.queue(e || "fx", []), this.each(function () {
                var t = !0,
                  r = null != e && e + "queueHooks",
                  o = _k.timers,
                  a = ae.get(this);
                if (r) a[r] && a[r].stop && i(a[r]);else for (r in a) a[r] && a[r].stop && ht.test(r) && i(a[r]);
                for (r = o.length; r--;) o[r].elem !== this || null != e && o[r].queue !== e || (o[r].anim.stop(n), t = !1, o.splice(r, 1));
                !t && n || _k.dequeue(this, e);
              });
            },
            finish: function finish(e) {
              return !1 !== e && (e = e || "fx"), this.each(function () {
                var t,
                  n = ae.get(this),
                  i = n[e + "queue"],
                  r = n[e + "queueHooks"],
                  o = _k.timers,
                  a = i ? i.length : 0;
                for (n.finish = !0, _k.queue(this, e, []), r && r.stop && r.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                for (t = 0; t < a; t++) i[t] && i[t].finish && i[t].finish.call(this);
                delete n.finish;
              });
            }
          }), _k.each(["toggle", "show", "hide"], function (e, t) {
            var n = _k.fn[t];
            _k.fn[t] = function (e, i, r) {
              return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(mt(t, !0), e, i, r);
            };
          }), _k.each({
            slideDown: mt("show"),
            slideUp: mt("hide"),
            slideToggle: mt("toggle"),
            fadeIn: {
              opacity: "show"
            },
            fadeOut: {
              opacity: "hide"
            },
            fadeToggle: {
              opacity: "toggle"
            }
          }, function (e, t) {
            _k.fn[e] = function (e, n, i) {
              return this.animate(t, e, n, i);
            };
          }), _k.timers = [], _k.fx.tick = function () {
            var e,
              t = 0,
              n = _k.timers;
            for (ft = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || _k.fx.stop(), ft = void 0;
          }, _k.fx.timer = function (e) {
            _k.timers.push(e), _k.fx.start();
          }, _k.fx.interval = 13, _k.fx.start = function () {
            dt || (dt = !0, vt());
          }, _k.fx.stop = function () {
            dt = null;
          }, _k.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
          }, _k.fn.delay = function (e, t) {
            return e = _k.fx && _k.fx.speeds[e] || e, t = t || "fx", this.queue(t, function (t, n) {
              var r = i.setTimeout(t, e);
              n.stop = function () {
                i.clearTimeout(r);
              };
            });
          }, function () {
            var e = b.createElement("input"),
              t = b.createElement("select").appendChild(b.createElement("option"));
            e.type = "checkbox", g.checkOn = "" !== e.value, g.optSelected = t.selected, (e = b.createElement("input")).value = "t", e.type = "radio", g.radioValue = "t" === e.value;
          }();
          var xt,
            wt = _k.expr.attrHandle;
          _k.fn.extend({
            attr: function attr(e, t) {
              return _Z(this, _k.attr, e, t, arguments.length > 1);
            },
            removeAttr: function removeAttr(e) {
              return this.each(function () {
                _k.removeAttr(this, e);
              });
            }
          }), _k.extend({
            attr: function attr(e, t, n) {
              var i,
                r,
                o = e.nodeType;
              if (3 !== o && 8 !== o && 2 !== o) return void 0 === e.getAttribute ? _k.prop(e, t, n) : (1 === o && _k.isXMLDoc(e) || (r = _k.attrHooks[t.toLowerCase()] || (_k.expr.match.bool.test(t) ? xt : void 0)), void 0 !== n ? null === n ? void _k.removeAttr(e, t) : r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : r && "get" in r && null !== (i = r.get(e, t)) ? i : null == (i = _k.find.attr(e, t)) ? void 0 : i);
            },
            attrHooks: {
              type: {
                set: function set(e, t) {
                  if (!g.radioValue && "radio" === t && S(e, "input")) {
                    var n = e.value;
                    return e.setAttribute("type", t), n && (e.value = n), t;
                  }
                }
              }
            },
            removeAttr: function removeAttr(e, t) {
              var n,
                i = 0,
                r = t && t.match(X);
              if (r && 1 === e.nodeType) for (; n = r[i++];) e.removeAttribute(n);
            }
          }), xt = {
            set: function set(e, t, n) {
              return !1 === t ? _k.removeAttr(e, n) : e.setAttribute(n, n), n;
            }
          }, _k.each(_k.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var n = wt[t] || _k.find.attr;
            wt[t] = function (e, t, i) {
              var r,
                o,
                a = t.toLowerCase();
              return i || (o = wt[a], wt[a] = r, r = null != n(e, t, i) ? a : null, wt[a] = o), r;
            };
          });
          var Ct = /^(?:input|select|textarea|button)$/i,
            Tt = /^(?:a|area)$/i;
          function kt(e) {
            return (e.match(X) || []).join(" ");
          }
          function _t(e) {
            return e.getAttribute && e.getAttribute("class") || "";
          }
          function St(e) {
            return Array.isArray(e) ? e : "string" == typeof e && e.match(X) || [];
          }
          _k.fn.extend({
            prop: function prop(e, t) {
              return _Z(this, _k.prop, e, t, arguments.length > 1);
            },
            removeProp: function removeProp(e) {
              return this.each(function () {
                delete this[_k.propFix[e] || e];
              });
            }
          }), _k.extend({
            prop: function prop(e, t, n) {
              var i,
                r,
                o = e.nodeType;
              if (3 !== o && 8 !== o && 2 !== o) return 1 === o && _k.isXMLDoc(e) || (t = _k.propFix[t] || t, r = _k.propHooks[t]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : e[t] = n : r && "get" in r && null !== (i = r.get(e, t)) ? i : e[t];
            },
            propHooks: {
              tabIndex: {
                get: function get(e) {
                  var t = _k.find.attr(e, "tabindex");
                  return t ? parseInt(t, 10) : Ct.test(e.nodeName) || Tt.test(e.nodeName) && e.href ? 0 : -1;
                }
              }
            },
            propFix: {
              "for": "htmlFor",
              "class": "className"
            }
          }), g.optSelected || (_k.propHooks.selected = {
            get: function get(e) {
              var t = e.parentNode;
              return t && t.parentNode && t.parentNode.selectedIndex, null;
            },
            set: function set(e) {
              var t = e.parentNode;
              t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
            }
          }), _k.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            _k.propFix[this.toLowerCase()] = this;
          }), _k.fn.extend({
            addClass: function addClass(e) {
              var t, n, i, r, o, a;
              return m(e) ? this.each(function (t) {
                _k(this).addClass(e.call(this, t, _t(this)));
              }) : (t = St(e)).length ? this.each(function () {
                if (i = _t(this), n = 1 === this.nodeType && " " + kt(i) + " ") {
                  for (o = 0; o < t.length; o++) r = t[o], n.indexOf(" " + r + " ") < 0 && (n += r + " ");
                  a = kt(n), i !== a && this.setAttribute("class", a);
                }
              }) : this;
            },
            removeClass: function removeClass(e) {
              var t, n, i, r, o, a;
              return m(e) ? this.each(function (t) {
                _k(this).removeClass(e.call(this, t, _t(this)));
              }) : arguments.length ? (t = St(e)).length ? this.each(function () {
                if (i = _t(this), n = 1 === this.nodeType && " " + kt(i) + " ") {
                  for (o = 0; o < t.length; o++) for (r = t[o]; n.indexOf(" " + r + " ") > -1;) n = n.replace(" " + r + " ", " ");
                  a = kt(n), i !== a && this.setAttribute("class", a);
                }
              }) : this : this.attr("class", "");
            },
            toggleClass: function toggleClass(e, t) {
              var n,
                i,
                r,
                o,
                a = _typeof(e),
                s = "string" === a || Array.isArray(e);
              return m(e) ? this.each(function (n) {
                _k(this).toggleClass(e.call(this, n, _t(this), t), t);
              }) : "boolean" == typeof t && s ? t ? this.addClass(e) : this.removeClass(e) : (n = St(e), this.each(function () {
                if (s) for (o = _k(this), r = 0; r < n.length; r++) i = n[r], o.hasClass(i) ? o.removeClass(i) : o.addClass(i);else void 0 !== e && "boolean" !== a || ((i = _t(this)) && ae.set(this, "__className__", i), this.setAttribute && this.setAttribute("class", i || !1 === e ? "" : ae.get(this, "__className__") || ""));
              }));
            },
            hasClass: function hasClass(e) {
              var t,
                n,
                i = 0;
              for (t = " " + e + " "; n = this[i++];) if (1 === n.nodeType && (" " + kt(_t(n)) + " ").indexOf(t) > -1) return !0;
              return !1;
            }
          });
          var Et = /\r/g;
          _k.fn.extend({
            val: function val(e) {
              var t,
                n,
                i,
                r = this[0];
              return arguments.length ? (i = m(e), this.each(function (n) {
                var r;
                1 === this.nodeType && (null == (r = i ? e.call(this, n, _k(this).val()) : e) ? r = "" : "number" == typeof r ? r += "" : Array.isArray(r) && (r = _k.map(r, function (e) {
                  return null == e ? "" : e + "";
                })), (t = _k.valHooks[this.type] || _k.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, r, "value") || (this.value = r));
              })) : r ? (t = _k.valHooks[r.type] || _k.valHooks[r.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(r, "value")) ? n : "string" == typeof (n = r.value) ? n.replace(Et, "") : null == n ? "" : n : void 0;
            }
          }), _k.extend({
            valHooks: {
              option: {
                get: function get(e) {
                  var t = _k.find.attr(e, "value");
                  return null != t ? t : kt(_k.text(e));
                }
              },
              select: {
                get: function get(e) {
                  var t,
                    n,
                    i,
                    r = e.options,
                    o = e.selectedIndex,
                    a = "select-one" === e.type,
                    s = a ? null : [],
                    l = a ? o + 1 : r.length;
                  for (i = o < 0 ? l : a ? o : 0; i < l; i++) if (((n = r[i]).selected || i === o) && !n.disabled && (!n.parentNode.disabled || !S(n.parentNode, "optgroup"))) {
                    if (t = _k(n).val(), a) return t;
                    s.push(t);
                  }
                  return s;
                },
                set: function set(e, t) {
                  for (var n, i, r = e.options, o = _k.makeArray(t), a = r.length; a--;) ((i = r[a]).selected = _k.inArray(_k.valHooks.option.get(i), o) > -1) && (n = !0);
                  return n || (e.selectedIndex = -1), o;
                }
              }
            }
          }), _k.each(["radio", "checkbox"], function () {
            _k.valHooks[this] = {
              set: function set(e, t) {
                if (Array.isArray(t)) return e.checked = _k.inArray(_k(e).val(), t) > -1;
              }
            }, g.checkOn || (_k.valHooks[this].get = function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            });
          });
          var Dt = i.location,
            At = {
              guid: Date.now()
            },
            jt = /\?/;
          _k.parseXML = function (e) {
            var t, n;
            if (!e || "string" != typeof e) return null;
            try {
              t = new i.DOMParser().parseFromString(e, "text/xml");
            } catch (e) {}
            return n = t && t.getElementsByTagName("parsererror")[0], t && !n || _k.error("Invalid XML: " + (n ? _k.map(n.childNodes, function (e) {
              return e.textContent;
            }).join("\n") : e)), t;
          };
          var Lt = /^(?:focusinfocus|focusoutblur)$/,
            Nt = function Nt(e) {
              e.stopPropagation();
            };
          _k.extend(_k.event, {
            trigger: function trigger(e, t, n, r) {
              var o,
                a,
                s,
                l,
                u,
                c,
                f,
                d,
                h = [n || b],
                v = p.call(e, "type") ? e.type : e,
                g = p.call(e, "namespace") ? e.namespace.split(".") : [];
              if (a = d = s = n = n || b, 3 !== n.nodeType && 8 !== n.nodeType && !Lt.test(v + _k.event.triggered) && (v.indexOf(".") > -1 && (g = v.split("."), v = g.shift(), g.sort()), u = v.indexOf(":") < 0 && "on" + v, (e = e[_k.expando] ? e : new _k.Event(v, "object" == _typeof(e) && e)).isTrigger = r ? 2 : 3, e.namespace = g.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), t = null == t ? [e] : _k.makeArray(t, [e]), f = _k.event.special[v] || {}, r || !f.trigger || !1 !== f.trigger.apply(n, t))) {
                if (!r && !f.noBubble && !y(n)) {
                  for (l = f.delegateType || v, Lt.test(l + v) || (a = a.parentNode); a; a = a.parentNode) h.push(a), s = a;
                  s === (n.ownerDocument || b) && h.push(s.defaultView || s.parentWindow || i);
                }
                for (o = 0; (a = h[o++]) && !e.isPropagationStopped();) d = a, e.type = o > 1 ? l : f.bindType || v, (c = (ae.get(a, "events") || Object.create(null))[e.type] && ae.get(a, "handle")) && c.apply(a, t), (c = u && a[u]) && c.apply && re(a) && (e.result = c.apply(a, t), !1 === e.result && e.preventDefault());
                return e.type = v, r || e.isDefaultPrevented() || f._default && !1 !== f._default.apply(h.pop(), t) || !re(n) || u && m(n[v]) && !y(n) && ((s = n[u]) && (n[u] = null), _k.event.triggered = v, e.isPropagationStopped() && d.addEventListener(v, Nt), n[v](), e.isPropagationStopped() && d.removeEventListener(v, Nt), _k.event.triggered = void 0, s && (n[u] = s)), e.result;
              }
            },
            simulate: function simulate(e, t, n) {
              var i = _k.extend(new _k.Event(), n, {
                type: e,
                isSimulated: !0
              });
              _k.event.trigger(i, null, t);
            }
          }), _k.fn.extend({
            trigger: function trigger(e, t) {
              return this.each(function () {
                _k.event.trigger(e, t, this);
              });
            },
            triggerHandler: function triggerHandler(e, t) {
              var n = this[0];
              if (n) return _k.event.trigger(e, t, n, !0);
            }
          });
          var Rt = /\[\]$/,
            qt = /\r?\n/g,
            Ht = /^(?:submit|button|image|reset|file)$/i,
            Ot = /^(?:input|select|textarea|keygen)/i;
          function Mt(e, t, n, i) {
            var r;
            if (Array.isArray(t)) _k.each(t, function (t, r) {
              n || Rt.test(e) ? i(e, r) : Mt(e + "[" + ("object" == _typeof(r) && null != r ? t : "") + "]", r, n, i);
            });else if (n || "object" !== C(t)) i(e, t);else for (r in t) Mt(e + "[" + r + "]", t[r], n, i);
          }
          _k.param = function (e, t) {
            var n,
              i = [],
              r = function r(e, t) {
                var n = m(t) ? t() : t;
                i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
              };
            if (null == e) return "";
            if (Array.isArray(e) || e.jquery && !_k.isPlainObject(e)) _k.each(e, function () {
              r(this.name, this.value);
            });else for (n in e) Mt(n, e[n], t, r);
            return i.join("&");
          }, _k.fn.extend({
            serialize: function serialize() {
              return _k.param(this.serializeArray());
            },
            serializeArray: function serializeArray() {
              return this.map(function () {
                var e = _k.prop(this, "elements");
                return e ? _k.makeArray(e) : this;
              }).filter(function () {
                var e = this.type;
                return this.name && !_k(this).is(":disabled") && Ot.test(this.nodeName) && !Ht.test(e) && (this.checked || !ke.test(e));
              }).map(function (e, t) {
                var n = _k(this).val();
                return null == n ? null : Array.isArray(n) ? _k.map(n, function (e) {
                  return {
                    name: t.name,
                    value: e.replace(qt, "\r\n")
                  };
                }) : {
                  name: t.name,
                  value: n.replace(qt, "\r\n")
                };
              }).get();
            }
          });
          var Ft = /%20/g,
            Pt = /#.*$/,
            It = /([?&])_=[^&]*/,
            Wt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            $t = /^(?:GET|HEAD)$/,
            Bt = /^\/\//,
            zt = {},
            Ut = {},
            Xt = "*/".concat("*"),
            Vt = b.createElement("a");
          function Gt(e) {
            return function (t, n) {
              "string" != typeof t && (n = t, t = "*");
              var i,
                r = 0,
                o = t.toLowerCase().match(X) || [];
              if (m(n)) for (; i = o[r++];) "+" === i[0] ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
            };
          }
          function Qt(e, t, n, i) {
            var r = {},
              o = e === Ut;
            function a(s) {
              var l;
              return r[s] = !0, _k.each(e[s] || [], function (e, s) {
                var u = s(t, n, i);
                return "string" != typeof u || o || r[u] ? o ? !(l = u) : void 0 : (t.dataTypes.unshift(u), a(u), !1);
              }), l;
            }
            return a(t.dataTypes[0]) || !r["*"] && a("*");
          }
          function Yt(e, t) {
            var n,
              i,
              r = _k.ajaxSettings.flatOptions || {};
            for (n in t) void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
            return i && _k.extend(!0, e, i), e;
          }
          Vt.href = Dt.href, _k.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
              url: Dt.href,
              type: "GET",
              isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Dt.protocol),
              global: !0,
              processData: !0,
              async: !0,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",
              accepts: {
                "*": Xt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
              },
              contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
              },
              responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
              },
              converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": _k.parseXML
              },
              flatOptions: {
                url: !0,
                context: !0
              }
            },
            ajaxSetup: function ajaxSetup(e, t) {
              return t ? Yt(Yt(e, _k.ajaxSettings), t) : Yt(_k.ajaxSettings, e);
            },
            ajaxPrefilter: Gt(zt),
            ajaxTransport: Gt(Ut),
            ajax: function ajax(e, t) {
              "object" == _typeof(e) && (t = e, e = void 0), t = t || {};
              var n,
                r,
                o,
                a,
                s,
                l,
                u,
                c,
                f,
                d,
                p = _k.ajaxSetup({}, t),
                h = p.context || p,
                v = p.context && (h.nodeType || h.jquery) ? _k(h) : _k.event,
                g = _k.Deferred(),
                m = _k.Callbacks("once memory"),
                y = p.statusCode || {},
                x = {},
                w = {},
                C = "canceled",
                T = {
                  readyState: 0,
                  getResponseHeader: function getResponseHeader(e) {
                    var t;
                    if (u) {
                      if (!a) for (a = {}; t = Wt.exec(o);) a[t[1].toLowerCase() + " "] = (a[t[1].toLowerCase() + " "] || []).concat(t[2]);
                      t = a[e.toLowerCase() + " "];
                    }
                    return null == t ? null : t.join(", ");
                  },
                  getAllResponseHeaders: function getAllResponseHeaders() {
                    return u ? o : null;
                  },
                  setRequestHeader: function setRequestHeader(e, t) {
                    return null == u && (e = w[e.toLowerCase()] = w[e.toLowerCase()] || e, x[e] = t), this;
                  },
                  overrideMimeType: function overrideMimeType(e) {
                    return null == u && (p.mimeType = e), this;
                  },
                  statusCode: function statusCode(e) {
                    var t;
                    if (e) if (u) T.always(e[T.status]);else for (t in e) y[t] = [y[t], e[t]];
                    return this;
                  },
                  abort: function abort(e) {
                    var t = e || C;
                    return n && n.abort(t), _(0, t), this;
                  }
                };
              if (g.promise(T), p.url = ((e || p.url || Dt.href) + "").replace(Bt, Dt.protocol + "//"), p.type = t.method || t.type || p.method || p.type, p.dataTypes = (p.dataType || "*").toLowerCase().match(X) || [""], null == p.crossDomain) {
                l = b.createElement("a");
                try {
                  l.href = p.url, l.href = l.href, p.crossDomain = Vt.protocol + "//" + Vt.host != l.protocol + "//" + l.host;
                } catch (e) {
                  p.crossDomain = !0;
                }
              }
              if (p.data && p.processData && "string" != typeof p.data && (p.data = _k.param(p.data, p.traditional)), Qt(zt, p, t, T), u) return T;
              for (f in (c = _k.event && p.global) && 0 == _k.active++ && _k.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !$t.test(p.type), r = p.url.replace(Pt, ""), p.hasContent ? p.data && p.processData && 0 === (p.contentType || "").indexOf("application/x-www-form-urlencoded") && (p.data = p.data.replace(Ft, "+")) : (d = p.url.slice(r.length), p.data && (p.processData || "string" == typeof p.data) && (r += (jt.test(r) ? "&" : "?") + p.data, delete p.data), !1 === p.cache && (r = r.replace(It, "$1"), d = (jt.test(r) ? "&" : "?") + "_=" + At.guid++ + d), p.url = r + d), p.ifModified && (_k.lastModified[r] && T.setRequestHeader("If-Modified-Since", _k.lastModified[r]), _k.etag[r] && T.setRequestHeader("If-None-Match", _k.etag[r])), (p.data && p.hasContent && !1 !== p.contentType || t.contentType) && T.setRequestHeader("Content-Type", p.contentType), T.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Xt + "; q=0.01" : "") : p.accepts["*"]), p.headers) T.setRequestHeader(f, p.headers[f]);
              if (p.beforeSend && (!1 === p.beforeSend.call(h, T, p) || u)) return T.abort();
              if (C = "abort", m.add(p.complete), T.done(p.success), T.fail(p.error), n = Qt(Ut, p, t, T)) {
                if (T.readyState = 1, c && v.trigger("ajaxSend", [T, p]), u) return T;
                p.async && p.timeout > 0 && (s = i.setTimeout(function () {
                  T.abort("timeout");
                }, p.timeout));
                try {
                  u = !1, n.send(x, _);
                } catch (e) {
                  if (u) throw e;
                  _(-1, e);
                }
              } else _(-1, "No Transport");
              function _(e, t, a, l) {
                var f,
                  d,
                  b,
                  x,
                  w,
                  C = t;
                u || (u = !0, s && i.clearTimeout(s), n = void 0, o = l || "", T.readyState = e > 0 ? 4 : 0, f = e >= 200 && e < 300 || 304 === e, a && (x = function (e, t, n) {
                  for (var i, r, o, a, s = e.contents, l = e.dataTypes; "*" === l[0];) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                  if (i) for (r in s) if (s[r] && s[r].test(i)) {
                    l.unshift(r);
                    break;
                  }
                  if (l[0] in n) o = l[0];else {
                    for (r in n) {
                      if (!l[0] || e.converters[r + " " + l[0]]) {
                        o = r;
                        break;
                      }
                      a || (a = r);
                    }
                    o = o || a;
                  }
                  if (o) return o !== l[0] && l.unshift(o), n[o];
                }(p, T, a)), !f && _k.inArray("script", p.dataTypes) > -1 && _k.inArray("json", p.dataTypes) < 0 && (p.converters["text script"] = function () {}), x = function (e, t, n, i) {
                  var r,
                    o,
                    a,
                    s,
                    l,
                    u = {},
                    c = e.dataTypes.slice();
                  if (c[1]) for (a in e.converters) u[a.toLowerCase()] = e.converters[a];
                  for (o = c.shift(); o;) if (e.responseFields[o] && (n[e.responseFields[o]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = o, o = c.shift()) if ("*" === o) o = l;else if ("*" !== l && l !== o) {
                    if (!(a = u[l + " " + o] || u["* " + o])) for (r in u) if ((s = r.split(" "))[1] === o && (a = u[l + " " + s[0]] || u["* " + s[0]])) {
                      !0 === a ? a = u[r] : !0 !== u[r] && (o = s[0], c.unshift(s[1]));
                      break;
                    }
                    if (!0 !== a) if (a && e["throws"]) t = a(t);else try {
                      t = a(t);
                    } catch (e) {
                      return {
                        state: "parsererror",
                        error: a ? e : "No conversion from " + l + " to " + o
                      };
                    }
                  }
                  return {
                    state: "success",
                    data: t
                  };
                }(p, x, T, f), f ? (p.ifModified && ((w = T.getResponseHeader("Last-Modified")) && (_k.lastModified[r] = w), (w = T.getResponseHeader("etag")) && (_k.etag[r] = w)), 204 === e || "HEAD" === p.type ? C = "nocontent" : 304 === e ? C = "notmodified" : (C = x.state, d = x.data, f = !(b = x.error))) : (b = C, !e && C || (C = "error", e < 0 && (e = 0))), T.status = e, T.statusText = (t || C) + "", f ? g.resolveWith(h, [d, C, T]) : g.rejectWith(h, [T, C, b]), T.statusCode(y), y = void 0, c && v.trigger(f ? "ajaxSuccess" : "ajaxError", [T, p, f ? d : b]), m.fireWith(h, [T, C]), c && (v.trigger("ajaxComplete", [T, p]), --_k.active || _k.event.trigger("ajaxStop")));
              }
              return T;
            },
            getJSON: function getJSON(e, t, n) {
              return _k.get(e, t, n, "json");
            },
            getScript: function getScript(e, t) {
              return _k.get(e, void 0, t, "script");
            }
          }), _k.each(["get", "post"], function (e, t) {
            _k[t] = function (e, n, i, r) {
              return m(n) && (r = r || i, i = n, n = void 0), _k.ajax(_k.extend({
                url: e,
                type: t,
                dataType: r,
                data: n,
                success: i
              }, _k.isPlainObject(e) && e));
            };
          }), _k.ajaxPrefilter(function (e) {
            var t;
            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
          }), _k._evalUrl = function (e, t, n) {
            return _k.ajax({
              url: e,
              type: "GET",
              dataType: "script",
              cache: !0,
              async: !1,
              global: !1,
              converters: {
                "text script": function text_script() {}
              },
              dataFilter: function dataFilter(e) {
                _k.globalEval(e, t, n);
              }
            });
          }, _k.fn.extend({
            wrapAll: function wrapAll(e) {
              var t;
              return this[0] && (m(e) && (e = e.call(this[0])), t = _k(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e;
              }).append(this)), this;
            },
            wrapInner: function wrapInner(e) {
              return m(e) ? this.each(function (t) {
                _k(this).wrapInner(e.call(this, t));
              }) : this.each(function () {
                var t = _k(this),
                  n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e);
              });
            },
            wrap: function wrap(e) {
              var t = m(e);
              return this.each(function (n) {
                _k(this).wrapAll(t ? e.call(this, n) : e);
              });
            },
            unwrap: function unwrap(e) {
              return this.parent(e).not("body").each(function () {
                _k(this).replaceWith(this.childNodes);
              }), this;
            }
          }), _k.expr.pseudos.hidden = function (e) {
            return !_k.expr.pseudos.visible(e);
          }, _k.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
          }, _k.ajaxSettings.xhr = function () {
            try {
              return new i.XMLHttpRequest();
            } catch (e) {}
          };
          var Kt = {
              0: 200,
              1223: 204
            },
            Jt = _k.ajaxSettings.xhr();
          g.cors = !!Jt && "withCredentials" in Jt, g.ajax = Jt = !!Jt, _k.ajaxTransport(function (e) {
            var _t3, n;
            if (g.cors || Jt && !e.crossDomain) return {
              send: function send(r, o) {
                var a,
                  s = e.xhr();
                if (s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (a in e.xhrFields) s[a] = e.xhrFields[a];
                for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"), r) s.setRequestHeader(a, r[a]);
                _t3 = function t(e) {
                  return function () {
                    _t3 && (_t3 = n = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Kt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                      binary: s.response
                    } : {
                      text: s.responseText
                    }, s.getAllResponseHeaders()));
                  };
                }, s.onload = _t3(), n = s.onerror = s.ontimeout = _t3("error"), void 0 !== s.onabort ? s.onabort = n : s.onreadystatechange = function () {
                  4 === s.readyState && i.setTimeout(function () {
                    _t3 && n();
                  });
                }, _t3 = _t3("abort");
                try {
                  s.send(e.hasContent && e.data || null);
                } catch (e) {
                  if (_t3) throw e;
                }
              },
              abort: function abort() {
                _t3 && _t3();
              }
            };
          }), _k.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
          }), _k.ajaxSetup({
            accepts: {
              script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
            },
            contents: {
              script: /\b(?:java|ecma)script\b/
            },
            converters: {
              "text script": function text_script(e) {
                return _k.globalEval(e), e;
              }
            }
          }), _k.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
          }), _k.ajaxTransport("script", function (e) {
            var t, _n;
            if (e.crossDomain || e.scriptAttrs) return {
              send: function send(i, r) {
                t = _k("<script>").attr(e.scriptAttrs || {}).prop({
                  charset: e.scriptCharset,
                  src: e.url
                }).on("load error", _n = function n(e) {
                  t.remove(), _n = null, e && r("error" === e.type ? 404 : 200, e.type);
                }), b.head.appendChild(t[0]);
              },
              abort: function abort() {
                _n && _n();
              }
            };
          });
          var Zt,
            en = [],
            tn = /(=)\?(?=&|$)|\?\?/;
          _k.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function jsonpCallback() {
              var e = en.pop() || _k.expando + "_" + At.guid++;
              return this[e] = !0, e;
            }
          }), _k.ajaxPrefilter("json jsonp", function (e, t, n) {
            var r,
              o,
              a,
              s = !1 !== e.jsonp && (tn.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && tn.test(e.data) && "data");
            if (s || "jsonp" === e.dataTypes[0]) return r = e.jsonpCallback = m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[s] = e[s].replace(tn, "$1" + r) : !1 !== e.jsonp && (e.url += (jt.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function () {
              return a || _k.error(r + " was not called"), a[0];
            }, e.dataTypes[0] = "json", o = i[r], i[r] = function () {
              a = arguments;
            }, n.always(function () {
              void 0 === o ? _k(i).removeProp(r) : i[r] = o, e[r] && (e.jsonpCallback = t.jsonpCallback, en.push(r)), a && m(o) && o(a[0]), a = o = void 0;
            }), "script";
          }), g.createHTMLDocument = ((Zt = b.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Zt.childNodes.length), _k.parseHTML = function (e, t, n) {
            return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (g.createHTMLDocument ? ((i = (t = b.implementation.createHTMLDocument("")).createElement("base")).href = b.location.href, t.head.appendChild(i)) : t = b), o = !n && [], (r = P.exec(e)) ? [t.createElement(r[1])] : (r = Le([e], t, o), o && o.length && _k(o).remove(), _k.merge([], r.childNodes)));
            var i, r, o;
          }, _k.fn.load = function (e, t, n) {
            var i,
              r,
              o,
              a = this,
              s = e.indexOf(" ");
            return s > -1 && (i = kt(e.slice(s)), e = e.slice(0, s)), m(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (r = "POST"), a.length > 0 && _k.ajax({
              url: e,
              type: r || "GET",
              dataType: "html",
              data: t
            }).done(function (e) {
              o = arguments, a.html(i ? _k("<div>").append(_k.parseHTML(e)).find(i) : e);
            }).always(n && function (e, t) {
              a.each(function () {
                n.apply(this, o || [e.responseText, t, e]);
              });
            }), this;
          }, _k.expr.pseudos.animated = function (e) {
            return _k.grep(_k.timers, function (t) {
              return e === t.elem;
            }).length;
          }, _k.offset = {
            setOffset: function setOffset(e, t, n) {
              var i,
                r,
                o,
                a,
                s,
                l,
                u = _k.css(e, "position"),
                c = _k(e),
                f = {};
              "static" === u && (e.style.position = "relative"), s = c.offset(), o = _k.css(e, "top"), l = _k.css(e, "left"), ("absolute" === u || "fixed" === u) && (o + l).indexOf("auto") > -1 ? (a = (i = c.position()).top, r = i.left) : (a = parseFloat(o) || 0, r = parseFloat(l) || 0), m(t) && (t = t.call(e, n, _k.extend({}, s))), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + r), "using" in t ? t.using.call(e, f) : c.css(f);
            }
          }, _k.fn.extend({
            offset: function offset(e) {
              if (arguments.length) return void 0 === e ? this : this.each(function (t) {
                _k.offset.setOffset(this, e, t);
              });
              var t,
                n,
                i = this[0];
              return i ? i.getClientRects().length ? (t = i.getBoundingClientRect(), n = i.ownerDocument.defaultView, {
                top: t.top + n.pageYOffset,
                left: t.left + n.pageXOffset
              }) : {
                top: 0,
                left: 0
              } : void 0;
            },
            position: function position() {
              if (this[0]) {
                var e,
                  t,
                  n,
                  i = this[0],
                  r = {
                    top: 0,
                    left: 0
                  };
                if ("fixed" === _k.css(i, "position")) t = i.getBoundingClientRect();else {
                  for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === _k.css(e, "position");) e = e.parentNode;
                  e && e !== i && 1 === e.nodeType && ((r = _k(e).offset()).top += _k.css(e, "borderTopWidth", !0), r.left += _k.css(e, "borderLeftWidth", !0));
                }
                return {
                  top: t.top - r.top - _k.css(i, "marginTop", !0),
                  left: t.left - r.left - _k.css(i, "marginLeft", !0)
                };
              }
            },
            offsetParent: function offsetParent() {
              return this.map(function () {
                for (var e = this.offsetParent; e && "static" === _k.css(e, "position");) e = e.offsetParent;
                return e || he;
              });
            }
          }), _k.each({
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset"
          }, function (e, t) {
            var n = "pageYOffset" === t;
            _k.fn[e] = function (i) {
              return _Z(this, function (e, i, r) {
                var o;
                if (y(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === r) return o ? o[t] : e[i];
                o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : e[i] = r;
              }, e, i, arguments.length);
            };
          }), _k.each(["top", "left"], function (e, t) {
            _k.cssHooks[t] = Ze(g.pixelPosition, function (e, n) {
              if (n) return n = Je(e, t), Ve.test(n) ? _k(e).position()[t] + "px" : n;
            });
          }), _k.each({
            Height: "height",
            Width: "width"
          }, function (e, t) {
            _k.each({
              padding: "inner" + e,
              content: t,
              "": "outer" + e
            }, function (n, i) {
              _k.fn[i] = function (r, o) {
                var a = arguments.length && (n || "boolean" != typeof r),
                  s = n || (!0 === r || !0 === o ? "margin" : "border");
                return _Z(this, function (t, n, r) {
                  var o;
                  return y(t) ? 0 === i.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === r ? _k.css(t, n, s) : _k.style(t, n, r, s);
                }, t, a ? r : void 0, a);
              };
            });
          }), _k.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            _k.fn[t] = function (e) {
              return this.on(t, e);
            };
          }), _k.fn.extend({
            bind: function bind(e, t, n) {
              return this.on(e, null, t, n);
            },
            unbind: function unbind(e, t) {
              return this.off(e, null, t);
            },
            delegate: function delegate(e, t, n, i) {
              return this.on(t, e, n, i);
            },
            undelegate: function undelegate(e, t, n) {
              return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            hover: function hover(e, t) {
              return this.on("mouseenter", e).on("mouseleave", t || e);
            }
          }), _k.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
            _k.fn[t] = function (e, n) {
              return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
            };
          });
          var nn = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
          _k.proxy = function (e, t) {
            var n, i, r;
            if ("string" == typeof t && (n = e[t], t = e, e = n), m(e)) return i = s.call(arguments, 2), (r = function r() {
              return e.apply(t || this, i.concat(s.call(arguments)));
            }).guid = e.guid = e.guid || _k.guid++, r;
          }, _k.holdReady = function (e) {
            e ? _k.readyWait++ : _k.ready(!0);
          }, _k.isArray = Array.isArray, _k.parseJSON = JSON.parse, _k.nodeName = S, _k.isFunction = m, _k.isWindow = y, _k.camelCase = ie, _k.type = C, _k.now = Date.now, _k.isNumeric = function (e) {
            var t = _k.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
          }, _k.trim = function (e) {
            return null == e ? "" : (e + "").replace(nn, "$1");
          }, void 0 === (n = function () {
            return _k;
          }.apply(t, [])) || (e.exports = n);
          var rn = i.jQuery,
            on = i.$;
          return _k.noConflict = function (e) {
            return i.$ === _k && (i.$ = on), e && i.jQuery === _k && (i.jQuery = rn), _k;
          }, void 0 === r && (i.jQuery = i.$ = _k), _k;
        });
      },
      6336: function _() {},
      1927: function _(e, t, n) {
        !function (e) {
          var t = function t(e) {
            var t,
              n,
              i = {};
            if ("" === e) return {};
            for (t = 0; t < e.length; t += 1) 2 === (n = e[t].split("=")).length && (i[n[0]] = decodeURIComponent(n[1].replace(/\+/g, " ")));
            return i;
          };
          e.queryParams = function () {
            return t(window.location.search.substr(1).split("&"));
          }, e.hashParams = function () {
            return t(window.location.hash.substr(1).split("&"));
          };
          var n = 0;
          window.Swiftype = window.Swiftype || {}, Swiftype.root_url = Swiftype.root_url || "https://api.swiftype.com", Swiftype.pingUrl = function (e, t) {
            var n = setTimeout(t, 350),
              i = new Image();
            return i.onload = i.onerror = function () {
              clearTimeout(n), t();
            }, i.src = e, !1;
          }, Swiftype.pingAutoSelection = function (t, n, i, r) {
            var o = {
                t: new Date().getTime(),
                engine_key: t,
                doc_id: n,
                prefix: i
              },
              a = Swiftype.root_url + "/api/v1/public/analytics/pas?" + e.param(o);
            Swiftype.pingUrl(a, r);
          }, Swiftype.findSelectedSection = function () {
            var t = e.hashParams().sts;
            function n(e) {
              var t = e.replace(/\s+/g, "");
              return t = t.toLowerCase();
            }
            t && (t = n(t), e("h1, h2, h3, h4, h5, h6").each(function (i) {
              if ($this = e(this), n($this.text()).indexOf(t) >= 0) return this.scrollIntoView(!0), !1;
            }));
          }, Swiftype.htmlEscape = Swiftype.htmlEscape || function (e) {
            return String(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
          }, e.fn.swiftype = function (t) {
            Swiftype.findSelectedSection();
            t = e.extend({}, e.fn.swiftype.defaults, t);
            return this.each(function () {
              var r = e(this),
                a = e.meta ? e.extend({}, t, r.data()) : t;
              r.attr("autocomplete", "off"), r.data("swiftype-config-autocomplete", a), r.submitted = !1, r.cache = new l(10), r.emptyQueries = [], r.isEmpty = function (t) {
                return e.inArray(i(t), this.emptyQueries) >= 0;
              }, r.addEmpty = function (e) {
                r.emptyQueries.unshift(i(e));
              };
              var u = a.dropdownStylesFunction(r),
                c = e('<div class="' + a.widgetContainerClass + '" />'),
                f = e("<div />").addClass(a.suggestionListClass).appendTo(c).css(u).hide();
              c.appendTo(a.autocompleteContainingElement);
              var d,
                p = e("<" + a.suggestionListType + " />").appendTo(f);
              r.data("swiftype-list", p), r.abortCurrent = function () {
                r.currentRequest && r.currentRequest.abort();
              }, r.showList = function () {
                !1 === s(a.disableAutocomplete) && f.show();
              }, r.hideList = function (e) {
                e ? f.hide() : setTimeout(function () {
                  f.hide();
                }, 10);
              }, r.showNoResults = function () {
                p.empty(), void 0 === a.noResultsMessage ? r.hideList() : (p.append(e("<li />", {
                  "class": a.noResultsClass
                }).text(a.noResultsMessage)), r.showList());
              }, r.focused = function () {
                return r.is(":focus");
              }, r.submitting = function () {
                r.submitted = !0;
              }, r.listResults = function () {
                return e(a.resultListSelector, p).filter(":not(." + a.noResultsClass + ")");
              }, r.activeResult = function () {
                return r.listResults().filter("." + a.activeItemClass).first();
              }, r.prevResult = function () {
                var e = r.listResults(),
                  t = e.index(r.activeResult()) - 1,
                  n = e.eq(t);
                r.listResults().removeClass(a.activeItemClass), t >= 0 && n.addClass(a.activeItemClass);
              }, r.nextResult = function () {
                var e = r.listResults(),
                  t = e.index(r.activeResult()) + 1,
                  n = e.eq(t);
                r.listResults().removeClass(a.activeItemClass), t >= 0 && n.addClass(a.activeItemClass);
              }, r.selectedCallback = function (e) {
                return function () {
                  var t = r.val();
                  Swiftype.pingAutoSelection(a.engineKey, e.id, t, function () {
                    a.onComplete(e, t);
                  });
                };
              }, r.registerResult = function (e, t) {
                e.data("swiftype-item", t), e.click(r.selectedCallback(t)).mouseover(function () {
                  r.listResults().removeClass(a.activeItemClass), e.addClass(a.activeItemClass);
                });
              }, r.getContext = function () {
                return {
                  config: a,
                  list: p,
                  registerResult: r.registerResult
                };
              };
              var h = !1;
              r.lastValue = "", r.keyup(function (e) {
                h ? h = !1 : e.which > 36 && e.which < 41 || 16 == e.which || (a.typingDelay > 0 ? (clearTimeout(d), d = setTimeout(function () {
                  o(r);
                }, a.typingDelay)) : o(r));
              }), r.styleDropdown = function () {
                f.css(a.dropdownStylesFunction(r));
              }, e(window).resize(function (e) {
                r.styleDropdown();
              }), r.keydown(function (e) {
                r.styleDropdown();
                var t = r.activeResult();
                switch (e.which) {
                  case 13:
                    0 !== t.length && p.is(":visible") ? (e.preventDefault(), r.selectedCallback(t.data("swiftype-item"))()) : r.currentRequest && r.submitting(), r.hideList(), h = !0;
                    break;
                  case 38:
                    e.preventDefault(), 0 === t.length ? r.listResults().last().addClass(a.activeItemClass) : r.prevResult();
                    break;
                  case 40:
                    e.preventDefault(), 0 === t.length ? r.listResults().first().addClass(a.activeItemClass) : t != r.listResults().last() && r.nextResult();
                    break;
                  case 27:
                    r.hideList(), h = !0;
                    break;
                  default:
                    r.submitted = !1;
                }
              }), r.keypress(function (e) {
                13 == e.which && r.activeResult().length > 0 && e.preventDefault();
              });
              var v = !1,
                g = !1;
              e(document).bind("mousedown.swiftype" + ++n, function () {
                v = !0;
              }), e(document).bind("mouseup.swiftype" + n, function () {
                v = !1, g && (g = !1, r.hideList());
              }), r.blur(function () {
                v ? g = !0 : r.hideList();
              }), r.focus(function () {
                setTimeout(function () {
                  r.select();
                }, 10), r.listResults().length > 0 && r.showList();
              });
            });
          };
          var i = function i(t) {
              return e.trim(t).toLowerCase();
            },
            r = function r(t, n) {
              var r = i(n);
              if (t.isEmpty(r)) t.showNoResults();else {
                var o = t.cache.get(r);
                o ? a(t, o, n) : function (t, n) {
                  t.abortCurrent();
                  var r = {},
                    o = t.data("swiftype-config-autocomplete");
                  r.q = n, r.engine_key = o.engineKey, r.search_fields = s(o.searchFields), r.fetch_fields = s(o.fetchFields), r.filters = s(o.filters), r.document_types = s(o.documentTypes), r.functional_boosts = s(o.functionalBoosts), r.sort_field = s(o.sortField), r.sort_direction = s(o.sortDirection), r.per_page = o.resultLimit, r.highlight_fields = o.highlightFields;
                  var l = Swiftype.root_url + "/api/v1/public/engines/suggest.json";
                  t.currentRequest = e.ajax({
                    type: "GET",
                    dataType: "jsonp",
                    url: l,
                    data: r
                  }).done(function (e) {
                    var r = i(n);
                    if (!(e.record_count > 0)) return t.addEmpty(r), void t.showNoResults();
                    t.cache.put(r, e.records), a(t, e.records, n);
                  });
                }(t, n);
              }
            },
            o = function o(t) {
              var n = t.val();
              if (n !== t.lastValue) {
                if (t.lastValue = n, "" === e.trim(n)) return t.data("swiftype-list").empty(), void t.hideList();
                void 0 !== t.data("swiftype-config-autocomplete").engineKey && r(t, n);
              }
            },
            a = function a(e, t, n) {
              var i = e.data("swiftype-list"),
                r = e.data("swiftype-config-autocomplete");
              i.empty(), e.hideList(!0), r.resultRenderFunction(e.getContext(), t), (e.listResults().length > 0 && e.focused() || void 0 !== r.noResultsMessage) && (e.submitted ? e.submitted = !1 : e.showList());
            },
            s = function s(e) {
              if (void 0 !== e) {
                var t = e;
                return "function" == typeof t && (t = t.call()), t;
              }
            };
          function l(e) {
            this.size = 0, this.limit = e, this._keymap = {};
          }
          l.prototype.put = function (e, t) {
            var n = {
              key: e,
              value: t
            };
            if (this._keymap[e] = n, this.tail ? (this.tail.newer = n, n.older = this.tail) : this.head = n, this.tail = n, this.size === this.limit) return this.shift();
            this.size++;
          }, l.prototype.shift = function () {
            var e = this.head;
            return e && (this.head.newer ? (this.head = this.head.newer, this.head.older = void 0) : this.head = void 0, e.newer = e.older = void 0, delete this._keymap[e.key]), e;
          }, l.prototype.get = function (e, t) {
            var n = this._keymap[e];
            if (void 0 !== n) return n === this.tail ? n.value : (n.newer && (n === this.head && (this.head = n.newer), n.newer.older = n.older), n.older && (n.older.newer = n.newer), n.newer = void 0, n.older = this.tail, this.tail && (this.tail.newer = n), this.tail = n, t ? n : n.value);
          }, l.prototype.remove = function (e) {
            var t = this._keymap[e];
            if (t) return delete this._keymap[t.key], t.newer && t.older ? (t.older.newer = t.newer, t.newer.older = t.older) : t.newer ? (t.newer.older = void 0, this.head = t.newer) : t.older ? (t.older.newer = void 0, this.tail = t.older) : this.head = this.tail = void 0, this.size--, t.value;
          }, l.prototype.clear = function () {
            this.head = this.tail = void 0, this.size = 0, this._keymap = {};
          }, "function" == typeof Object.keys ? l.prototype.keys = function () {
            return Object.keys(this._keymap);
          } : l.prototype.keys = function () {
            var e = [];
            for (var t in this._keymap) e.push(t);
            return e;
          }, e.fn.swiftype.defaults = {
            activeItemClass: "active",
            attachTo: void 0,
            documentTypes: void 0,
            filters: void 0,
            engineKey: void 0,
            searchFields: void 0,
            functionalBoosts: void 0,
            sortField: void 0,
            sortDirection: void 0,
            fetchFields: void 0,
            highlightFields: void 0,
            noResultsClass: "noResults",
            noResultsMessage: void 0,
            onComplete: function onComplete(e, t) {
              window.location = e.url;
            },
            resultRenderFunction: function resultRenderFunction(t, n) {
              var i = t.list,
                r = t.config;
              e.each(n, function (n, o) {
                e.each(o, function (o, a) {
                  t.registerResult(e("<li>" + r.renderFunction(n, a) + "</li>").appendTo(i), a);
                });
              });
            },
            renderFunction: function renderFunction(e, t) {
              return '<p class="title">' + Swiftype.htmlEscape(t.title) + "</p>";
            },
            dropdownStylesFunction: function dropdownStylesFunction(t) {
              var n = t.data("swiftype-config-autocomplete"),
                i = n.attachTo ? e(n.attachTo) : t,
                r = i.offset(),
                o = {
                  position: "absolute",
                  "z-index": 9999,
                  top: r.top + i.outerHeight() + 1,
                  left: r.left
                };
              return n.setWidth && (o.width = i.outerWidth() - 2), o;
            },
            resultLimit: void 0,
            suggestionListType: "ul",
            suggestionListClass: "autocomplete",
            resultListSelector: "li",
            setWidth: !0,
            typingDelay: 80,
            disableAutocomplete: !1,
            autocompleteContainingElement: "body",
            widgetContainerClass: "swiftype-widget"
          };
        }(n(4692));
      }
    },
    t = {};
  function n(i) {
    var r = t[i];
    if (void 0 !== r) return r.exports;
    var o = t[i] = {
      exports: {}
    };
    return e[i].call(o.exports, o, o.exports, n), o.exports;
  }
  !function () {
    "use strict";

    n(6336), n(1927);
    var e = n(4692);
    var t = function () {
      function t(t) {
        var n = e("body,html"),
          i = window.matchMedia(window.FUtils.largeBreakpoint),
          r = t.find(".nav-item__button"),
          o = t.find(".nav-item"),
          a = t.find(".navigation__lower-banner"),
          s = e(".navigation-space"),
          l = e(".skip-content"),
          u = e(".root-container div > div").not(":first-child"),
          c = t.find(".open__search-bar"),
          f = t.find(".close__search-bar"),
          d = e(".desktop-search__input-wrapper"),
          p = e("[role=main] .root-container .aem-Grid .hero:eq(0)"),
          h = e("[role=main] .root-container .aem-Grid .root-container:eq(0)"),
          v = e("[role=main] .root-container .aem-Grid .experiencefragment:eq(1)");
        var g = 80,
          m = !1,
          y = !1,
          b = 0;
        function x() {
          var e = t.find(".nav-item__secondary");
          if (i.matches) e.outerHeight("");else {
            var _n2 = window.innerHeight,
              _i2 = t.find(".navigation__mobile-bar-wrapper").height(),
              _r = t.hasClass("navigation--active-lower-banner") ? a.height() : 0;
            e.outerHeight(_n2 - _i2 - _r);
          }
        }
        function w() {
          var e = t.find(".nav-item__secondary"),
            n = e.find(".navigation__mobile-content"),
            r = t.find("button[aria-controls=nav-container]");
          var o;
          i.matches ? (r.closest(".navigation").append(t.find("#nav-container").detach()), r.closest(".navigation").find("#nav-container").css("position", "static")) : (r.closest("div").append(t.find("#nav-container").detach()), r.parent("div").find("#nav-container").css("position", "fixed"), 0 === n.length && (o = t.find(".navigation__mobile-content").clone(), e.append(o)));
        }
        function C() {
          g = 80, a.remove(), s.removeClass("navigation-space--has-lower-banner"), t.removeClass("navigation--active-lower-banner"), x();
        }
        function T(t) {
          var n = t.find(".nav-section--is-active").not(".nav-section--non-clickable");
          n.length > 0 && n.each(function (t, n) {
            e(n).removeClass("nav-section--is-active").find(".nav-section__title").attr("aria-expanded", "false");
          });
        }
        function k(n) {
          n.preventDefault();
          var r = e(n.currentTarget),
            o = r.closest(".nav-item");
          return o.siblings().find(".nav-item__button").blur(), r.attr("aria-expanded", "true"), o.addClass("nav-item--is-active"), o.find(".nav-item__secondary").removeClass("d-none"), i.matches ? o.find(".nav-item__secondary").clearQueue().finish().animate({
            opacity: 1,
            top: g
          }, 200) : (o.siblings().addClass("d-none"), o.find("> a").addClass("d-none"), t.find(".navigation__nav-wrapper > .navigation__mobile-content").addClass("d-none").removeClass("d-flex"), t.find(".navigation__nav-wrapper > .mobile-search").addClass("d-none"), o.find(".nav-item__secondary button").focus()), !0;
        }
        function _(e) {
          e.preventDefault();
          var n = t.find(".desktop-search__input-wrapper");
          n.toggleClass("d-none"), t.find(".navigation__nav--main").toggleClass("invisible"), n.hasClass("d-none") ? (c.focus(), t.find(".desktop-search__options-wrapper").addClass("d-none")) : n.find("input").focus();
        }
        function S(e) {
          e.preventDefault();
          var n = t.find(".desktop-search__input-wrapper");
          n.toggleClass("d-none"), t.find(".navigation__nav--main").toggleClass("invisible"), n.hasClass("d-none") && setTimeout(function () {
            t.find(".desktop-search__options-wrapper").addClass("d-none");
          }, 500);
        }
        function E() {
          t.find(".mobile-search__input-wrapper input").attr("aria-expanded", "false").val(""), t.find(".desktop-search__input-wrapper input").attr("aria-expanded", "false").val(""), t.find(".desktop-search__options-title").remove(), t.find(".mobile-search__options-title").remove(), t.find(".swiftype-widget .autocomplete ul li").remove(), t.find(".navigation__nav--main").removeClass("invisible"), t.find(".desktop-search__options-wrapper").addClass("d-none"), t.find(".desktop-search__input-wrapper").addClass("d-none");
        }
        function D() {
          var n = t.find(".nav-item--is-active");
          n.length > 0 && n.each(function (n, r) {
            var a = e(r);
            a.find(".nav-item__button").attr("aria-expanded", "false"), i.matches ? a.find(".nav-item__secondary").clearQueue().stop().animate({
              opacity: 0,
              top: 18
            }, 150, function () {
              a.removeClass("nav-item--is-active"), a.find(".nav-item__secondary").addClass("d-none");
            }) : (o.removeClass("d-none"), o.find("> a").removeClass("d-none"), t.find(".navigation__nav-wrapper > .navigation__mobile-content").removeClass("d-none"), t.find(".navigation__nav-wrapper > .mobile-search").removeClass("d-none"), a.find(".nav-item__secondary").addClass("d-none"), a.removeClass("nav-item--is-active"), a.find(".nav-item__button").focus());
          });
        }
        function A() {
          t.hasClass("navigation--is-active") && (n.removeClass("noscroll"), t.removeClass("navigation--is-active"), D(), T(t), p.removeClass("d-none"), h.removeClass("d-none"), v.removeClass("d-none"));
        }
        function j() {
          t.hasClass("navigation--is-active") ? (t.find(".mobile-bar__toggler-button").attr("aria-label", "Toggle main menu"), t.find(".mobile-bar__toggler-button").attr("aria-expanded", "false"), A(), window.scrollTo(0, b)) : (b = window.scrollY, t.find(".mobile-bar__toggler-button").attr("aria-label", "Close main menu"), t.find(".mobile-bar__toggler-button").attr("aria-expanded", "true"), t.addClass("navigation--is-active"), n.addClass("noscroll"), p.addClass("d-none"), h.addClass("d-none"), v.addClass("d-none"));
        }
        function L(t) {
          var n = e(t.currentTarget).closest(".nav-item");
          D(), T(n);
        }
        function N(t) {
          var n = e(t.currentTarget);
          e.contains(n.get(0), t.relatedTarget) || D();
        }
        function R(t) {
          var n = e(t.currentTarget),
            i = n.closest(".nav-section"),
            r = i.hasClass("nav-section--is-active");
          n.attr("aria-expanded", !r), r ? i.removeClass("nav-section--is-active") : i.addClass("nav-section--is-active");
        }
        function q() {
          e(window).off("mousemove"), r.off("mouseenter").on("mouseenter", k), o.off("mouseleave").on("mouseleave", D);
        }
        function H() {
          u.off("touchstart"), D();
        }
        function O(n) {
          var i = e(n.currentTarget).closest(".nav-item");
          n.preventDefault(), n.stopPropagation(), i.hasClass("nav-item--is-active") ? D() : (u.off("touchstart").on("touchstart", H), t.find(".nav-item--is-active").length > 0 && D(), k(n));
        }
        function M(t) {
          var n = e(t.currentTarget).closest(".nav-item");
          t.preventDefault(), n.hasClass("nav-item--is-active") ? (r.off("mouseenter"), D()) : (o.off("mouseleave"), k(t)), e(window).on("mousemove", q);
        }
        function F(n) {
          var i = t.find(".mobile-search__input-wrapper input"),
            r = ".mobile-search__options-list",
            o = "mobile-search__result-link",
            a = "mobile-search__options-title",
            s = "m-result";
          "desktop" === n ? (y = !0, i = t.find(".desktop-search__input-wrapper input"), r = ".desktop-search__options-list", o = "desktop-search__result-link", a = "desktop-search__options-title", s = "d-result") : m = !0, i.swiftype({
            engineKey: "B-yfaMJAXKMyzyDV7vvB",
            resultLimit: 6,
            setWidth: !1,
            autocompleteContainingElement: r,
            noResultsMessage: "No results found",
            fetchFields: {
              page: ["sections", "url"]
            },
            searchFields: {
              page: ["sections"]
            },
            renderFunction: function renderFunction(e, t) {
              return "<div data-href='".concat(Swiftype.htmlEscape(t.url), "' class='").concat(o, " d-block'>").concat(t.sections[0], "</div>");
            },
            resultRenderFunction: function resultRenderFunction(n, r) {
              var o = n.list,
                l = n.config;
              e.each(r, function (t, i) {
                e.each(i, function (i, r) {
                  n.registerResult(e("<li role=\"option\" id=\"".concat(s, "-").concat(i, "\">").concat(l.renderFunction(t, r), "</li>")).appendTo(o), r);
                });
              }), 0 === e("." + a).length && t.find(".swiftype-widget .autocomplete").prepend("<div class='".concat(a, " px-3 py-2'>SUGGESTED PAGES</div>")), o.attr("role", "listbox"), i.attr("aria-expanded", "true"), t.find(".desktop-search__options-wrapper").removeClass("d-none");
            },
            dropdownStylesFunction: function dropdownStylesFunction() {
              return {};
            },
            onComplete: function onComplete(e) {
              E(), window.location = e.url;
            }
          });
        }
        function P(t) {
          var n = e(this).attr("href");
          t.preventDefault(), n && (window.location = n);
        }
        function I() {
          t.find(".sub-menu--list a").on("touchend", P), "ontouchstart" in document.documentElement ? r.on("touchstart", O) : (r.off("click").on("click", M), r.on("mouseenter", k), o.on("mouseleave", D), o.on("focusout", N)), t.find(".nav-section__title").removeAttr("role aria-expanded tabindex aria-haspopup"), t.find(".nav-item--has-secondary").off("click", ".nav-section--is-clickable .nav-section__title"), t.find(".nav-item--has-secondary").off("keydown", ".nav-section--is-clickable .nav-section__title"), t.find(".mobile-bar__login").off("keydown"), y || F("desktop");
        }
        function W() {
          r.off("mouseenter"), r.off("click").on("click", k), o.off("focusout"), o.off("mouseleave"), t.find(".nav-section__title").attr("role", "button").attr("aria-haspopup", "true").attr("tabindex", "0").attr("aria-expanded", "false"), t.find(".nav-item--has-secondary").on("click", ".nav-section--is-clickable .nav-section__title", R), t.find(".nav-item--has-secondary").on("keydown", ".nav-section--is-clickable .nav-section__title", function (e) {
            var t = e.keyCode || e.which;
            t !== window.FUtils.keys.space && t !== window.FUtils.keys.enter || R(e);
          }), t.find(".mobile-bar__login").on("keydown", function (e) {
            (e.keyCode || e.which) === window.FUtils.wkeys.tab && t.hasClass("navigation--is-active") && (e.preventDefault(), t.find(".mobile-bar__toggler-button").focus());
          }), m || F("mobile");
        }
        function $(e) {
          w(), e.matches ? (A(), I()) : (D(), W(), t.find(".nav-item .nav-item__secondary").css({
            opacity: "",
            top: ""
          })), E();
        }
        function B() {
          t.addClass("navigation--active-skip");
        }
        function z() {
          t.removeClass("navigation--active-skip");
        }
        function U(t) {
          var n = e(t.currentTarget),
            r = "submit" === t.type || n.hasClass("mobile-search__result-link"),
            o = "#" !== n.attr("href") && "" !== n.attr("href");
          !r && !o || i.matches || A();
        }
        function X(t) {
          var n = t.keyCode || t.which,
            i = e(t.currentTarget),
            r = i.closest(".nav-item__search"),
            o = r.find(".desktop-search__options-wrapper li"),
            a = r.find(".desktop-search__options-wrapper li.noResults"),
            s = r.find(".desktop-search__options-wrapper li.active");
          var l;
          switch (n) {
            case window.FUtils.keys.up:
              0 === s.length ? l = o.last() : s.length > 0 && 1 === o.length ? l = void 0 : s.length > 0 && o.length > 1 && (l = s.prev()), o.removeAttr("aria-selected"), i.attr("aria-activedescendant", "");
              break;
            case window.FUtils.keys.down:
              0 === s.length ? l = o.first() : s.length > 0 && 1 === o.length ? l = void 0 : s.length > 0 && o.length > 1 && (l = s.next()), o.removeAttr("aria-selected"), i.attr("aria-activedescendant", "");
              break;
            case window.FUtils.keys.escape:
              "none" === r.find(".autocomplete").css("display") && i.attr("aria-expanded", "false");
          }
          void 0 !== l && l.length > 0 ? (l.hasClass("noResults") && l.attr("id", "noResults").attr("role", "option").addClass("active"), l.attr("aria-selected", "true"), i.attr("aria-activedescendant", l.attr("id")), r.find(".autocomplete").scrollTop(50)) : a.removeClass("active");
        }
        function V(t) {
          e(t.currentTarget).attr("aria-expanded", "false");
        }
        function G(t) {
          var n = e(t.currentTarget);
          "none" !== n.closest(".nav-item__search").find(".autocomplete").css("display") && n.attr("aria-expanded", "true");
        }
        function Q(t) {
          var n = e(t.currentTarget),
            i = n.closest(".nav-item__search").find("input");
          n.siblings().removeAttr("aria-selected"), n.attr("aria-selected", "true"), i.attr("aria-activedescendant", n.attr("id"));
        }
        t.find(".mobile-bar__toggler-button").on("click", j), t.find(".nav-item__secondary-close").on("click", L), t.on("click", "a, .mobile-search__result-link", U), t.find(".mobile-search form").on("submit", U), e(window).on("resize", x), c.on("click", _), f.on("click", _), d.on("focusout", S), t.find(".desktop-search__input-wrapper input").on("keydown", X), t.find(".desktop-search__input-wrapper input").on("blur", V), t.find(".desktop-search__input-wrapper input").on("focus", G), t.find(".desktop-search__options-list").on("mouseover", "li", Q), i.addEventListener("change", $), l.length > 0 && (l.on("focusin", B), l.on("focusout", z)), i.matches ? I() : W(), function () {
          var n = t.find(".nav-section");
          n.length > 0 && n.each(function (t, n) {
            var i = e(n),
              r = i.find(".c-article-card").length > 0,
              o = i.find(".button-cta").length > 0;
            r || o ? i.addClass("nav-section--is-active nav-section--non-clickable") : i.addClass("nav-section--is-clickable");
          });
        }(), function () {
          var e = window.location.hostname.indexOf("csst") >= 0;
          a.length > 0 && e && (g = 130, s.addClass("navigation-space--has-lower-banner"), a.removeClass("d-none"), a.find(".navigation__lower-banner-button").on("click", C));
        }(), w(), x();
      }
      return {
        init: function init() {
          var n = e('.navigation:not([data-component-state="initialized"])');
          n.length > 0 && n.each(function (n, i) {
            t(e(i)), e(i).attr("data-component-state", "initialized");
          });
        }
      };
    }();
    document.addEventListener("DOMContentLoaded", function () {
      t.init();
    });
  }();
}();
!function () {
  var e = {
      3958: function _(e, t, n) {
        var r = n(4692);
        ({
          init: function init() {
            var e = r('.skip-content:not([data-component-state="initialized"])');
            e && e.each(function (e, t) {
              !function () {
                var e = r("h1");
                e && e.attr("id", "main-content1");
              }(), r(t).attr("data-component-state", "initialized");
            });
          }
        }).init();
      },
      4692: function _(e, t) {
        var n;
        !function (t, n) {
          "use strict";

          "object" == _typeof(e.exports) ? e.exports = t.document ? n(t, !0) : function (e) {
            if (!e.document) throw new Error("jQuery requires a window with a document");
            return n(e);
          } : n(t);
        }("undefined" != typeof window ? window : this, function (r, i) {
          "use strict";

          var o = [],
            a = Object.getPrototypeOf,
            s = o.slice,
            u = o.flat ? function (e) {
              return o.flat.call(e);
            } : function (e) {
              return o.concat.apply([], e);
            },
            l = o.push,
            c = o.indexOf,
            f = {},
            p = f.toString,
            d = f.hasOwnProperty,
            h = d.toString,
            g = h.call(Object),
            v = {},
            y = function y(e) {
              return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
            },
            m = function m(e) {
              return null != e && e === e.window;
            },
            x = r.document,
            b = {
              type: !0,
              src: !0,
              nonce: !0,
              noModule: !0
            };
          function w(e, t, n) {
            var r,
              i,
              o = (n = n || x).createElement("script");
            if (o.text = e, t) for (r in b) (i = t[r] || t.getAttribute && t.getAttribute(r)) && o.setAttribute(r, i);
            n.head.appendChild(o).parentNode.removeChild(o);
          }
          function T(e) {
            return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? f[p.call(e)] || "object" : _typeof(e);
          }
          var C = /HTML$/i,
            _S = function S(e, t) {
              return new _S.fn.init(e, t);
            };
          function k(e) {
            var t = !!e && "length" in e && e.length,
              n = T(e);
            return !y(e) && !m(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
          }
          function E(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
          }
          _S.fn = _S.prototype = {
            jquery: "3.7.1",
            constructor: _S,
            length: 0,
            toArray: function toArray() {
              return s.call(this);
            },
            get: function get(e) {
              return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
            },
            pushStack: function pushStack(e) {
              var t = _S.merge(this.constructor(), e);
              return t.prevObject = this, t;
            },
            each: function each(e) {
              return _S.each(this, e);
            },
            map: function map(e) {
              return this.pushStack(_S.map(this, function (t, n) {
                return e.call(t, n, t);
              }));
            },
            slice: function slice() {
              return this.pushStack(s.apply(this, arguments));
            },
            first: function first() {
              return this.eq(0);
            },
            last: function last() {
              return this.eq(-1);
            },
            even: function even() {
              return this.pushStack(_S.grep(this, function (e, t) {
                return (t + 1) % 2;
              }));
            },
            odd: function odd() {
              return this.pushStack(_S.grep(this, function (e, t) {
                return t % 2;
              }));
            },
            eq: function eq(e) {
              var t = this.length,
                n = +e + (e < 0 ? t : 0);
              return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
            },
            end: function end() {
              return this.prevObject || this.constructor();
            },
            push: l,
            sort: o.sort,
            splice: o.splice
          }, _S.extend = _S.fn.extend = function () {
            var e,
              t,
              n,
              r,
              i,
              o,
              a = arguments[0] || {},
              s = 1,
              u = arguments.length,
              l = !1;
            for ("boolean" == typeof a && (l = a, a = arguments[s] || {}, s++), "object" == _typeof(a) || y(a) || (a = {}), s === u && (a = this, s--); s < u; s++) if (null != (e = arguments[s])) for (t in e) r = e[t], "__proto__" !== t && a !== r && (l && r && (_S.isPlainObject(r) || (i = Array.isArray(r))) ? (n = a[t], o = i && !Array.isArray(n) ? [] : i || _S.isPlainObject(n) ? n : {}, i = !1, a[t] = _S.extend(l, o, r)) : void 0 !== r && (a[t] = r));
            return a;
          }, _S.extend({
            expando: "jQuery" + ("3.7.1" + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function error(e) {
              throw new Error(e);
            },
            noop: function noop() {},
            isPlainObject: function isPlainObject(e) {
              var t, n;
              return !(!e || "[object Object]" !== p.call(e)) && (!(t = a(e)) || "function" == typeof (n = d.call(t, "constructor") && t.constructor) && h.call(n) === g);
            },
            isEmptyObject: function isEmptyObject(e) {
              var t;
              for (t in e) return !1;
              return !0;
            },
            globalEval: function globalEval(e, t, n) {
              w(e, {
                nonce: t && t.nonce
              }, n);
            },
            each: function each(e, t) {
              var n,
                r = 0;
              if (k(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
              return e;
            },
            text: function text(e) {
              var t,
                n = "",
                r = 0,
                i = e.nodeType;
              if (!i) for (; t = e[r++];) n += _S.text(t);
              return 1 === i || 11 === i ? e.textContent : 9 === i ? e.documentElement.textContent : 3 === i || 4 === i ? e.nodeValue : n;
            },
            makeArray: function makeArray(e, t) {
              var n = t || [];
              return null != e && (k(Object(e)) ? _S.merge(n, "string" == typeof e ? [e] : e) : l.call(n, e)), n;
            },
            inArray: function inArray(e, t, n) {
              return null == t ? -1 : c.call(t, e, n);
            },
            isXMLDoc: function isXMLDoc(e) {
              var t = e && e.namespaceURI,
                n = e && (e.ownerDocument || e).documentElement;
              return !C.test(t || n && n.nodeName || "HTML");
            },
            merge: function merge(e, t) {
              for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
              return e.length = i, e;
            },
            grep: function grep(e, t, n) {
              for (var r = [], i = 0, o = e.length, a = !n; i < o; i++) !t(e[i], i) !== a && r.push(e[i]);
              return r;
            },
            map: function map(e, t, n) {
              var r,
                i,
                o = 0,
                a = [];
              if (k(e)) for (r = e.length; o < r; o++) null != (i = t(e[o], o, n)) && a.push(i);else for (o in e) null != (i = t(e[o], o, n)) && a.push(i);
              return u(a);
            },
            guid: 1,
            support: v
          }), "function" == typeof Symbol && (_S.fn[Symbol.iterator] = o[Symbol.iterator]), _S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            f["[object " + t + "]"] = t.toLowerCase();
          });
          var j = o.pop,
            A = o.sort,
            D = o.splice,
            N = "[\\x20\\t\\r\\n\\f]",
            q = new RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g");
          _S.contains = function (e, t) {
            var n = t && t.parentNode;
            return e === n || !(!n || 1 !== n.nodeType || !(e.contains ? e.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)));
          };
          var L = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
          function H(e, t) {
            return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
          }
          _S.escapeSelector = function (e) {
            return (e + "").replace(L, H);
          };
          var O = x,
            P = l;
          !function () {
            var e,
              t,
              n,
              i,
              a,
              u,
              l,
              f,
              p,
              h,
              g = P,
              y = _S.expando,
              m = 0,
              x = 0,
              b = ee(),
              w = ee(),
              T = ee(),
              C = ee(),
              k = function k(e, t) {
                return e === t && (a = !0), 0;
              },
              L = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
              H = "(?:\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
              M = "\\[" + N + "*(" + H + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + H + "))|)" + N + "*\\]",
              R = ":(" + H + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + M + ")*)|.*)\\)|)",
              I = new RegExp(N + "+", "g"),
              W = new RegExp("^" + N + "*," + N + "*"),
              F = new RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"),
              $ = new RegExp(N + "|>"),
              B = new RegExp(R),
              _ = new RegExp("^" + H + "$"),
              z = {
                ID: new RegExp("^#(" + H + ")"),
                CLASS: new RegExp("^\\.(" + H + ")"),
                TAG: new RegExp("^(" + H + "|[*])"),
                ATTR: new RegExp("^" + M),
                PSEUDO: new RegExp("^" + R),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + L + ")$", "i"),
                needsContext: new RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)", "i")
              },
              X = /^(?:input|select|textarea|button)$/i,
              U = /^h\d$/i,
              V = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              G = /[+~]/,
              Y = new RegExp("\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\([^\\r\\n\\f])", "g"),
              Q = function Q(e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320));
              },
              J = function J() {
                ue();
              },
              K = pe(function (e) {
                return !0 === e.disabled && E(e, "fieldset");
              }, {
                dir: "parentNode",
                next: "legend"
              });
            try {
              g.apply(o = s.call(O.childNodes), O.childNodes), o[O.childNodes.length].nodeType;
            } catch (e) {
              g = {
                apply: function apply(e, t) {
                  P.apply(e, s.call(t));
                },
                call: function call(e) {
                  P.apply(e, s.call(arguments, 1));
                }
              };
            }
            function Z(e, t, n, r) {
              var i,
                o,
                a,
                s,
                l,
                c,
                d,
                h = t && t.ownerDocument,
                m = t ? t.nodeType : 9;
              if (n = n || [], "string" != typeof e || !e || 1 !== m && 9 !== m && 11 !== m) return n;
              if (!r && (ue(t), t = t || u, f)) {
                if (11 !== m && (l = V.exec(e))) if (i = l[1]) {
                  if (9 === m) {
                    if (!(a = t.getElementById(i))) return n;
                    if (a.id === i) return g.call(n, a), n;
                  } else if (h && (a = h.getElementById(i)) && Z.contains(t, a) && a.id === i) return g.call(n, a), n;
                } else {
                  if (l[2]) return g.apply(n, t.getElementsByTagName(e)), n;
                  if ((i = l[3]) && t.getElementsByClassName) return g.apply(n, t.getElementsByClassName(i)), n;
                }
                if (!(C[e + " "] || p && p.test(e))) {
                  if (d = e, h = t, 1 === m && ($.test(e) || F.test(e))) {
                    for ((h = G.test(e) && se(t.parentNode) || t) == t && v.scope || ((s = t.getAttribute("id")) ? s = _S.escapeSelector(s) : t.setAttribute("id", s = y)), o = (c = ce(e)).length; o--;) c[o] = (s ? "#" + s : ":scope") + " " + fe(c[o]);
                    d = c.join(",");
                  }
                  try {
                    return g.apply(n, h.querySelectorAll(d)), n;
                  } catch (t) {
                    C(e, !0);
                  } finally {
                    s === y && t.removeAttribute("id");
                  }
                }
              }
              return me(e.replace(q, "$1"), t, n, r);
            }
            function ee() {
              var e = [];
              return function n(r, i) {
                return e.push(r + " ") > t.cacheLength && delete n[e.shift()], n[r + " "] = i;
              };
            }
            function te(e) {
              return e[y] = !0, e;
            }
            function ne(e) {
              var t = u.createElement("fieldset");
              try {
                return !!e(t);
              } catch (e) {
                return !1;
              } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null;
              }
            }
            function re(e) {
              return function (t) {
                return E(t, "input") && t.type === e;
              };
            }
            function ie(e) {
              return function (t) {
                return (E(t, "input") || E(t, "button")) && t.type === e;
              };
            }
            function oe(e) {
              return function (t) {
                return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && K(t) === e : t.disabled === e : "label" in t && t.disabled === e;
              };
            }
            function ae(e) {
              return te(function (t) {
                return t = +t, te(function (n, r) {
                  for (var i, o = e([], n.length, t), a = o.length; a--;) n[i = o[a]] && (n[i] = !(r[i] = n[i]));
                });
              });
            }
            function se(e) {
              return e && void 0 !== e.getElementsByTagName && e;
            }
            function ue(e) {
              var n,
                r = e ? e.ownerDocument || e : O;
              return r != u && 9 === r.nodeType && r.documentElement ? (l = (u = r).documentElement, f = !_S.isXMLDoc(u), h = l.matches || l.webkitMatchesSelector || l.msMatchesSelector, l.msMatchesSelector && O != u && (n = u.defaultView) && n.top !== n && n.addEventListener("unload", J), v.getById = ne(function (e) {
                return l.appendChild(e).id = _S.expando, !u.getElementsByName || !u.getElementsByName(_S.expando).length;
              }), v.disconnectedMatch = ne(function (e) {
                return h.call(e, "*");
              }), v.scope = ne(function () {
                return u.querySelectorAll(":scope");
              }), v.cssHas = ne(function () {
                try {
                  return u.querySelector(":has(*,:jqfake)"), !1;
                } catch (e) {
                  return !0;
                }
              }), v.getById ? (t.filter.ID = function (e) {
                var t = e.replace(Y, Q);
                return function (e) {
                  return e.getAttribute("id") === t;
                };
              }, t.find.ID = function (e, t) {
                if (void 0 !== t.getElementById && f) {
                  var n = t.getElementById(e);
                  return n ? [n] : [];
                }
              }) : (t.filter.ID = function (e) {
                var t = e.replace(Y, Q);
                return function (e) {
                  var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                  return n && n.value === t;
                };
              }, t.find.ID = function (e, t) {
                if (void 0 !== t.getElementById && f) {
                  var n,
                    r,
                    i,
                    o = t.getElementById(e);
                  if (o) {
                    if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                    for (i = t.getElementsByName(e), r = 0; o = i[r++];) if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                  }
                  return [];
                }
              }), t.find.TAG = function (e, t) {
                return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : t.querySelectorAll(e);
              }, t.find.CLASS = function (e, t) {
                if (void 0 !== t.getElementsByClassName && f) return t.getElementsByClassName(e);
              }, p = [], ne(function (e) {
                var t;
                l.appendChild(e).innerHTML = "<a id='" + y + "' href='' disabled='disabled'></a><select id='" + y + "-\r\\' disabled='disabled'><option selected=''></option></select>", e.querySelectorAll("[selected]").length || p.push("\\[" + N + "*(?:value|" + L + ")"), e.querySelectorAll("[id~=" + y + "-]").length || p.push("~="), e.querySelectorAll("a#" + y + "+*").length || p.push(".#.+[+~]"), e.querySelectorAll(":checked").length || p.push(":checked"), (t = u.createElement("input")).setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), l.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && p.push(":enabled", ":disabled"), (t = u.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || p.push("\\[" + N + "*name" + N + "*=" + N + "*(?:''|\"\")");
              }), v.cssHas || p.push(":has"), p = p.length && new RegExp(p.join("|")), k = function k(e, t) {
                if (e === t) return a = !0, 0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n || (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !v.sortDetached && t.compareDocumentPosition(e) === n ? e === u || e.ownerDocument == O && Z.contains(O, e) ? -1 : t === u || t.ownerDocument == O && Z.contains(O, t) ? 1 : i ? c.call(i, e) - c.call(i, t) : 0 : 4 & n ? -1 : 1);
              }, u) : u;
            }
            for (e in Z.matches = function (e, t) {
              return Z(e, null, null, t);
            }, Z.matchesSelector = function (e, t) {
              if (ue(e), f && !C[t + " "] && (!p || !p.test(t))) try {
                var n = h.call(e, t);
                if (n || v.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n;
              } catch (e) {
                C(t, !0);
              }
              return Z(t, u, null, [e]).length > 0;
            }, Z.contains = function (e, t) {
              return (e.ownerDocument || e) != u && ue(e), _S.contains(e, t);
            }, Z.attr = function (e, n) {
              (e.ownerDocument || e) != u && ue(e);
              var r = t.attrHandle[n.toLowerCase()],
                i = r && d.call(t.attrHandle, n.toLowerCase()) ? r(e, n, !f) : void 0;
              return void 0 !== i ? i : e.getAttribute(n);
            }, Z.error = function (e) {
              throw new Error("Syntax error, unrecognized expression: " + e);
            }, _S.uniqueSort = function (e) {
              var t,
                n = [],
                r = 0,
                o = 0;
              if (a = !v.sortStable, i = !v.sortStable && s.call(e, 0), A.call(e, k), a) {
                for (; t = e[o++];) t === e[o] && (r = n.push(o));
                for (; r--;) D.call(e, n[r], 1);
              }
              return i = null, e;
            }, _S.fn.uniqueSort = function () {
              return this.pushStack(_S.uniqueSort(s.apply(this)));
            }, (t = _S.expr = {
              cacheLength: 50,
              createPseudo: te,
              match: z,
              attrHandle: {},
              find: {},
              relative: {
                ">": {
                  dir: "parentNode",
                  first: !0
                },
                " ": {
                  dir: "parentNode"
                },
                "+": {
                  dir: "previousSibling",
                  first: !0
                },
                "~": {
                  dir: "previousSibling"
                }
              },
              preFilter: {
                ATTR: function ATTR(e) {
                  return e[1] = e[1].replace(Y, Q), e[3] = (e[3] || e[4] || e[5] || "").replace(Y, Q), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                },
                CHILD: function CHILD(e) {
                  return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || Z.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && Z.error(e[0]), e;
                },
                PSEUDO: function PSEUDO(e) {
                  var t,
                    n = !e[6] && e[2];
                  return z.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && B.test(n) && (t = ce(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
                }
              },
              filter: {
                TAG: function TAG(e) {
                  var t = e.replace(Y, Q).toLowerCase();
                  return "*" === e ? function () {
                    return !0;
                  } : function (e) {
                    return E(e, t);
                  };
                },
                CLASS: function CLASS(e) {
                  var t = b[e + " "];
                  return t || (t = new RegExp("(^|" + N + ")" + e + "(" + N + "|$)")) && b(e, function (e) {
                    return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "");
                  });
                },
                ATTR: function ATTR(e, t, n) {
                  return function (r) {
                    var i = Z.attr(r, e);
                    return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace(I, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
                  };
                },
                CHILD: function CHILD(e, t, n, r, i) {
                  var o = "nth" !== e.slice(0, 3),
                    a = "last" !== e.slice(-4),
                    s = "of-type" === t;
                  return 1 === r && 0 === i ? function (e) {
                    return !!e.parentNode;
                  } : function (t, n, u) {
                    var l,
                      c,
                      f,
                      p,
                      d,
                      h = o !== a ? "nextSibling" : "previousSibling",
                      g = t.parentNode,
                      v = s && t.nodeName.toLowerCase(),
                      x = !u && !s,
                      b = !1;
                    if (g) {
                      if (o) {
                        for (; h;) {
                          for (f = t; f = f[h];) if (s ? E(f, v) : 1 === f.nodeType) return !1;
                          d = h = "only" === e && !d && "nextSibling";
                        }
                        return !0;
                      }
                      if (d = [a ? g.firstChild : g.lastChild], a && x) {
                        for (b = (p = (l = (c = g[y] || (g[y] = {}))[e] || [])[0] === m && l[1]) && l[2], f = p && g.childNodes[p]; f = ++p && f && f[h] || (b = p = 0) || d.pop();) if (1 === f.nodeType && ++b && f === t) {
                          c[e] = [m, p, b];
                          break;
                        }
                      } else if (x && (b = p = (l = (c = t[y] || (t[y] = {}))[e] || [])[0] === m && l[1]), !1 === b) for (; (f = ++p && f && f[h] || (b = p = 0) || d.pop()) && (!(s ? E(f, v) : 1 === f.nodeType) || !++b || (x && ((c = f[y] || (f[y] = {}))[e] = [m, b]), f !== t)););
                      return (b -= i) === r || b % r == 0 && b / r >= 0;
                    }
                  };
                },
                PSEUDO: function PSEUDO(e, n) {
                  var r,
                    i = t.pseudos[e] || t.setFilters[e.toLowerCase()] || Z.error("unsupported pseudo: " + e);
                  return i[y] ? i(n) : i.length > 1 ? (r = [e, e, "", n], t.setFilters.hasOwnProperty(e.toLowerCase()) ? te(function (e, t) {
                    for (var r, o = i(e, n), a = o.length; a--;) e[r = c.call(e, o[a])] = !(t[r] = o[a]);
                  }) : function (e) {
                    return i(e, 0, r);
                  }) : i;
                }
              },
              pseudos: {
                not: te(function (e) {
                  var t = [],
                    n = [],
                    r = ye(e.replace(q, "$1"));
                  return r[y] ? te(function (e, t, n, i) {
                    for (var o, a = r(e, null, i, []), s = e.length; s--;) (o = a[s]) && (e[s] = !(t[s] = o));
                  }) : function (e, i, o) {
                    return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop();
                  };
                }),
                has: te(function (e) {
                  return function (t) {
                    return Z(e, t).length > 0;
                  };
                }),
                contains: te(function (e) {
                  return e = e.replace(Y, Q), function (t) {
                    return (t.textContent || _S.text(t)).indexOf(e) > -1;
                  };
                }),
                lang: te(function (e) {
                  return _.test(e || "") || Z.error("unsupported lang: " + e), e = e.replace(Y, Q).toLowerCase(), function (t) {
                    var n;
                    do {
                      if (n = f ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                    } while ((t = t.parentNode) && 1 === t.nodeType);
                    return !1;
                  };
                }),
                target: function target(e) {
                  var t = r.location && r.location.hash;
                  return t && t.slice(1) === e.id;
                },
                root: function root(e) {
                  return e === l;
                },
                focus: function focus(e) {
                  return e === function () {
                    try {
                      return u.activeElement;
                    } catch (e) {}
                  }() && u.hasFocus() && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: oe(!1),
                disabled: oe(!0),
                checked: function checked(e) {
                  return E(e, "input") && !!e.checked || E(e, "option") && !!e.selected;
                },
                selected: function selected(e) {
                  return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function empty(e) {
                  for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                  return !0;
                },
                parent: function parent(e) {
                  return !t.pseudos.empty(e);
                },
                header: function header(e) {
                  return U.test(e.nodeName);
                },
                input: function input(e) {
                  return X.test(e.nodeName);
                },
                button: function button(e) {
                  return E(e, "input") && "button" === e.type || E(e, "button");
                },
                text: function text(e) {
                  var t;
                  return E(e, "input") && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                },
                first: ae(function () {
                  return [0];
                }),
                last: ae(function (e, t) {
                  return [t - 1];
                }),
                eq: ae(function (e, t, n) {
                  return [n < 0 ? n + t : n];
                }),
                even: ae(function (e, t) {
                  for (var n = 0; n < t; n += 2) e.push(n);
                  return e;
                }),
                odd: ae(function (e, t) {
                  for (var n = 1; n < t; n += 2) e.push(n);
                  return e;
                }),
                lt: ae(function (e, t, n) {
                  var r;
                  for (r = n < 0 ? n + t : n > t ? t : n; --r >= 0;) e.push(r);
                  return e;
                }),
                gt: ae(function (e, t, n) {
                  for (var r = n < 0 ? n + t : n; ++r < t;) e.push(r);
                  return e;
                })
              }
            }).pseudos.nth = t.pseudos.eq, {
              radio: !0,
              checkbox: !0,
              file: !0,
              password: !0,
              image: !0
            }) t.pseudos[e] = re(e);
            for (e in {
              submit: !0,
              reset: !0
            }) t.pseudos[e] = ie(e);
            function le() {}
            function ce(e, n) {
              var r,
                i,
                o,
                a,
                s,
                u,
                l,
                c = w[e + " "];
              if (c) return n ? 0 : c.slice(0);
              for (s = e, u = [], l = t.preFilter; s;) {
                for (a in r && !(i = W.exec(s)) || (i && (s = s.slice(i[0].length) || s), u.push(o = [])), r = !1, (i = F.exec(s)) && (r = i.shift(), o.push({
                  value: r,
                  type: i[0].replace(q, " ")
                }), s = s.slice(r.length)), t.filter) !(i = z[a].exec(s)) || l[a] && !(i = l[a](i)) || (r = i.shift(), o.push({
                  value: r,
                  type: a,
                  matches: i
                }), s = s.slice(r.length));
                if (!r) break;
              }
              return n ? s.length : s ? Z.error(e) : w(e, u).slice(0);
            }
            function fe(e) {
              for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
              return r;
            }
            function pe(e, t, n) {
              var r = t.dir,
                i = t.next,
                o = i || r,
                a = n && "parentNode" === o,
                s = x++;
              return t.first ? function (t, n, i) {
                for (; t = t[r];) if (1 === t.nodeType || a) return e(t, n, i);
                return !1;
              } : function (t, n, u) {
                var l,
                  c,
                  f = [m, s];
                if (u) {
                  for (; t = t[r];) if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
                } else for (; t = t[r];) if (1 === t.nodeType || a) if (c = t[y] || (t[y] = {}), i && E(t, i)) t = t[r] || t;else {
                  if ((l = c[o]) && l[0] === m && l[1] === s) return f[2] = l[2];
                  if (c[o] = f, f[2] = e(t, n, u)) return !0;
                }
                return !1;
              };
            }
            function de(e) {
              return e.length > 1 ? function (t, n, r) {
                for (var i = e.length; i--;) if (!e[i](t, n, r)) return !1;
                return !0;
              } : e[0];
            }
            function he(e, t, n, r, i) {
              for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++) (o = e[s]) && (n && !n(o, r, i) || (a.push(o), l && t.push(s)));
              return a;
            }
            function ge(e, t, n, r, i, o) {
              return r && !r[y] && (r = ge(r)), i && !i[y] && (i = ge(i, o)), te(function (o, a, s, u) {
                var l,
                  f,
                  p,
                  d,
                  h = [],
                  v = [],
                  y = a.length,
                  m = o || function (e, t, n) {
                    for (var r = 0, i = t.length; r < i; r++) Z(e, t[r], n);
                    return n;
                  }(t || "*", s.nodeType ? [s] : s, []),
                  x = !e || !o && t ? m : he(m, h, e, s, u);
                if (n ? n(x, d = i || (o ? e : y || r) ? [] : a, s, u) : d = x, r) for (l = he(d, v), r(l, [], s, u), f = l.length; f--;) (p = l[f]) && (d[v[f]] = !(x[v[f]] = p));
                if (o) {
                  if (i || e) {
                    if (i) {
                      for (l = [], f = d.length; f--;) (p = d[f]) && l.push(x[f] = p);
                      i(null, d = [], l, u);
                    }
                    for (f = d.length; f--;) (p = d[f]) && (l = i ? c.call(o, p) : h[f]) > -1 && (o[l] = !(a[l] = p));
                  }
                } else d = he(d === a ? d.splice(y, d.length) : d), i ? i(null, a, d, u) : g.apply(a, d);
              });
            }
            function ve(e) {
              for (var r, i, o, a = e.length, s = t.relative[e[0].type], u = s || t.relative[" "], l = s ? 1 : 0, f = pe(function (e) {
                  return e === r;
                }, u, !0), p = pe(function (e) {
                  return c.call(r, e) > -1;
                }, u, !0), d = [function (e, t, i) {
                  var o = !s && (i || t != n) || ((r = t).nodeType ? f(e, t, i) : p(e, t, i));
                  return r = null, o;
                }]; l < a; l++) if (i = t.relative[e[l].type]) d = [pe(de(d), i)];else {
                if ((i = t.filter[e[l].type].apply(null, e[l].matches))[y]) {
                  for (o = ++l; o < a && !t.relative[e[o].type]; o++);
                  return ge(l > 1 && de(d), l > 1 && fe(e.slice(0, l - 1).concat({
                    value: " " === e[l - 2].type ? "*" : ""
                  })).replace(q, "$1"), i, l < o && ve(e.slice(l, o)), o < a && ve(e = e.slice(o)), o < a && fe(e));
                }
                d.push(i);
              }
              return de(d);
            }
            function ye(e, r) {
              var i,
                o = [],
                a = [],
                s = T[e + " "];
              if (!s) {
                for (r || (r = ce(e)), i = r.length; i--;) (s = ve(r[i]))[y] ? o.push(s) : a.push(s);
                (s = T(e, function (e, r) {
                  var i = r.length > 0,
                    o = e.length > 0,
                    a = function a(_a2, s, l, c, p) {
                      var d,
                        h,
                        v,
                        y = 0,
                        x = "0",
                        b = _a2 && [],
                        w = [],
                        T = n,
                        C = _a2 || o && t.find.TAG("*", p),
                        k = m += null == T ? 1 : Math.random() || .1,
                        E = C.length;
                      for (p && (n = s == u || s || p); x !== E && null != (d = C[x]); x++) {
                        if (o && d) {
                          for (h = 0, s || d.ownerDocument == u || (ue(d), l = !f); v = e[h++];) if (v(d, s || u, l)) {
                            g.call(c, d);
                            break;
                          }
                          p && (m = k);
                        }
                        i && ((d = !v && d) && y--, _a2 && b.push(d));
                      }
                      if (y += x, i && x !== y) {
                        for (h = 0; v = r[h++];) v(b, w, s, l);
                        if (_a2) {
                          if (y > 0) for (; x--;) b[x] || w[x] || (w[x] = j.call(c));
                          w = he(w);
                        }
                        g.apply(c, w), p && !_a2 && w.length > 0 && y + r.length > 1 && _S.uniqueSort(c);
                      }
                      return p && (m = k, n = T), b;
                    };
                  return i ? te(a) : a;
                }(a, o))).selector = e;
              }
              return s;
            }
            function me(e, n, r, i) {
              var o,
                a,
                s,
                u,
                l,
                c = "function" == typeof e && e,
                p = !i && ce(e = c.selector || e);
              if (r = r || [], 1 === p.length) {
                if ((a = p[0] = p[0].slice(0)).length > 2 && "ID" === (s = a[0]).type && 9 === n.nodeType && f && t.relative[a[1].type]) {
                  if (!(n = (t.find.ID(s.matches[0].replace(Y, Q), n) || [])[0])) return r;
                  c && (n = n.parentNode), e = e.slice(a.shift().value.length);
                }
                for (o = z.needsContext.test(e) ? 0 : a.length; o-- && (s = a[o], !t.relative[u = s.type]);) if ((l = t.find[u]) && (i = l(s.matches[0].replace(Y, Q), G.test(a[0].type) && se(n.parentNode) || n))) {
                  if (a.splice(o, 1), !(e = i.length && fe(a))) return g.apply(r, i), r;
                  break;
                }
              }
              return (c || ye(e, p))(i, n, !f, r, !n || G.test(e) && se(n.parentNode) || n), r;
            }
            le.prototype = t.filters = t.pseudos, t.setFilters = new le(), v.sortStable = y.split("").sort(k).join("") === y, ue(), v.sortDetached = ne(function (e) {
              return 1 & e.compareDocumentPosition(u.createElement("fieldset"));
            }), _S.find = Z, _S.expr[":"] = _S.expr.pseudos, _S.unique = _S.uniqueSort, Z.compile = ye, Z.select = me, Z.setDocument = ue, Z.tokenize = ce, Z.escape = _S.escapeSelector, Z.getText = _S.text, Z.isXML = _S.isXMLDoc, Z.selectors = _S.expr, Z.support = _S.support, Z.uniqueSort = _S.uniqueSort;
          }();
          var M = function M(e, t, n) {
              for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;) if (1 === e.nodeType) {
                if (i && _S(e).is(n)) break;
                r.push(e);
              }
              return r;
            },
            R = function R(e, t) {
              for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
              return n;
            },
            I = _S.expr.match.needsContext,
            W = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function F(e, t, n) {
            return y(t) ? _S.grep(e, function (e, r) {
              return !!t.call(e, r, e) !== n;
            }) : t.nodeType ? _S.grep(e, function (e) {
              return e === t !== n;
            }) : "string" != typeof t ? _S.grep(e, function (e) {
              return c.call(t, e) > -1 !== n;
            }) : _S.filter(t, e, n);
          }
          _S.filter = function (e, t, n) {
            var r = t[0];
            return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? _S.find.matchesSelector(r, e) ? [r] : [] : _S.find.matches(e, _S.grep(t, function (e) {
              return 1 === e.nodeType;
            }));
          }, _S.fn.extend({
            find: function find(e) {
              var t,
                n,
                r = this.length,
                i = this;
              if ("string" != typeof e) return this.pushStack(_S(e).filter(function () {
                for (t = 0; t < r; t++) if (_S.contains(i[t], this)) return !0;
              }));
              for (n = this.pushStack([]), t = 0; t < r; t++) _S.find(e, i[t], n);
              return r > 1 ? _S.uniqueSort(n) : n;
            },
            filter: function filter(e) {
              return this.pushStack(F(this, e || [], !1));
            },
            not: function not(e) {
              return this.pushStack(F(this, e || [], !0));
            },
            is: function is(e) {
              return !!F(this, "string" == typeof e && I.test(e) ? _S(e) : e || [], !1).length;
            }
          });
          var $,
            B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          (_S.fn.init = function (e, t, n) {
            var r, i;
            if (!e) return this;
            if (n = n || $, "string" == typeof e) {
              if (!(r = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : B.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
              if (r[1]) {
                if (t = t instanceof _S ? t[0] : t, _S.merge(this, _S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : x, !0)), W.test(r[1]) && _S.isPlainObject(t)) for (r in t) y(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                return this;
              }
              return (i = x.getElementById(r[2])) && (this[0] = i, this.length = 1), this;
            }
            return e.nodeType ? (this[0] = e, this.length = 1, this) : y(e) ? void 0 !== n.ready ? n.ready(e) : e(_S) : _S.makeArray(e, this);
          }).prototype = _S.fn, $ = _S(x);
          var _ = /^(?:parents|prev(?:Until|All))/,
            z = {
              children: !0,
              contents: !0,
              next: !0,
              prev: !0
            };
          function X(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType;);
            return e;
          }
          _S.fn.extend({
            has: function has(e) {
              var t = _S(e, this),
                n = t.length;
              return this.filter(function () {
                for (var e = 0; e < n; e++) if (_S.contains(this, t[e])) return !0;
              });
            },
            closest: function closest(e, t) {
              var n,
                r = 0,
                i = this.length,
                o = [],
                a = "string" != typeof e && _S(e);
              if (!I.test(e)) for (; r < i; r++) for (n = this[r]; n && n !== t; n = n.parentNode) if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && _S.find.matchesSelector(n, e))) {
                o.push(n);
                break;
              }
              return this.pushStack(o.length > 1 ? _S.uniqueSort(o) : o);
            },
            index: function index(e) {
              return e ? "string" == typeof e ? c.call(_S(e), this[0]) : c.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function add(e, t) {
              return this.pushStack(_S.uniqueSort(_S.merge(this.get(), _S(e, t))));
            },
            addBack: function addBack(e) {
              return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            }
          }), _S.each({
            parent: function parent(e) {
              var t = e.parentNode;
              return t && 11 !== t.nodeType ? t : null;
            },
            parents: function parents(e) {
              return M(e, "parentNode");
            },
            parentsUntil: function parentsUntil(e, t, n) {
              return M(e, "parentNode", n);
            },
            next: function next(e) {
              return X(e, "nextSibling");
            },
            prev: function prev(e) {
              return X(e, "previousSibling");
            },
            nextAll: function nextAll(e) {
              return M(e, "nextSibling");
            },
            prevAll: function prevAll(e) {
              return M(e, "previousSibling");
            },
            nextUntil: function nextUntil(e, t, n) {
              return M(e, "nextSibling", n);
            },
            prevUntil: function prevUntil(e, t, n) {
              return M(e, "previousSibling", n);
            },
            siblings: function siblings(e) {
              return R((e.parentNode || {}).firstChild, e);
            },
            children: function children(e) {
              return R(e.firstChild);
            },
            contents: function contents(e) {
              return null != e.contentDocument && a(e.contentDocument) ? e.contentDocument : (E(e, "template") && (e = e.content || e), _S.merge([], e.childNodes));
            }
          }, function (e, t) {
            _S.fn[e] = function (n, r) {
              var i = _S.map(this, t, n);
              return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = _S.filter(r, i)), this.length > 1 && (z[e] || _S.uniqueSort(i), _.test(e) && i.reverse()), this.pushStack(i);
            };
          });
          var U = /[^\x20\t\r\n\f]+/g;
          function V(e) {
            return e;
          }
          function G(e) {
            throw e;
          }
          function Y(e, t, n, r) {
            var i;
            try {
              e && y(i = e.promise) ? i.call(e).done(t).fail(n) : e && y(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
            } catch (e) {
              n.apply(void 0, [e]);
            }
          }
          _S.Callbacks = function (e) {
            e = "string" == typeof e ? function (e) {
              var t = {};
              return _S.each(e.match(U) || [], function (e, n) {
                t[n] = !0;
              }), t;
            }(e) : _S.extend({}, e);
            var t,
              n,
              r,
              i,
              o = [],
              a = [],
              s = -1,
              u = function u() {
                for (i = i || e.once, r = t = !0; a.length; s = -1) for (n = a.shift(); ++s < o.length;) !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length, n = !1);
                e.memory || (n = !1), t = !1, i && (o = n ? [] : "");
              },
              l = {
                add: function add() {
                  return o && (n && !t && (s = o.length - 1, a.push(n)), function t(n) {
                    _S.each(n, function (n, r) {
                      y(r) ? e.unique && l.has(r) || o.push(r) : r && r.length && "string" !== T(r) && t(r);
                    });
                  }(arguments), n && !t && u()), this;
                },
                remove: function remove() {
                  return _S.each(arguments, function (e, t) {
                    for (var n; (n = _S.inArray(t, o, n)) > -1;) o.splice(n, 1), n <= s && s--;
                  }), this;
                },
                has: function has(e) {
                  return e ? _S.inArray(e, o) > -1 : o.length > 0;
                },
                empty: function empty() {
                  return o && (o = []), this;
                },
                disable: function disable() {
                  return i = a = [], o = n = "", this;
                },
                disabled: function disabled() {
                  return !o;
                },
                lock: function lock() {
                  return i = a = [], n || t || (o = n = ""), this;
                },
                locked: function locked() {
                  return !!i;
                },
                fireWith: function fireWith(e, n) {
                  return i || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(n), t || u()), this;
                },
                fire: function fire() {
                  return l.fireWith(this, arguments), this;
                },
                fired: function fired() {
                  return !!r;
                }
              };
            return l;
          }, _S.extend({
            Deferred: function Deferred(e) {
              var t = [["notify", "progress", _S.Callbacks("memory"), _S.Callbacks("memory"), 2], ["resolve", "done", _S.Callbacks("once memory"), _S.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", _S.Callbacks("once memory"), _S.Callbacks("once memory"), 1, "rejected"]],
                n = "pending",
                i = {
                  state: function state() {
                    return n;
                  },
                  always: function always() {
                    return o.done(arguments).fail(arguments), this;
                  },
                  "catch": function _catch(e) {
                    return i.then(null, e);
                  },
                  pipe: function pipe() {
                    var e = arguments;
                    return _S.Deferred(function (n) {
                      _S.each(t, function (t, r) {
                        var i = y(e[r[4]]) && e[r[4]];
                        o[r[1]](function () {
                          var e = i && i.apply(this, arguments);
                          e && y(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[r[0] + "With"](this, i ? [e] : arguments);
                        });
                      }), e = null;
                    }).promise();
                  },
                  then: function then(e, n, i) {
                    var o = 0;
                    function a(e, t, n, i) {
                      return function () {
                        var s = this,
                          u = arguments,
                          l = function l() {
                            var r, l;
                            if (!(e < o)) {
                              if ((r = n.apply(s, u)) === t.promise()) throw new TypeError("Thenable self-resolution");
                              l = r && ("object" == _typeof(r) || "function" == typeof r) && r.then, y(l) ? i ? l.call(r, a(o, t, V, i), a(o, t, G, i)) : (o++, l.call(r, a(o, t, V, i), a(o, t, G, i), a(o, t, V, t.notifyWith))) : (n !== V && (s = void 0, u = [r]), (i || t.resolveWith)(s, u));
                            }
                          },
                          c = i ? l : function () {
                            try {
                              l();
                            } catch (r) {
                              _S.Deferred.exceptionHook && _S.Deferred.exceptionHook(r, c.error), e + 1 >= o && (n !== G && (s = void 0, u = [r]), t.rejectWith(s, u));
                            }
                          };
                        e ? c() : (_S.Deferred.getErrorHook ? c.error = _S.Deferred.getErrorHook() : _S.Deferred.getStackHook && (c.error = _S.Deferred.getStackHook()), r.setTimeout(c));
                      };
                    }
                    return _S.Deferred(function (r) {
                      t[0][3].add(a(0, r, y(i) ? i : V, r.notifyWith)), t[1][3].add(a(0, r, y(e) ? e : V)), t[2][3].add(a(0, r, y(n) ? n : G));
                    }).promise();
                  },
                  promise: function promise(e) {
                    return null != e ? _S.extend(e, i) : i;
                  }
                },
                o = {};
              return _S.each(t, function (e, r) {
                var a = r[2],
                  s = r[5];
                i[r[1]] = a.add, s && a.add(function () {
                  n = s;
                }, t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock), a.add(r[3].fire), o[r[0]] = function () {
                  return o[r[0] + "With"](this === o ? void 0 : this, arguments), this;
                }, o[r[0] + "With"] = a.fireWith;
              }), i.promise(o), e && e.call(o, o), o;
            },
            when: function when(e) {
              var t = arguments.length,
                n = t,
                r = Array(n),
                i = s.call(arguments),
                o = _S.Deferred(),
                a = function a(e) {
                  return function (n) {
                    r[e] = this, i[e] = arguments.length > 1 ? s.call(arguments) : n, --t || o.resolveWith(r, i);
                  };
                };
              if (t <= 1 && (Y(e, o.done(a(n)).resolve, o.reject, !t), "pending" === o.state() || y(i[n] && i[n].then))) return o.then();
              for (; n--;) Y(i[n], a(n), o.reject);
              return o.promise();
            }
          });
          var Q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          _S.Deferred.exceptionHook = function (e, t) {
            r.console && r.console.warn && e && Q.test(e.name) && r.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
          }, _S.readyException = function (e) {
            r.setTimeout(function () {
              throw e;
            });
          };
          var J = _S.Deferred();
          function K() {
            x.removeEventListener("DOMContentLoaded", K), r.removeEventListener("load", K), _S.ready();
          }
          _S.fn.ready = function (e) {
            return J.then(e)["catch"](function (e) {
              _S.readyException(e);
            }), this;
          }, _S.extend({
            isReady: !1,
            readyWait: 1,
            ready: function ready(e) {
              (!0 === e ? --_S.readyWait : _S.isReady) || (_S.isReady = !0, !0 !== e && --_S.readyWait > 0 || J.resolveWith(x, [_S]));
            }
          }), _S.ready.then = J.then, "complete" === x.readyState || "loading" !== x.readyState && !x.documentElement.doScroll ? r.setTimeout(_S.ready) : (x.addEventListener("DOMContentLoaded", K), r.addEventListener("load", K));
          var _Z2 = function Z(e, t, n, r, i, o, a) {
              var s = 0,
                u = e.length,
                l = null == n;
              if ("object" === T(n)) for (s in i = !0, n) _Z2(e, t, s, n[s], !0, o, a);else if (void 0 !== r && (i = !0, y(r) || (a = !0), l && (a ? (t.call(e, r), t = null) : (l = t, t = function t(e, _t4, n) {
                return l.call(_S(e), n);
              })), t)) for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
              return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
            },
            ee = /^-ms-/,
            te = /-([a-z])/g;
          function ne(e, t) {
            return t.toUpperCase();
          }
          function re(e) {
            return e.replace(ee, "ms-").replace(te, ne);
          }
          var ie = function ie(e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
          };
          function oe() {
            this.expando = _S.expando + oe.uid++;
          }
          oe.uid = 1, oe.prototype = {
            cache: function cache(e) {
              var t = e[this.expando];
              return t || (t = {}, ie(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
              }))), t;
            },
            set: function set(e, t, n) {
              var r,
                i = this.cache(e);
              if ("string" == typeof t) i[re(t)] = n;else for (r in t) i[re(r)] = t[r];
              return i;
            },
            get: function get(e, t) {
              return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][re(t)];
            },
            access: function access(e, t, n) {
              return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function remove(e, t) {
              var n,
                r = e[this.expando];
              if (void 0 !== r) {
                if (void 0 !== t) {
                  n = (t = Array.isArray(t) ? t.map(re) : (t = re(t)) in r ? [t] : t.match(U) || []).length;
                  for (; n--;) delete r[t[n]];
                }
                (void 0 === t || _S.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
              }
            },
            hasData: function hasData(e) {
              var t = e[this.expando];
              return void 0 !== t && !_S.isEmptyObject(t);
            }
          };
          var ae = new oe(),
            se = new oe(),
            ue = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            le = /[A-Z]/g;
          function ce(e, t, n) {
            var r;
            if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(le, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
              try {
                n = function (e) {
                  return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : ue.test(e) ? JSON.parse(e) : e);
                }(n);
              } catch (e) {}
              se.set(e, t, n);
            } else n = void 0;
            return n;
          }
          _S.extend({
            hasData: function hasData(e) {
              return se.hasData(e) || ae.hasData(e);
            },
            data: function data(e, t, n) {
              return se.access(e, t, n);
            },
            removeData: function removeData(e, t) {
              se.remove(e, t);
            },
            _data: function _data(e, t, n) {
              return ae.access(e, t, n);
            },
            _removeData: function _removeData(e, t) {
              ae.remove(e, t);
            }
          }), _S.fn.extend({
            data: function data(e, t) {
              var n,
                r,
                i,
                o = this[0],
                a = o && o.attributes;
              if (void 0 === e) {
                if (this.length && (i = se.get(o), 1 === o.nodeType && !ae.get(o, "hasDataAttrs"))) {
                  for (n = a.length; n--;) a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = re(r.slice(5)), ce(o, r, i[r]));
                  ae.set(o, "hasDataAttrs", !0);
                }
                return i;
              }
              return "object" == _typeof(e) ? this.each(function () {
                se.set(this, e);
              }) : _Z2(this, function (t) {
                var n;
                if (o && void 0 === t) return void 0 !== (n = se.get(o, e)) || void 0 !== (n = ce(o, e)) ? n : void 0;
                this.each(function () {
                  se.set(this, e, t);
                });
              }, null, t, arguments.length > 1, null, !0);
            },
            removeData: function removeData(e) {
              return this.each(function () {
                se.remove(this, e);
              });
            }
          }), _S.extend({
            queue: function queue(e, t, n) {
              var r;
              if (e) return t = (t || "fx") + "queue", r = ae.get(e, t), n && (!r || Array.isArray(n) ? r = ae.access(e, t, _S.makeArray(n)) : r.push(n)), r || [];
            },
            dequeue: function dequeue(e, t) {
              t = t || "fx";
              var n = _S.queue(e, t),
                r = n.length,
                i = n.shift(),
                o = _S._queueHooks(e, t);
              "inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, function () {
                _S.dequeue(e, t);
              }, o)), !r && o && o.empty.fire();
            },
            _queueHooks: function _queueHooks(e, t) {
              var n = t + "queueHooks";
              return ae.get(e, n) || ae.access(e, n, {
                empty: _S.Callbacks("once memory").add(function () {
                  ae.remove(e, [t + "queue", n]);
                })
              });
            }
          }), _S.fn.extend({
            queue: function queue(e, t) {
              var n = 2;
              return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? _S.queue(this[0], e) : void 0 === t ? this : this.each(function () {
                var n = _S.queue(this, e, t);
                _S._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && _S.dequeue(this, e);
              });
            },
            dequeue: function dequeue(e) {
              return this.each(function () {
                _S.dequeue(this, e);
              });
            },
            clearQueue: function clearQueue(e) {
              return this.queue(e || "fx", []);
            },
            promise: function promise(e, t) {
              var n,
                r = 1,
                i = _S.Deferred(),
                o = this,
                a = this.length,
                s = function s() {
                  --r || i.resolveWith(o, [o]);
                };
              for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;) (n = ae.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
              return s(), i.promise(t);
            }
          });
          var fe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            pe = new RegExp("^(?:([+-])=|)(" + fe + ")([a-z%]*)$", "i"),
            de = ["Top", "Right", "Bottom", "Left"],
            he = x.documentElement,
            ge = function ge(e) {
              return _S.contains(e.ownerDocument, e);
            },
            ve = {
              composed: !0
            };
          he.getRootNode && (ge = function ge(e) {
            return _S.contains(e.ownerDocument, e) || e.getRootNode(ve) === e.ownerDocument;
          });
          var ye = function ye(e, t) {
            return "none" === (e = t || e).style.display || "" === e.style.display && ge(e) && "none" === _S.css(e, "display");
          };
          function me(e, t, n, r) {
            var i,
              o,
              a = 20,
              s = r ? function () {
                return r.cur();
              } : function () {
                return _S.css(e, t, "");
              },
              u = s(),
              l = n && n[3] || (_S.cssNumber[t] ? "" : "px"),
              c = e.nodeType && (_S.cssNumber[t] || "px" !== l && +u) && pe.exec(_S.css(e, t));
            if (c && c[3] !== l) {
              for (u /= 2, l = l || c[3], c = +u || 1; a--;) _S.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0), c /= o;
              c *= 2, _S.style(e, t, c + l), n = n || [];
            }
            return n && (c = +c || +u || 0, i = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = i)), i;
          }
          var xe = {};
          function be(e) {
            var t,
              n = e.ownerDocument,
              r = e.nodeName,
              i = xe[r];
            return i || (t = n.body.appendChild(n.createElement(r)), i = _S.css(t, "display"), t.parentNode.removeChild(t), "none" === i && (i = "block"), xe[r] = i, i);
          }
          function we(e, t) {
            for (var n, r, i = [], o = 0, a = e.length; o < a; o++) (r = e[o]).style && (n = r.style.display, t ? ("none" === n && (i[o] = ae.get(r, "display") || null, i[o] || (r.style.display = "")), "" === r.style.display && ye(r) && (i[o] = be(r))) : "none" !== n && (i[o] = "none", ae.set(r, "display", n)));
            for (o = 0; o < a; o++) null != i[o] && (e[o].style.display = i[o]);
            return e;
          }
          _S.fn.extend({
            show: function show() {
              return we(this, !0);
            },
            hide: function hide() {
              return we(this);
            },
            toggle: function toggle(e) {
              return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
                ye(this) ? _S(this).show() : _S(this).hide();
              });
            }
          });
          var Te,
            Ce,
            Se = /^(?:checkbox|radio)$/i,
            ke = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            Ee = /^$|^module$|\/(?:java|ecma)script/i;
          Te = x.createDocumentFragment().appendChild(x.createElement("div")), (Ce = x.createElement("input")).setAttribute("type", "radio"), Ce.setAttribute("checked", "checked"), Ce.setAttribute("name", "t"), Te.appendChild(Ce), v.checkClone = Te.cloneNode(!0).cloneNode(!0).lastChild.checked, Te.innerHTML = "<textarea>x</textarea>", v.noCloneChecked = !!Te.cloneNode(!0).lastChild.defaultValue, Te.innerHTML = "<option></option>", v.option = !!Te.lastChild;
          var je = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
          };
          function Ae(e, t) {
            var n;
            return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && E(e, t) ? _S.merge([e], n) : n;
          }
          function De(e, t) {
            for (var n = 0, r = e.length; n < r; n++) ae.set(e[n], "globalEval", !t || ae.get(t[n], "globalEval"));
          }
          je.tbody = je.tfoot = je.colgroup = je.caption = je.thead, je.th = je.td, v.option || (je.optgroup = je.option = [1, "<select multiple='multiple'>", "</select>"]);
          var Ne = /<|&#?\w+;/;
          function qe(e, t, n, r, i) {
            for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++) if ((o = e[d]) || 0 === o) if ("object" === T(o)) _S.merge(p, o.nodeType ? [o] : o);else if (Ne.test(o)) {
              for (a = a || f.appendChild(t.createElement("div")), s = (ke.exec(o) || ["", ""])[1].toLowerCase(), u = je[s] || je._default, a.innerHTML = u[1] + _S.htmlPrefilter(o) + u[2], c = u[0]; c--;) a = a.lastChild;
              _S.merge(p, a.childNodes), (a = f.firstChild).textContent = "";
            } else p.push(t.createTextNode(o));
            for (f.textContent = "", d = 0; o = p[d++];) if (r && _S.inArray(o, r) > -1) i && i.push(o);else if (l = ge(o), a = Ae(f.appendChild(o), "script"), l && De(a), n) for (c = 0; o = a[c++];) Ee.test(o.type || "") && n.push(o);
            return f;
          }
          var Le = /^([^.]*)(?:\.(.+)|)/;
          function He() {
            return !0;
          }
          function Oe() {
            return !1;
          }
          function Pe(e, t, n, r, i, o) {
            var a, s;
            if ("object" == _typeof(t)) {
              for (s in "string" != typeof n && (r = r || n, n = void 0), t) Pe(e, s, n, r, t[s], o);
              return e;
            }
            if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = Oe;else if (!i) return e;
            return 1 === o && (a = i, (i = function i(e) {
              return _S().off(e), a.apply(this, arguments);
            }).guid = a.guid || (a.guid = _S.guid++)), e.each(function () {
              _S.event.add(this, t, i, r, n);
            });
          }
          function Me(e, t, n) {
            n ? (ae.set(e, t, !1), _S.event.add(e, t, {
              namespace: !1,
              handler: function handler(e) {
                var n,
                  r = ae.get(this, t);
                if (1 & e.isTrigger && this[t]) {
                  if (r) (_S.event.special[t] || {}).delegateType && e.stopPropagation();else if (r = s.call(arguments), ae.set(this, t, r), this[t](), n = ae.get(this, t), ae.set(this, t, !1), r !== n) return e.stopImmediatePropagation(), e.preventDefault(), n;
                } else r && (ae.set(this, t, _S.event.trigger(r[0], r.slice(1), this)), e.stopPropagation(), e.isImmediatePropagationStopped = He);
              }
            })) : void 0 === ae.get(e, t) && _S.event.add(e, t, He);
          }
          _S.event = {
            global: {},
            add: function add(e, t, n, r, i) {
              var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = ae.get(e);
              if (ie(e)) for (n.handler && (n = (o = n).handler, i = o.selector), i && _S.find.matchesSelector(he, i), n.guid || (n.guid = _S.guid++), (u = v.events) || (u = v.events = Object.create(null)), (a = v.handle) || (a = v.handle = function (t) {
                return void 0 !== _S && _S.event.triggered !== t.type ? _S.event.dispatch.apply(e, arguments) : void 0;
              }), l = (t = (t || "").match(U) || [""]).length; l--;) d = g = (s = Le.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(), d && (f = _S.event.special[d] || {}, d = (i ? f.delegateType : f.bindType) || d, f = _S.event.special[d] || {}, c = _S.extend({
                type: d,
                origType: g,
                data: r,
                handler: n,
                guid: n.guid,
                selector: i,
                needsContext: i && _S.expr.match.needsContext.test(i),
                namespace: h.join(".")
              }, o), (p = u[d]) || ((p = u[d] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, h, a) || e.addEventListener && e.addEventListener(d, a)), f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, c) : p.push(c), _S.event.global[d] = !0);
            },
            remove: function remove(e, t, n, r, i) {
              var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = ae.hasData(e) && ae.get(e);
              if (v && (u = v.events)) {
                for (l = (t = (t || "").match(U) || [""]).length; l--;) if (d = g = (s = Le.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(), d) {
                  for (f = _S.event.special[d] || {}, p = u[d = (r ? f.delegateType : f.bindType) || d] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length; o--;) c = p[o], !i && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
                  a && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, v.handle) || _S.removeEvent(e, d, v.handle), delete u[d]);
                } else for (d in u) _S.event.remove(e, d + t[l], n, r, !0);
                _S.isEmptyObject(u) && ae.remove(e, "handle events");
              }
            },
            dispatch: function dispatch(e) {
              var t,
                n,
                r,
                i,
                o,
                a,
                s = new Array(arguments.length),
                u = _S.event.fix(e),
                l = (ae.get(this, "events") || Object.create(null))[u.type] || [],
                c = _S.event.special[u.type] || {};
              for (s[0] = u, t = 1; t < arguments.length; t++) s[t] = arguments[t];
              if (u.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, u)) {
                for (a = _S.event.handlers.call(this, u, l), t = 0; (i = a[t++]) && !u.isPropagationStopped();) for (u.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !u.isImmediatePropagationStopped();) u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace) || (u.handleObj = o, u.data = o.data, void 0 !== (r = ((_S.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (u.result = r) && (u.preventDefault(), u.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, u), u.result;
              }
            },
            handlers: function handlers(e, t) {
              var n,
                r,
                i,
                o,
                a,
                s = [],
                u = t.delegateCount,
                l = e.target;
              if (u && l.nodeType && !("click" === e.type && e.button >= 1)) for (; l !== this; l = l.parentNode || this) if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                for (o = [], a = {}, n = 0; n < u; n++) void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? _S(i, this).index(l) > -1 : _S.find(i, this, null, [l]).length), a[i] && o.push(r);
                o.length && s.push({
                  elem: l,
                  handlers: o
                });
              }
              return l = this, u < t.length && s.push({
                elem: l,
                handlers: t.slice(u)
              }), s;
            },
            addProp: function addProp(e, t) {
              Object.defineProperty(_S.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: y(t) ? function () {
                  if (this.originalEvent) return t(this.originalEvent);
                } : function () {
                  if (this.originalEvent) return this.originalEvent[e];
                },
                set: function set(t) {
                  Object.defineProperty(this, e, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: t
                  });
                }
              });
            },
            fix: function fix(e) {
              return e[_S.expando] ? e : new _S.Event(e);
            },
            special: {
              load: {
                noBubble: !0
              },
              click: {
                setup: function setup(e) {
                  var t = this || e;
                  return Se.test(t.type) && t.click && E(t, "input") && Me(t, "click", !0), !1;
                },
                trigger: function trigger(e) {
                  var t = this || e;
                  return Se.test(t.type) && t.click && E(t, "input") && Me(t, "click"), !0;
                },
                _default: function _default(e) {
                  var t = e.target;
                  return Se.test(t.type) && t.click && E(t, "input") && ae.get(t, "click") || E(t, "a");
                }
              },
              beforeunload: {
                postDispatch: function postDispatch(e) {
                  void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                }
              }
            }
          }, _S.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
          }, _S.Event = function (e, t) {
            if (!(this instanceof _S.Event)) return new _S.Event(e, t);
            e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? He : Oe, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && _S.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[_S.expando] = !0;
          }, _S.Event.prototype = {
            constructor: _S.Event,
            isDefaultPrevented: Oe,
            isPropagationStopped: Oe,
            isImmediatePropagationStopped: Oe,
            isSimulated: !1,
            preventDefault: function preventDefault() {
              var e = this.originalEvent;
              this.isDefaultPrevented = He, e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function stopPropagation() {
              var e = this.originalEvent;
              this.isPropagationStopped = He, e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function stopImmediatePropagation() {
              var e = this.originalEvent;
              this.isImmediatePropagationStopped = He, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
            }
          }, _S.each({
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            "char": !0,
            code: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: !0
          }, _S.event.addProp), _S.each({
            focus: "focusin",
            blur: "focusout"
          }, function (e, t) {
            function n(e) {
              if (x.documentMode) {
                var n = ae.get(this, "handle"),
                  r = _S.event.fix(e);
                r.type = "focusin" === e.type ? "focus" : "blur", r.isSimulated = !0, n(e), r.target === r.currentTarget && n(r);
              } else _S.event.simulate(t, e.target, _S.event.fix(e));
            }
            _S.event.special[e] = {
              setup: function setup() {
                var r;
                if (Me(this, e, !0), !x.documentMode) return !1;
                (r = ae.get(this, t)) || this.addEventListener(t, n), ae.set(this, t, (r || 0) + 1);
              },
              trigger: function trigger() {
                return Me(this, e), !0;
              },
              teardown: function teardown() {
                var e;
                if (!x.documentMode) return !1;
                (e = ae.get(this, t) - 1) ? ae.set(this, t, e) : (this.removeEventListener(t, n), ae.remove(this, t));
              },
              _default: function _default(t) {
                return ae.get(t.target, e);
              },
              delegateType: t
            }, _S.event.special[t] = {
              setup: function setup() {
                var r = this.ownerDocument || this.document || this,
                  i = x.documentMode ? this : r,
                  o = ae.get(i, t);
                o || (x.documentMode ? this.addEventListener(t, n) : r.addEventListener(e, n, !0)), ae.set(i, t, (o || 0) + 1);
              },
              teardown: function teardown() {
                var r = this.ownerDocument || this.document || this,
                  i = x.documentMode ? this : r,
                  o = ae.get(i, t) - 1;
                o ? ae.set(i, t, o) : (x.documentMode ? this.removeEventListener(t, n) : r.removeEventListener(e, n, !0), ae.remove(i, t));
              }
            };
          }), _S.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
          }, function (e, t) {
            _S.event.special[e] = {
              delegateType: t,
              bindType: t,
              handle: function handle(e) {
                var n,
                  r = this,
                  i = e.relatedTarget,
                  o = e.handleObj;
                return i && (i === r || _S.contains(r, i)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
              }
            };
          }), _S.fn.extend({
            on: function on(e, t, n, r) {
              return Pe(this, e, t, n, r);
            },
            one: function one(e, t, n, r) {
              return Pe(this, e, t, n, r, 1);
            },
            off: function off(e, t, n) {
              var r, i;
              if (e && e.preventDefault && e.handleObj) return r = e.handleObj, _S(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
              if ("object" == _typeof(e)) {
                for (i in e) this.off(i, t, e[i]);
                return this;
              }
              return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Oe), this.each(function () {
                _S.event.remove(this, e, n, t);
              });
            }
          });
          var Re = /<script|<style|<link/i,
            Ie = /checked\s*(?:[^=]|=\s*.checked.)/i,
            We = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
          function Fe(e, t) {
            return E(e, "table") && E(11 !== t.nodeType ? t : t.firstChild, "tr") && _S(e).children("tbody")[0] || e;
          }
          function $e(e) {
            return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
          }
          function Be(e) {
            return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
          }
          function _e(e, t) {
            var n, r, i, o, a, s;
            if (1 === t.nodeType) {
              if (ae.hasData(e) && (s = ae.get(e).events)) for (i in ae.remove(t, "handle events"), s) for (n = 0, r = s[i].length; n < r; n++) _S.event.add(t, i, s[i][n]);
              se.hasData(e) && (o = se.access(e), a = _S.extend({}, o), se.set(t, a));
            }
          }
          function ze(e, t) {
            var n = t.nodeName.toLowerCase();
            "input" === n && Se.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
          }
          function Xe(e, t, n, r) {
            t = u(t);
            var i,
              o,
              a,
              s,
              l,
              c,
              f = 0,
              p = e.length,
              d = p - 1,
              h = t[0],
              g = y(h);
            if (g || p > 1 && "string" == typeof h && !v.checkClone && Ie.test(h)) return e.each(function (i) {
              var o = e.eq(i);
              g && (t[0] = h.call(this, i, o.html())), Xe(o, t, n, r);
            });
            if (p && (o = (i = qe(t, e[0].ownerDocument, !1, e, r)).firstChild, 1 === i.childNodes.length && (i = o), o || r)) {
              for (s = (a = _S.map(Ae(i, "script"), $e)).length; f < p; f++) l = i, f !== d && (l = _S.clone(l, !0, !0), s && _S.merge(a, Ae(l, "script"))), n.call(e[f], l, f);
              if (s) for (c = a[a.length - 1].ownerDocument, _S.map(a, Be), f = 0; f < s; f++) l = a[f], Ee.test(l.type || "") && !ae.access(l, "globalEval") && _S.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? _S._evalUrl && !l.noModule && _S._evalUrl(l.src, {
                nonce: l.nonce || l.getAttribute("nonce")
              }, c) : w(l.textContent.replace(We, ""), l, c));
            }
            return e;
          }
          function Ue(e, t, n) {
            for (var r, i = t ? _S.filter(t, e) : e, o = 0; null != (r = i[o]); o++) n || 1 !== r.nodeType || _S.cleanData(Ae(r)), r.parentNode && (n && ge(r) && De(Ae(r, "script")), r.parentNode.removeChild(r));
            return e;
          }
          _S.extend({
            htmlPrefilter: function htmlPrefilter(e) {
              return e;
            },
            clone: function clone(e, t, n) {
              var r,
                i,
                o,
                a,
                s = e.cloneNode(!0),
                u = ge(e);
              if (!(v.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || _S.isXMLDoc(e))) for (a = Ae(s), r = 0, i = (o = Ae(e)).length; r < i; r++) ze(o[r], a[r]);
              if (t) if (n) for (o = o || Ae(e), a = a || Ae(s), r = 0, i = o.length; r < i; r++) _e(o[r], a[r]);else _e(e, s);
              return (a = Ae(s, "script")).length > 0 && De(a, !u && Ae(e, "script")), s;
            },
            cleanData: function cleanData(e) {
              for (var t, n, r, i = _S.event.special, o = 0; void 0 !== (n = e[o]); o++) if (ie(n)) {
                if (t = n[ae.expando]) {
                  if (t.events) for (r in t.events) i[r] ? _S.event.remove(n, r) : _S.removeEvent(n, r, t.handle);
                  n[ae.expando] = void 0;
                }
                n[se.expando] && (n[se.expando] = void 0);
              }
            }
          }), _S.fn.extend({
            detach: function detach(e) {
              return Ue(this, e, !0);
            },
            remove: function remove(e) {
              return Ue(this, e);
            },
            text: function text(e) {
              return _Z2(this, function (e) {
                return void 0 === e ? _S.text(this) : this.empty().each(function () {
                  1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
                });
              }, null, e, arguments.length);
            },
            append: function append() {
              return Xe(this, arguments, function (e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Fe(this, e).appendChild(e);
              });
            },
            prepend: function prepend() {
              return Xe(this, arguments, function (e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                  var t = Fe(this, e);
                  t.insertBefore(e, t.firstChild);
                }
              });
            },
            before: function before() {
              return Xe(this, arguments, function (e) {
                this.parentNode && this.parentNode.insertBefore(e, this);
              });
            },
            after: function after() {
              return Xe(this, arguments, function (e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
              });
            },
            empty: function empty() {
              for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (_S.cleanData(Ae(e, !1)), e.textContent = "");
              return this;
            },
            clone: function clone(e, t) {
              return e = null != e && e, t = null == t ? e : t, this.map(function () {
                return _S.clone(this, e, t);
              });
            },
            html: function html(e) {
              return _Z2(this, function (e) {
                var t = this[0] || {},
                  n = 0,
                  r = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !Re.test(e) && !je[(ke.exec(e) || ["", ""])[1].toLowerCase()]) {
                  e = _S.htmlPrefilter(e);
                  try {
                    for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (_S.cleanData(Ae(t, !1)), t.innerHTML = e);
                    t = 0;
                  } catch (e) {}
                }
                t && this.empty().append(e);
              }, null, e, arguments.length);
            },
            replaceWith: function replaceWith() {
              var e = [];
              return Xe(this, arguments, function (t) {
                var n = this.parentNode;
                _S.inArray(this, e) < 0 && (_S.cleanData(Ae(this)), n && n.replaceChild(t, this));
              }, e);
            }
          }), _S.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
          }, function (e, t) {
            _S.fn[e] = function (e) {
              for (var n, r = [], i = _S(e), o = i.length - 1, a = 0; a <= o; a++) n = a === o ? this : this.clone(!0), _S(i[a])[t](n), l.apply(r, n.get());
              return this.pushStack(r);
            };
          });
          var Ve = new RegExp("^(" + fe + ")(?!px)[a-z%]+$", "i"),
            Ge = /^--/,
            Ye = function Ye(e) {
              var t = e.ownerDocument.defaultView;
              return t && t.opener || (t = r), t.getComputedStyle(e);
            },
            Qe = function Qe(e, t, n) {
              var r,
                i,
                o = {};
              for (i in t) o[i] = e.style[i], e.style[i] = t[i];
              for (i in r = n.call(e), t) e.style[i] = o[i];
              return r;
            },
            Je = new RegExp(de.join("|"), "i");
          function Ke(e, t, n) {
            var r,
              i,
              o,
              a,
              s = Ge.test(t),
              u = e.style;
            return (n = n || Ye(e)) && (a = n.getPropertyValue(t) || n[t], s && a && (a = a.replace(q, "$1") || void 0), "" !== a || ge(e) || (a = _S.style(e, t)), !v.pixelBoxStyles() && Ve.test(a) && Je.test(t) && (r = u.width, i = u.minWidth, o = u.maxWidth, u.minWidth = u.maxWidth = u.width = a, a = n.width, u.width = r, u.minWidth = i, u.maxWidth = o)), void 0 !== a ? a + "" : a;
          }
          function Ze(e, t) {
            return {
              get: function get() {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
              }
            };
          }
          !function () {
            function e() {
              if (c) {
                l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", he.appendChild(l).appendChild(c);
                var e = r.getComputedStyle(c);
                n = "1%" !== e.top, u = 12 === t(e.marginLeft), c.style.right = "60%", a = 36 === t(e.right), i = 36 === t(e.width), c.style.position = "absolute", o = 12 === t(c.offsetWidth / 3), he.removeChild(l), c = null;
              }
            }
            function t(e) {
              return Math.round(parseFloat(e));
            }
            var n,
              i,
              o,
              a,
              s,
              u,
              l = x.createElement("div"),
              c = x.createElement("div");
            c.style && (c.style.backgroundClip = "content-box", c.cloneNode(!0).style.backgroundClip = "", v.clearCloneStyle = "content-box" === c.style.backgroundClip, _S.extend(v, {
              boxSizingReliable: function boxSizingReliable() {
                return e(), i;
              },
              pixelBoxStyles: function pixelBoxStyles() {
                return e(), a;
              },
              pixelPosition: function pixelPosition() {
                return e(), n;
              },
              reliableMarginLeft: function reliableMarginLeft() {
                return e(), u;
              },
              scrollboxSize: function scrollboxSize() {
                return e(), o;
              },
              reliableTrDimensions: function reliableTrDimensions() {
                var e, t, n, i;
                return null == s && (e = x.createElement("table"), t = x.createElement("tr"), n = x.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", t.style.cssText = "box-sizing:content-box;border:1px solid", t.style.height = "1px", n.style.height = "9px", n.style.display = "block", he.appendChild(e).appendChild(t).appendChild(n), i = r.getComputedStyle(t), s = parseInt(i.height, 10) + parseInt(i.borderTopWidth, 10) + parseInt(i.borderBottomWidth, 10) === t.offsetHeight, he.removeChild(e)), s;
              }
            }));
          }();
          var et = ["Webkit", "Moz", "ms"],
            tt = x.createElement("div").style,
            nt = {};
          function rt(e) {
            var t = _S.cssProps[e] || nt[e];
            return t || (e in tt ? e : nt[e] = function (e) {
              for (var t = e[0].toUpperCase() + e.slice(1), n = et.length; n--;) if ((e = et[n] + t) in tt) return e;
            }(e) || e);
          }
          var it = /^(none|table(?!-c[ea]).+)/,
            ot = {
              position: "absolute",
              visibility: "hidden",
              display: "block"
            },
            at = {
              letterSpacing: "0",
              fontWeight: "400"
            };
          function st(e, t, n) {
            var r = pe.exec(t);
            return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
          }
          function ut(e, t, n, r, i, o) {
            var a = "width" === t ? 1 : 0,
              s = 0,
              u = 0,
              l = 0;
            if (n === (r ? "border" : "content")) return 0;
            for (; a < 4; a += 2) "margin" === n && (l += _S.css(e, n + de[a], !0, i)), r ? ("content" === n && (u -= _S.css(e, "padding" + de[a], !0, i)), "margin" !== n && (u -= _S.css(e, "border" + de[a] + "Width", !0, i))) : (u += _S.css(e, "padding" + de[a], !0, i), "padding" !== n ? u += _S.css(e, "border" + de[a] + "Width", !0, i) : s += _S.css(e, "border" + de[a] + "Width", !0, i));
            return !r && o >= 0 && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5)) || 0), u + l;
          }
          function lt(e, t, n) {
            var r = Ye(e),
              i = (!v.boxSizingReliable() || n) && "border-box" === _S.css(e, "boxSizing", !1, r),
              o = i,
              a = Ke(e, t, r),
              s = "offset" + t[0].toUpperCase() + t.slice(1);
            if (Ve.test(a)) {
              if (!n) return a;
              a = "auto";
            }
            return (!v.boxSizingReliable() && i || !v.reliableTrDimensions() && E(e, "tr") || "auto" === a || !parseFloat(a) && "inline" === _S.css(e, "display", !1, r)) && e.getClientRects().length && (i = "border-box" === _S.css(e, "boxSizing", !1, r), (o = s in e) && (a = e[s])), (a = parseFloat(a) || 0) + ut(e, t, n || (i ? "border" : "content"), o, r, a) + "px";
          }
          function ct(e, t, n, r, i) {
            return new ct.prototype.init(e, t, n, r, i);
          }
          _S.extend({
            cssHooks: {
              opacity: {
                get: function get(e, t) {
                  if (t) {
                    var n = Ke(e, "opacity");
                    return "" === n ? "1" : n;
                  }
                }
              }
            },
            cssNumber: {
              animationIterationCount: !0,
              aspectRatio: !0,
              borderImageSlice: !0,
              columnCount: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              scale: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
              fillOpacity: !0,
              floodOpacity: !0,
              stopOpacity: !0,
              strokeMiterlimit: !0,
              strokeOpacity: !0
            },
            cssProps: {},
            style: function style(e, t, n, r) {
              if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i,
                  o,
                  a,
                  s = re(t),
                  u = Ge.test(t),
                  l = e.style;
                if (u || (t = rt(s)), a = _S.cssHooks[t] || _S.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
                "string" === (o = _typeof(n)) && (i = pe.exec(n)) && i[1] && (n = me(e, t, i), o = "number"), null != n && n == n && ("number" !== o || u || (n += i && i[3] || (_S.cssNumber[s] ? "" : "px")), v.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (u ? l.setProperty(t, n) : l[t] = n));
              }
            },
            css: function css(e, t, n, r) {
              var i,
                o,
                a,
                s = re(t);
              return Ge.test(t) || (t = rt(s)), (a = _S.cssHooks[t] || _S.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = Ke(e, t, r)), "normal" === i && t in at && (i = at[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
            }
          }), _S.each(["height", "width"], function (e, t) {
            _S.cssHooks[t] = {
              get: function get(e, n, r) {
                if (n) return !it.test(_S.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? lt(e, t, r) : Qe(e, ot, function () {
                  return lt(e, t, r);
                });
              },
              set: function set(e, n, r) {
                var i,
                  o = Ye(e),
                  a = !v.scrollboxSize() && "absolute" === o.position,
                  s = (a || r) && "border-box" === _S.css(e, "boxSizing", !1, o),
                  u = r ? ut(e, t, r, s, o) : 0;
                return s && a && (u -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - ut(e, t, "border", !1, o) - .5)), u && (i = pe.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = _S.css(e, t)), st(0, n, u);
              }
            };
          }), _S.cssHooks.marginLeft = Ze(v.reliableMarginLeft, function (e, t) {
            if (t) return (parseFloat(Ke(e, "marginLeft")) || e.getBoundingClientRect().left - Qe(e, {
              marginLeft: 0
            }, function () {
              return e.getBoundingClientRect().left;
            })) + "px";
          }), _S.each({
            margin: "",
            padding: "",
            border: "Width"
          }, function (e, t) {
            _S.cssHooks[e + t] = {
              expand: function expand(n) {
                for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) i[e + de[r] + t] = o[r] || o[r - 2] || o[0];
                return i;
              }
            }, "margin" !== e && (_S.cssHooks[e + t].set = st);
          }), _S.fn.extend({
            css: function css(e, t) {
              return _Z2(this, function (e, t, n) {
                var r,
                  i,
                  o = {},
                  a = 0;
                if (Array.isArray(t)) {
                  for (r = Ye(e), i = t.length; a < i; a++) o[t[a]] = _S.css(e, t[a], !1, r);
                  return o;
                }
                return void 0 !== n ? _S.style(e, t, n) : _S.css(e, t);
              }, e, t, arguments.length > 1);
            }
          }), _S.Tween = ct, ct.prototype = {
            constructor: ct,
            init: function init(e, t, n, r, i, o) {
              this.elem = e, this.prop = n, this.easing = i || _S.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (_S.cssNumber[n] ? "" : "px");
            },
            cur: function cur() {
              var e = ct.propHooks[this.prop];
              return e && e.get ? e.get(this) : ct.propHooks._default.get(this);
            },
            run: function run(e) {
              var t,
                n = ct.propHooks[this.prop];
              return this.options.duration ? this.pos = t = _S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : ct.propHooks._default.set(this), this;
            }
          }, ct.prototype.init.prototype = ct.prototype, ct.propHooks = {
            _default: {
              get: function get(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = _S.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
              },
              set: function set(e) {
                _S.fx.step[e.prop] ? _S.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !_S.cssHooks[e.prop] && null == e.elem.style[rt(e.prop)] ? e.elem[e.prop] = e.now : _S.style(e.elem, e.prop, e.now + e.unit);
              }
            }
          }, ct.propHooks.scrollTop = ct.propHooks.scrollLeft = {
            set: function set(e) {
              e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            }
          }, _S.easing = {
            linear: function linear(e) {
              return e;
            },
            swing: function swing(e) {
              return .5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing"
          }, _S.fx = ct.prototype.init, _S.fx.step = {};
          var ft,
            pt,
            dt = /^(?:toggle|show|hide)$/,
            ht = /queueHooks$/;
          function gt() {
            pt && (!1 === x.hidden && r.requestAnimationFrame ? r.requestAnimationFrame(gt) : r.setTimeout(gt, _S.fx.interval), _S.fx.tick());
          }
          function vt() {
            return r.setTimeout(function () {
              ft = void 0;
            }), ft = Date.now();
          }
          function yt(e, t) {
            var n,
              r = 0,
              i = {
                height: e
              };
            for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = de[r])] = i["padding" + n] = e;
            return t && (i.opacity = i.width = e), i;
          }
          function mt(e, t, n) {
            for (var r, i = (xt.tweeners[t] || []).concat(xt.tweeners["*"]), o = 0, a = i.length; o < a; o++) if (r = i[o].call(n, t, e)) return r;
          }
          function xt(e, t, n) {
            var r,
              i,
              o = 0,
              a = xt.prefilters.length,
              s = _S.Deferred().always(function () {
                delete u.elem;
              }),
              u = function u() {
                if (i) return !1;
                for (var t = ft || vt(), n = Math.max(0, l.startTime + l.duration - t), r = 1 - (n / l.duration || 0), o = 0, a = l.tweens.length; o < a; o++) l.tweens[o].run(r);
                return s.notifyWith(e, [l, r, n]), r < 1 && a ? n : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1);
              },
              l = s.promise({
                elem: e,
                props: _S.extend({}, t),
                opts: _S.extend(!0, {
                  specialEasing: {},
                  easing: _S.easing._default
                }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: ft || vt(),
                duration: n.duration,
                tweens: [],
                createTween: function createTween(t, n) {
                  var r = _S.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
                  return l.tweens.push(r), r;
                },
                stop: function stop(t) {
                  var n = 0,
                    r = t ? l.tweens.length : 0;
                  if (i) return this;
                  for (i = !0; n < r; n++) l.tweens[n].run(1);
                  return t ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t])) : s.rejectWith(e, [l, t]), this;
                }
              }),
              c = l.props;
            for (!function (e, t) {
              var n, r, i, o, a;
              for (n in e) if (i = t[r = re(n)], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (a = _S.cssHooks[r]) && "expand" in a) for (n in o = a.expand(o), delete e[r], o) n in e || (e[n] = o[n], t[n] = i);else t[r] = i;
            }(c, l.opts.specialEasing); o < a; o++) if (r = xt.prefilters[o].call(l, e, c, l.opts)) return y(r.stop) && (_S._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)), r;
            return _S.map(c, mt, l), y(l.opts.start) && l.opts.start.call(e, l), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always), _S.fx.timer(_S.extend(u, {
              elem: e,
              anim: l,
              queue: l.opts.queue
            })), l;
          }
          _S.Animation = _S.extend(xt, {
            tweeners: {
              "*": [function (e, t) {
                var n = this.createTween(e, t);
                return me(n.elem, e, pe.exec(t), n), n;
              }]
            },
            tweener: function tweener(e, t) {
              y(e) ? (t = e, e = ["*"]) : e = e.match(U);
              for (var n, r = 0, i = e.length; r < i; r++) n = e[r], xt.tweeners[n] = xt.tweeners[n] || [], xt.tweeners[n].unshift(t);
            },
            prefilters: [function (e, t, n) {
              var r,
                i,
                o,
                a,
                s,
                u,
                l,
                c,
                f = "width" in t || "height" in t,
                p = this,
                d = {},
                h = e.style,
                g = e.nodeType && ye(e),
                v = ae.get(e, "fxshow");
              for (r in n.queue || (null == (a = _S._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () {
                a.unqueued || s();
              }), a.unqueued++, p.always(function () {
                p.always(function () {
                  a.unqueued--, _S.queue(e, "fx").length || a.empty.fire();
                });
              })), t) if (i = t[r], dt.test(i)) {
                if (delete t[r], o = o || "toggle" === i, i === (g ? "hide" : "show")) {
                  if ("show" !== i || !v || void 0 === v[r]) continue;
                  g = !0;
                }
                d[r] = v && v[r] || _S.style(e, r);
              }
              if ((u = !_S.isEmptyObject(t)) || !_S.isEmptyObject(d)) for (r in f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (l = v && v.display) && (l = ae.get(e, "display")), "none" === (c = _S.css(e, "display")) && (l ? c = l : (we([e], !0), l = e.style.display || l, c = _S.css(e, "display"), we([e]))), ("inline" === c || "inline-block" === c && null != l) && "none" === _S.css(e, "float") && (u || (p.done(function () {
                h.display = l;
              }), null == l && (c = h.display, l = "none" === c ? "" : c)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always(function () {
                h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
              })), u = !1, d) u || (v ? "hidden" in v && (g = v.hidden) : v = ae.access(e, "fxshow", {
                display: l
              }), o && (v.hidden = !g), g && we([e], !0), p.done(function () {
                for (r in g || we([e]), ae.remove(e, "fxshow"), d) _S.style(e, r, d[r]);
              })), u = mt(g ? v[r] : 0, r, p), r in v || (v[r] = u.start, g && (u.end = u.start, u.start = 0));
            }],
            prefilter: function prefilter(e, t) {
              t ? xt.prefilters.unshift(e) : xt.prefilters.push(e);
            }
          }), _S.speed = function (e, t, n) {
            var r = e && "object" == _typeof(e) ? _S.extend({}, e) : {
              complete: n || !n && t || y(e) && e,
              duration: e,
              easing: n && t || t && !y(t) && t
            };
            return _S.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in _S.fx.speeds ? r.duration = _S.fx.speeds[r.duration] : r.duration = _S.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
              y(r.old) && r.old.call(this), r.queue && _S.dequeue(this, r.queue);
            }, r;
          }, _S.fn.extend({
            fadeTo: function fadeTo(e, t, n, r) {
              return this.filter(ye).css("opacity", 0).show().end().animate({
                opacity: t
              }, e, n, r);
            },
            animate: function animate(e, t, n, r) {
              var i = _S.isEmptyObject(e),
                o = _S.speed(t, n, r),
                a = function a() {
                  var t = xt(this, _S.extend({}, e), o);
                  (i || ae.get(this, "finish")) && t.stop(!0);
                };
              return a.finish = a, i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
            },
            stop: function stop(e, t, n) {
              var r = function r(e) {
                var t = e.stop;
                delete e.stop, t(n);
              };
              return "string" != typeof e && (n = t, t = e, e = void 0), t && this.queue(e || "fx", []), this.each(function () {
                var t = !0,
                  i = null != e && e + "queueHooks",
                  o = _S.timers,
                  a = ae.get(this);
                if (i) a[i] && a[i].stop && r(a[i]);else for (i in a) a[i] && a[i].stop && ht.test(i) && r(a[i]);
                for (i = o.length; i--;) o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
                !t && n || _S.dequeue(this, e);
              });
            },
            finish: function finish(e) {
              return !1 !== e && (e = e || "fx"), this.each(function () {
                var t,
                  n = ae.get(this),
                  r = n[e + "queue"],
                  i = n[e + "queueHooks"],
                  o = _S.timers,
                  a = r ? r.length : 0;
                for (n.finish = !0, _S.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                for (t = 0; t < a; t++) r[t] && r[t].finish && r[t].finish.call(this);
                delete n.finish;
              });
            }
          }), _S.each(["toggle", "show", "hide"], function (e, t) {
            var n = _S.fn[t];
            _S.fn[t] = function (e, r, i) {
              return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(yt(t, !0), e, r, i);
            };
          }), _S.each({
            slideDown: yt("show"),
            slideUp: yt("hide"),
            slideToggle: yt("toggle"),
            fadeIn: {
              opacity: "show"
            },
            fadeOut: {
              opacity: "hide"
            },
            fadeToggle: {
              opacity: "toggle"
            }
          }, function (e, t) {
            _S.fn[e] = function (e, n, r) {
              return this.animate(t, e, n, r);
            };
          }), _S.timers = [], _S.fx.tick = function () {
            var e,
              t = 0,
              n = _S.timers;
            for (ft = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || _S.fx.stop(), ft = void 0;
          }, _S.fx.timer = function (e) {
            _S.timers.push(e), _S.fx.start();
          }, _S.fx.interval = 13, _S.fx.start = function () {
            pt || (pt = !0, gt());
          }, _S.fx.stop = function () {
            pt = null;
          }, _S.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
          }, _S.fn.delay = function (e, t) {
            return e = _S.fx && _S.fx.speeds[e] || e, t = t || "fx", this.queue(t, function (t, n) {
              var i = r.setTimeout(t, e);
              n.stop = function () {
                r.clearTimeout(i);
              };
            });
          }, function () {
            var e = x.createElement("input"),
              t = x.createElement("select").appendChild(x.createElement("option"));
            e.type = "checkbox", v.checkOn = "" !== e.value, v.optSelected = t.selected, (e = x.createElement("input")).value = "t", e.type = "radio", v.radioValue = "t" === e.value;
          }();
          var bt,
            wt = _S.expr.attrHandle;
          _S.fn.extend({
            attr: function attr(e, t) {
              return _Z2(this, _S.attr, e, t, arguments.length > 1);
            },
            removeAttr: function removeAttr(e) {
              return this.each(function () {
                _S.removeAttr(this, e);
              });
            }
          }), _S.extend({
            attr: function attr(e, t, n) {
              var r,
                i,
                o = e.nodeType;
              if (3 !== o && 8 !== o && 2 !== o) return void 0 === e.getAttribute ? _S.prop(e, t, n) : (1 === o && _S.isXMLDoc(e) || (i = _S.attrHooks[t.toLowerCase()] || (_S.expr.match.bool.test(t) ? bt : void 0)), void 0 !== n ? null === n ? void _S.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = _S.find.attr(e, t)) ? void 0 : r);
            },
            attrHooks: {
              type: {
                set: function set(e, t) {
                  if (!v.radioValue && "radio" === t && E(e, "input")) {
                    var n = e.value;
                    return e.setAttribute("type", t), n && (e.value = n), t;
                  }
                }
              }
            },
            removeAttr: function removeAttr(e, t) {
              var n,
                r = 0,
                i = t && t.match(U);
              if (i && 1 === e.nodeType) for (; n = i[r++];) e.removeAttribute(n);
            }
          }), bt = {
            set: function set(e, t, n) {
              return !1 === t ? _S.removeAttr(e, n) : e.setAttribute(n, n), n;
            }
          }, _S.each(_S.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var n = wt[t] || _S.find.attr;
            wt[t] = function (e, t, r) {
              var i,
                o,
                a = t.toLowerCase();
              return r || (o = wt[a], wt[a] = i, i = null != n(e, t, r) ? a : null, wt[a] = o), i;
            };
          });
          var Tt = /^(?:input|select|textarea|button)$/i,
            Ct = /^(?:a|area)$/i;
          function St(e) {
            return (e.match(U) || []).join(" ");
          }
          function kt(e) {
            return e.getAttribute && e.getAttribute("class") || "";
          }
          function Et(e) {
            return Array.isArray(e) ? e : "string" == typeof e && e.match(U) || [];
          }
          _S.fn.extend({
            prop: function prop(e, t) {
              return _Z2(this, _S.prop, e, t, arguments.length > 1);
            },
            removeProp: function removeProp(e) {
              return this.each(function () {
                delete this[_S.propFix[e] || e];
              });
            }
          }), _S.extend({
            prop: function prop(e, t, n) {
              var r,
                i,
                o = e.nodeType;
              if (3 !== o && 8 !== o && 2 !== o) return 1 === o && _S.isXMLDoc(e) || (t = _S.propFix[t] || t, i = _S.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t];
            },
            propHooks: {
              tabIndex: {
                get: function get(e) {
                  var t = _S.find.attr(e, "tabindex");
                  return t ? parseInt(t, 10) : Tt.test(e.nodeName) || Ct.test(e.nodeName) && e.href ? 0 : -1;
                }
              }
            },
            propFix: {
              "for": "htmlFor",
              "class": "className"
            }
          }), v.optSelected || (_S.propHooks.selected = {
            get: function get(e) {
              var t = e.parentNode;
              return t && t.parentNode && t.parentNode.selectedIndex, null;
            },
            set: function set(e) {
              var t = e.parentNode;
              t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
            }
          }), _S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            _S.propFix[this.toLowerCase()] = this;
          }), _S.fn.extend({
            addClass: function addClass(e) {
              var t, n, r, i, o, a;
              return y(e) ? this.each(function (t) {
                _S(this).addClass(e.call(this, t, kt(this)));
              }) : (t = Et(e)).length ? this.each(function () {
                if (r = kt(this), n = 1 === this.nodeType && " " + St(r) + " ") {
                  for (o = 0; o < t.length; o++) i = t[o], n.indexOf(" " + i + " ") < 0 && (n += i + " ");
                  a = St(n), r !== a && this.setAttribute("class", a);
                }
              }) : this;
            },
            removeClass: function removeClass(e) {
              var t, n, r, i, o, a;
              return y(e) ? this.each(function (t) {
                _S(this).removeClass(e.call(this, t, kt(this)));
              }) : arguments.length ? (t = Et(e)).length ? this.each(function () {
                if (r = kt(this), n = 1 === this.nodeType && " " + St(r) + " ") {
                  for (o = 0; o < t.length; o++) for (i = t[o]; n.indexOf(" " + i + " ") > -1;) n = n.replace(" " + i + " ", " ");
                  a = St(n), r !== a && this.setAttribute("class", a);
                }
              }) : this : this.attr("class", "");
            },
            toggleClass: function toggleClass(e, t) {
              var n,
                r,
                i,
                o,
                a = _typeof(e),
                s = "string" === a || Array.isArray(e);
              return y(e) ? this.each(function (n) {
                _S(this).toggleClass(e.call(this, n, kt(this), t), t);
              }) : "boolean" == typeof t && s ? t ? this.addClass(e) : this.removeClass(e) : (n = Et(e), this.each(function () {
                if (s) for (o = _S(this), i = 0; i < n.length; i++) r = n[i], o.hasClass(r) ? o.removeClass(r) : o.addClass(r);else void 0 !== e && "boolean" !== a || ((r = kt(this)) && ae.set(this, "__className__", r), this.setAttribute && this.setAttribute("class", r || !1 === e ? "" : ae.get(this, "__className__") || ""));
              }));
            },
            hasClass: function hasClass(e) {
              var t,
                n,
                r = 0;
              for (t = " " + e + " "; n = this[r++];) if (1 === n.nodeType && (" " + St(kt(n)) + " ").indexOf(t) > -1) return !0;
              return !1;
            }
          });
          var jt = /\r/g;
          _S.fn.extend({
            val: function val(e) {
              var t,
                n,
                r,
                i = this[0];
              return arguments.length ? (r = y(e), this.each(function (n) {
                var i;
                1 === this.nodeType && (null == (i = r ? e.call(this, n, _S(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = _S.map(i, function (e) {
                  return null == e ? "" : e + "";
                })), (t = _S.valHooks[this.type] || _S.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i));
              })) : i ? (t = _S.valHooks[i.type] || _S.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(jt, "") : null == n ? "" : n : void 0;
            }
          }), _S.extend({
            valHooks: {
              option: {
                get: function get(e) {
                  var t = _S.find.attr(e, "value");
                  return null != t ? t : St(_S.text(e));
                }
              },
              select: {
                get: function get(e) {
                  var t,
                    n,
                    r,
                    i = e.options,
                    o = e.selectedIndex,
                    a = "select-one" === e.type,
                    s = a ? null : [],
                    u = a ? o + 1 : i.length;
                  for (r = o < 0 ? u : a ? o : 0; r < u; r++) if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !E(n.parentNode, "optgroup"))) {
                    if (t = _S(n).val(), a) return t;
                    s.push(t);
                  }
                  return s;
                },
                set: function set(e, t) {
                  for (var n, r, i = e.options, o = _S.makeArray(t), a = i.length; a--;) ((r = i[a]).selected = _S.inArray(_S.valHooks.option.get(r), o) > -1) && (n = !0);
                  return n || (e.selectedIndex = -1), o;
                }
              }
            }
          }), _S.each(["radio", "checkbox"], function () {
            _S.valHooks[this] = {
              set: function set(e, t) {
                if (Array.isArray(t)) return e.checked = _S.inArray(_S(e).val(), t) > -1;
              }
            }, v.checkOn || (_S.valHooks[this].get = function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            });
          });
          var At = r.location,
            Dt = {
              guid: Date.now()
            },
            Nt = /\?/;
          _S.parseXML = function (e) {
            var t, n;
            if (!e || "string" != typeof e) return null;
            try {
              t = new r.DOMParser().parseFromString(e, "text/xml");
            } catch (e) {}
            return n = t && t.getElementsByTagName("parsererror")[0], t && !n || _S.error("Invalid XML: " + (n ? _S.map(n.childNodes, function (e) {
              return e.textContent;
            }).join("\n") : e)), t;
          };
          var qt = /^(?:focusinfocus|focusoutblur)$/,
            Lt = function Lt(e) {
              e.stopPropagation();
            };
          _S.extend(_S.event, {
            trigger: function trigger(e, t, n, i) {
              var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                h = [n || x],
                g = d.call(e, "type") ? e.type : e,
                v = d.call(e, "namespace") ? e.namespace.split(".") : [];
              if (a = p = s = n = n || x, 3 !== n.nodeType && 8 !== n.nodeType && !qt.test(g + _S.event.triggered) && (g.indexOf(".") > -1 && (v = g.split("."), g = v.shift(), v.sort()), l = g.indexOf(":") < 0 && "on" + g, (e = e[_S.expando] ? e : new _S.Event(g, "object" == _typeof(e) && e)).isTrigger = i ? 2 : 3, e.namespace = v.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), t = null == t ? [e] : _S.makeArray(t, [e]), f = _S.event.special[g] || {}, i || !f.trigger || !1 !== f.trigger.apply(n, t))) {
                if (!i && !f.noBubble && !m(n)) {
                  for (u = f.delegateType || g, qt.test(u + g) || (a = a.parentNode); a; a = a.parentNode) h.push(a), s = a;
                  s === (n.ownerDocument || x) && h.push(s.defaultView || s.parentWindow || r);
                }
                for (o = 0; (a = h[o++]) && !e.isPropagationStopped();) p = a, e.type = o > 1 ? u : f.bindType || g, (c = (ae.get(a, "events") || Object.create(null))[e.type] && ae.get(a, "handle")) && c.apply(a, t), (c = l && a[l]) && c.apply && ie(a) && (e.result = c.apply(a, t), !1 === e.result && e.preventDefault());
                return e.type = g, i || e.isDefaultPrevented() || f._default && !1 !== f._default.apply(h.pop(), t) || !ie(n) || l && y(n[g]) && !m(n) && ((s = n[l]) && (n[l] = null), _S.event.triggered = g, e.isPropagationStopped() && p.addEventListener(g, Lt), n[g](), e.isPropagationStopped() && p.removeEventListener(g, Lt), _S.event.triggered = void 0, s && (n[l] = s)), e.result;
              }
            },
            simulate: function simulate(e, t, n) {
              var r = _S.extend(new _S.Event(), n, {
                type: e,
                isSimulated: !0
              });
              _S.event.trigger(r, null, t);
            }
          }), _S.fn.extend({
            trigger: function trigger(e, t) {
              return this.each(function () {
                _S.event.trigger(e, t, this);
              });
            },
            triggerHandler: function triggerHandler(e, t) {
              var n = this[0];
              if (n) return _S.event.trigger(e, t, n, !0);
            }
          });
          var Ht = /\[\]$/,
            Ot = /\r?\n/g,
            Pt = /^(?:submit|button|image|reset|file)$/i,
            Mt = /^(?:input|select|textarea|keygen)/i;
          function Rt(e, t, n, r) {
            var i;
            if (Array.isArray(t)) _S.each(t, function (t, i) {
              n || Ht.test(e) ? r(e, i) : Rt(e + "[" + ("object" == _typeof(i) && null != i ? t : "") + "]", i, n, r);
            });else if (n || "object" !== T(t)) r(e, t);else for (i in t) Rt(e + "[" + i + "]", t[i], n, r);
          }
          _S.param = function (e, t) {
            var n,
              r = [],
              i = function i(e, t) {
                var n = y(t) ? t() : t;
                r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
              };
            if (null == e) return "";
            if (Array.isArray(e) || e.jquery && !_S.isPlainObject(e)) _S.each(e, function () {
              i(this.name, this.value);
            });else for (n in e) Rt(n, e[n], t, i);
            return r.join("&");
          }, _S.fn.extend({
            serialize: function serialize() {
              return _S.param(this.serializeArray());
            },
            serializeArray: function serializeArray() {
              return this.map(function () {
                var e = _S.prop(this, "elements");
                return e ? _S.makeArray(e) : this;
              }).filter(function () {
                var e = this.type;
                return this.name && !_S(this).is(":disabled") && Mt.test(this.nodeName) && !Pt.test(e) && (this.checked || !Se.test(e));
              }).map(function (e, t) {
                var n = _S(this).val();
                return null == n ? null : Array.isArray(n) ? _S.map(n, function (e) {
                  return {
                    name: t.name,
                    value: e.replace(Ot, "\r\n")
                  };
                }) : {
                  name: t.name,
                  value: n.replace(Ot, "\r\n")
                };
              }).get();
            }
          });
          var It = /%20/g,
            Wt = /#.*$/,
            Ft = /([?&])_=[^&]*/,
            $t = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Bt = /^(?:GET|HEAD)$/,
            _t = /^\/\//,
            zt = {},
            Xt = {},
            Ut = "*/".concat("*"),
            Vt = x.createElement("a");
          function Gt(e) {
            return function (t, n) {
              "string" != typeof t && (n = t, t = "*");
              var r,
                i = 0,
                o = t.toLowerCase().match(U) || [];
              if (y(n)) for (; r = o[i++];) "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
            };
          }
          function Yt(e, t, n, r) {
            var i = {},
              o = e === Xt;
            function a(s) {
              var u;
              return i[s] = !0, _S.each(e[s] || [], function (e, s) {
                var l = s(t, n, r);
                return "string" != typeof l || o || i[l] ? o ? !(u = l) : void 0 : (t.dataTypes.unshift(l), a(l), !1);
              }), u;
            }
            return a(t.dataTypes[0]) || !i["*"] && a("*");
          }
          function Qt(e, t) {
            var n,
              r,
              i = _S.ajaxSettings.flatOptions || {};
            for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
            return r && _S.extend(!0, e, r), e;
          }
          Vt.href = At.href, _S.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
              url: At.href,
              type: "GET",
              isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(At.protocol),
              global: !0,
              processData: !0,
              async: !0,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",
              accepts: {
                "*": Ut,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
              },
              contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
              },
              responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
              },
              converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": _S.parseXML
              },
              flatOptions: {
                url: !0,
                context: !0
              }
            },
            ajaxSetup: function ajaxSetup(e, t) {
              return t ? Qt(Qt(e, _S.ajaxSettings), t) : Qt(_S.ajaxSettings, e);
            },
            ajaxPrefilter: Gt(zt),
            ajaxTransport: Gt(Xt),
            ajax: function ajax(e, t) {
              "object" == _typeof(e) && (t = e, e = void 0), t = t || {};
              var n,
                i,
                o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d = _S.ajaxSetup({}, t),
                h = d.context || d,
                g = d.context && (h.nodeType || h.jquery) ? _S(h) : _S.event,
                v = _S.Deferred(),
                y = _S.Callbacks("once memory"),
                m = d.statusCode || {},
                b = {},
                w = {},
                T = "canceled",
                C = {
                  readyState: 0,
                  getResponseHeader: function getResponseHeader(e) {
                    var t;
                    if (l) {
                      if (!a) for (a = {}; t = $t.exec(o);) a[t[1].toLowerCase() + " "] = (a[t[1].toLowerCase() + " "] || []).concat(t[2]);
                      t = a[e.toLowerCase() + " "];
                    }
                    return null == t ? null : t.join(", ");
                  },
                  getAllResponseHeaders: function getAllResponseHeaders() {
                    return l ? o : null;
                  },
                  setRequestHeader: function setRequestHeader(e, t) {
                    return null == l && (e = w[e.toLowerCase()] = w[e.toLowerCase()] || e, b[e] = t), this;
                  },
                  overrideMimeType: function overrideMimeType(e) {
                    return null == l && (d.mimeType = e), this;
                  },
                  statusCode: function statusCode(e) {
                    var t;
                    if (e) if (l) C.always(e[C.status]);else for (t in e) m[t] = [m[t], e[t]];
                    return this;
                  },
                  abort: function abort(e) {
                    var t = e || T;
                    return n && n.abort(t), k(0, t), this;
                  }
                };
              if (v.promise(C), d.url = ((e || d.url || At.href) + "").replace(_t, At.protocol + "//"), d.type = t.method || t.type || d.method || d.type, d.dataTypes = (d.dataType || "*").toLowerCase().match(U) || [""], null == d.crossDomain) {
                u = x.createElement("a");
                try {
                  u.href = d.url, u.href = u.href, d.crossDomain = Vt.protocol + "//" + Vt.host != u.protocol + "//" + u.host;
                } catch (e) {
                  d.crossDomain = !0;
                }
              }
              if (d.data && d.processData && "string" != typeof d.data && (d.data = _S.param(d.data, d.traditional)), Yt(zt, d, t, C), l) return C;
              for (f in (c = _S.event && d.global) && 0 == _S.active++ && _S.event.trigger("ajaxStart"), d.type = d.type.toUpperCase(), d.hasContent = !Bt.test(d.type), i = d.url.replace(Wt, ""), d.hasContent ? d.data && d.processData && 0 === (d.contentType || "").indexOf("application/x-www-form-urlencoded") && (d.data = d.data.replace(It, "+")) : (p = d.url.slice(i.length), d.data && (d.processData || "string" == typeof d.data) && (i += (Nt.test(i) ? "&" : "?") + d.data, delete d.data), !1 === d.cache && (i = i.replace(Ft, "$1"), p = (Nt.test(i) ? "&" : "?") + "_=" + Dt.guid++ + p), d.url = i + p), d.ifModified && (_S.lastModified[i] && C.setRequestHeader("If-Modified-Since", _S.lastModified[i]), _S.etag[i] && C.setRequestHeader("If-None-Match", _S.etag[i])), (d.data && d.hasContent && !1 !== d.contentType || t.contentType) && C.setRequestHeader("Content-Type", d.contentType), C.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + Ut + "; q=0.01" : "") : d.accepts["*"]), d.headers) C.setRequestHeader(f, d.headers[f]);
              if (d.beforeSend && (!1 === d.beforeSend.call(h, C, d) || l)) return C.abort();
              if (T = "abort", y.add(d.complete), C.done(d.success), C.fail(d.error), n = Yt(Xt, d, t, C)) {
                if (C.readyState = 1, c && g.trigger("ajaxSend", [C, d]), l) return C;
                d.async && d.timeout > 0 && (s = r.setTimeout(function () {
                  C.abort("timeout");
                }, d.timeout));
                try {
                  l = !1, n.send(b, k);
                } catch (e) {
                  if (l) throw e;
                  k(-1, e);
                }
              } else k(-1, "No Transport");
              function k(e, t, a, u) {
                var f,
                  p,
                  x,
                  b,
                  w,
                  T = t;
                l || (l = !0, s && r.clearTimeout(s), n = void 0, o = u || "", C.readyState = e > 0 ? 4 : 0, f = e >= 200 && e < 300 || 304 === e, a && (b = function (e, t, n) {
                  for (var r, i, o, a, s = e.contents, u = e.dataTypes; "*" === u[0];) u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                  if (r) for (i in s) if (s[i] && s[i].test(r)) {
                    u.unshift(i);
                    break;
                  }
                  if (u[0] in n) o = u[0];else {
                    for (i in n) {
                      if (!u[0] || e.converters[i + " " + u[0]]) {
                        o = i;
                        break;
                      }
                      a || (a = i);
                    }
                    o = o || a;
                  }
                  if (o) return o !== u[0] && u.unshift(o), n[o];
                }(d, C, a)), !f && _S.inArray("script", d.dataTypes) > -1 && _S.inArray("json", d.dataTypes) < 0 && (d.converters["text script"] = function () {}), b = function (e, t, n, r) {
                  var i,
                    o,
                    a,
                    s,
                    u,
                    l = {},
                    c = e.dataTypes.slice();
                  if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
                  for (o = c.shift(); o;) if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = c.shift()) if ("*" === o) o = u;else if ("*" !== u && u !== o) {
                    if (!(a = l[u + " " + o] || l["* " + o])) for (i in l) if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                      !0 === a ? a = l[i] : !0 !== l[i] && (o = s[0], c.unshift(s[1]));
                      break;
                    }
                    if (!0 !== a) if (a && e["throws"]) t = a(t);else try {
                      t = a(t);
                    } catch (e) {
                      return {
                        state: "parsererror",
                        error: a ? e : "No conversion from " + u + " to " + o
                      };
                    }
                  }
                  return {
                    state: "success",
                    data: t
                  };
                }(d, b, C, f), f ? (d.ifModified && ((w = C.getResponseHeader("Last-Modified")) && (_S.lastModified[i] = w), (w = C.getResponseHeader("etag")) && (_S.etag[i] = w)), 204 === e || "HEAD" === d.type ? T = "nocontent" : 304 === e ? T = "notmodified" : (T = b.state, p = b.data, f = !(x = b.error))) : (x = T, !e && T || (T = "error", e < 0 && (e = 0))), C.status = e, C.statusText = (t || T) + "", f ? v.resolveWith(h, [p, T, C]) : v.rejectWith(h, [C, T, x]), C.statusCode(m), m = void 0, c && g.trigger(f ? "ajaxSuccess" : "ajaxError", [C, d, f ? p : x]), y.fireWith(h, [C, T]), c && (g.trigger("ajaxComplete", [C, d]), --_S.active || _S.event.trigger("ajaxStop")));
              }
              return C;
            },
            getJSON: function getJSON(e, t, n) {
              return _S.get(e, t, n, "json");
            },
            getScript: function getScript(e, t) {
              return _S.get(e, void 0, t, "script");
            }
          }), _S.each(["get", "post"], function (e, t) {
            _S[t] = function (e, n, r, i) {
              return y(n) && (i = i || r, r = n, n = void 0), _S.ajax(_S.extend({
                url: e,
                type: t,
                dataType: i,
                data: n,
                success: r
              }, _S.isPlainObject(e) && e));
            };
          }), _S.ajaxPrefilter(function (e) {
            var t;
            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
          }), _S._evalUrl = function (e, t, n) {
            return _S.ajax({
              url: e,
              type: "GET",
              dataType: "script",
              cache: !0,
              async: !1,
              global: !1,
              converters: {
                "text script": function text_script() {}
              },
              dataFilter: function dataFilter(e) {
                _S.globalEval(e, t, n);
              }
            });
          }, _S.fn.extend({
            wrapAll: function wrapAll(e) {
              var t;
              return this[0] && (y(e) && (e = e.call(this[0])), t = _S(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e;
              }).append(this)), this;
            },
            wrapInner: function wrapInner(e) {
              return y(e) ? this.each(function (t) {
                _S(this).wrapInner(e.call(this, t));
              }) : this.each(function () {
                var t = _S(this),
                  n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e);
              });
            },
            wrap: function wrap(e) {
              var t = y(e);
              return this.each(function (n) {
                _S(this).wrapAll(t ? e.call(this, n) : e);
              });
            },
            unwrap: function unwrap(e) {
              return this.parent(e).not("body").each(function () {
                _S(this).replaceWith(this.childNodes);
              }), this;
            }
          }), _S.expr.pseudos.hidden = function (e) {
            return !_S.expr.pseudos.visible(e);
          }, _S.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
          }, _S.ajaxSettings.xhr = function () {
            try {
              return new r.XMLHttpRequest();
            } catch (e) {}
          };
          var Jt = {
              0: 200,
              1223: 204
            },
            Kt = _S.ajaxSettings.xhr();
          v.cors = !!Kt && "withCredentials" in Kt, v.ajax = Kt = !!Kt, _S.ajaxTransport(function (e) {
            var _t5, n;
            if (v.cors || Kt && !e.crossDomain) return {
              send: function send(i, o) {
                var a,
                  s = e.xhr();
                if (s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (a in e.xhrFields) s[a] = e.xhrFields[a];
                for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i) s.setRequestHeader(a, i[a]);
                _t5 = function t(e) {
                  return function () {
                    _t5 && (_t5 = n = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Jt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                      binary: s.response
                    } : {
                      text: s.responseText
                    }, s.getAllResponseHeaders()));
                  };
                }, s.onload = _t5(), n = s.onerror = s.ontimeout = _t5("error"), void 0 !== s.onabort ? s.onabort = n : s.onreadystatechange = function () {
                  4 === s.readyState && r.setTimeout(function () {
                    _t5 && n();
                  });
                }, _t5 = _t5("abort");
                try {
                  s.send(e.hasContent && e.data || null);
                } catch (e) {
                  if (_t5) throw e;
                }
              },
              abort: function abort() {
                _t5 && _t5();
              }
            };
          }), _S.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
          }), _S.ajaxSetup({
            accepts: {
              script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
            },
            contents: {
              script: /\b(?:java|ecma)script\b/
            },
            converters: {
              "text script": function text_script(e) {
                return _S.globalEval(e), e;
              }
            }
          }), _S.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
          }), _S.ajaxTransport("script", function (e) {
            var t, _n3;
            if (e.crossDomain || e.scriptAttrs) return {
              send: function send(r, i) {
                t = _S("<script>").attr(e.scriptAttrs || {}).prop({
                  charset: e.scriptCharset,
                  src: e.url
                }).on("load error", _n3 = function n(e) {
                  t.remove(), _n3 = null, e && i("error" === e.type ? 404 : 200, e.type);
                }), x.head.appendChild(t[0]);
              },
              abort: function abort() {
                _n3 && _n3();
              }
            };
          });
          var Zt,
            en = [],
            tn = /(=)\?(?=&|$)|\?\?/;
          _S.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function jsonpCallback() {
              var e = en.pop() || _S.expando + "_" + Dt.guid++;
              return this[e] = !0, e;
            }
          }), _S.ajaxPrefilter("json jsonp", function (e, t, n) {
            var i,
              o,
              a,
              s = !1 !== e.jsonp && (tn.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && tn.test(e.data) && "data");
            if (s || "jsonp" === e.dataTypes[0]) return i = e.jsonpCallback = y(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[s] = e[s].replace(tn, "$1" + i) : !1 !== e.jsonp && (e.url += (Nt.test(e.url) ? "&" : "?") + e.jsonp + "=" + i), e.converters["script json"] = function () {
              return a || _S.error(i + " was not called"), a[0];
            }, e.dataTypes[0] = "json", o = r[i], r[i] = function () {
              a = arguments;
            }, n.always(function () {
              void 0 === o ? _S(r).removeProp(i) : r[i] = o, e[i] && (e.jsonpCallback = t.jsonpCallback, en.push(i)), a && y(o) && o(a[0]), a = o = void 0;
            }), "script";
          }), v.createHTMLDocument = ((Zt = x.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Zt.childNodes.length), _S.parseHTML = function (e, t, n) {
            return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (v.createHTMLDocument ? ((r = (t = x.implementation.createHTMLDocument("")).createElement("base")).href = x.location.href, t.head.appendChild(r)) : t = x), o = !n && [], (i = W.exec(e)) ? [t.createElement(i[1])] : (i = qe([e], t, o), o && o.length && _S(o).remove(), _S.merge([], i.childNodes)));
            var r, i, o;
          }, _S.fn.load = function (e, t, n) {
            var r,
              i,
              o,
              a = this,
              s = e.indexOf(" ");
            return s > -1 && (r = St(e.slice(s)), e = e.slice(0, s)), y(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (i = "POST"), a.length > 0 && _S.ajax({
              url: e,
              type: i || "GET",
              dataType: "html",
              data: t
            }).done(function (e) {
              o = arguments, a.html(r ? _S("<div>").append(_S.parseHTML(e)).find(r) : e);
            }).always(n && function (e, t) {
              a.each(function () {
                n.apply(this, o || [e.responseText, t, e]);
              });
            }), this;
          }, _S.expr.pseudos.animated = function (e) {
            return _S.grep(_S.timers, function (t) {
              return e === t.elem;
            }).length;
          }, _S.offset = {
            setOffset: function setOffset(e, t, n) {
              var r,
                i,
                o,
                a,
                s,
                u,
                l = _S.css(e, "position"),
                c = _S(e),
                f = {};
              "static" === l && (e.style.position = "relative"), s = c.offset(), o = _S.css(e, "top"), u = _S.css(e, "left"), ("absolute" === l || "fixed" === l) && (o + u).indexOf("auto") > -1 ? (a = (r = c.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(u) || 0), y(t) && (t = t.call(e, n, _S.extend({}, s))), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + i), "using" in t ? t.using.call(e, f) : c.css(f);
            }
          }, _S.fn.extend({
            offset: function offset(e) {
              if (arguments.length) return void 0 === e ? this : this.each(function (t) {
                _S.offset.setOffset(this, e, t);
              });
              var t,
                n,
                r = this[0];
              return r ? r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, {
                top: t.top + n.pageYOffset,
                left: t.left + n.pageXOffset
              }) : {
                top: 0,
                left: 0
              } : void 0;
            },
            position: function position() {
              if (this[0]) {
                var e,
                  t,
                  n,
                  r = this[0],
                  i = {
                    top: 0,
                    left: 0
                  };
                if ("fixed" === _S.css(r, "position")) t = r.getBoundingClientRect();else {
                  for (t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === _S.css(e, "position");) e = e.parentNode;
                  e && e !== r && 1 === e.nodeType && ((i = _S(e).offset()).top += _S.css(e, "borderTopWidth", !0), i.left += _S.css(e, "borderLeftWidth", !0));
                }
                return {
                  top: t.top - i.top - _S.css(r, "marginTop", !0),
                  left: t.left - i.left - _S.css(r, "marginLeft", !0)
                };
              }
            },
            offsetParent: function offsetParent() {
              return this.map(function () {
                for (var e = this.offsetParent; e && "static" === _S.css(e, "position");) e = e.offsetParent;
                return e || he;
              });
            }
          }), _S.each({
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset"
          }, function (e, t) {
            var n = "pageYOffset" === t;
            _S.fn[e] = function (r) {
              return _Z2(this, function (e, r, i) {
                var o;
                if (m(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === i) return o ? o[t] : e[r];
                o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i;
              }, e, r, arguments.length);
            };
          }), _S.each(["top", "left"], function (e, t) {
            _S.cssHooks[t] = Ze(v.pixelPosition, function (e, n) {
              if (n) return n = Ke(e, t), Ve.test(n) ? _S(e).position()[t] + "px" : n;
            });
          }), _S.each({
            Height: "height",
            Width: "width"
          }, function (e, t) {
            _S.each({
              padding: "inner" + e,
              content: t,
              "": "outer" + e
            }, function (n, r) {
              _S.fn[r] = function (i, o) {
                var a = arguments.length && (n || "boolean" != typeof i),
                  s = n || (!0 === i || !0 === o ? "margin" : "border");
                return _Z2(this, function (t, n, i) {
                  var o;
                  return m(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? _S.css(t, n, s) : _S.style(t, n, i, s);
                }, t, a ? i : void 0, a);
              };
            });
          }), _S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            _S.fn[t] = function (e) {
              return this.on(t, e);
            };
          }), _S.fn.extend({
            bind: function bind(e, t, n) {
              return this.on(e, null, t, n);
            },
            unbind: function unbind(e, t) {
              return this.off(e, null, t);
            },
            delegate: function delegate(e, t, n, r) {
              return this.on(t, e, n, r);
            },
            undelegate: function undelegate(e, t, n) {
              return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            hover: function hover(e, t) {
              return this.on("mouseenter", e).on("mouseleave", t || e);
            }
          }), _S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
            _S.fn[t] = function (e, n) {
              return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
            };
          });
          var nn = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
          _S.proxy = function (e, t) {
            var n, r, i;
            if ("string" == typeof t && (n = e[t], t = e, e = n), y(e)) return r = s.call(arguments, 2), (i = function i() {
              return e.apply(t || this, r.concat(s.call(arguments)));
            }).guid = e.guid = e.guid || _S.guid++, i;
          }, _S.holdReady = function (e) {
            e ? _S.readyWait++ : _S.ready(!0);
          }, _S.isArray = Array.isArray, _S.parseJSON = JSON.parse, _S.nodeName = E, _S.isFunction = y, _S.isWindow = m, _S.camelCase = re, _S.type = T, _S.now = Date.now, _S.isNumeric = function (e) {
            var t = _S.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
          }, _S.trim = function (e) {
            return null == e ? "" : (e + "").replace(nn, "$1");
          }, void 0 === (n = function () {
            return _S;
          }.apply(t, [])) || (e.exports = n);
          var rn = r.jQuery,
            on = r.$;
          return _S.noConflict = function (e) {
            return r.$ === _S && (r.$ = on), e && r.jQuery === _S && (r.jQuery = rn), _S;
          }, void 0 === i && (r.jQuery = r.$ = _S), _S;
        });
      },
      4876: function _() {}
    },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var o = t[r] = {
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.exports;
  }
  n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return n.d(t, {
      a: t
    }), t;
  }, n.d = function (e, t) {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, function () {
    "use strict";

    n(4876), n(3958);
  }();
}();
/***********************
* browser info
***********************/
var browserSpecifics;
var whichBrowser;
var whichUserAgent;
var mBrowserVersion;
var specialVarForOpera;
specialVarForOpera = navigator.userAgent.substring(0, 5);
var isIE6 = false;
var isIE7 = false;
var isIE8 = false;
var isIE8CO = false;
var isIE9 = false;
jQuery.browser = {};
jQuery.browser.mozilla = /mozilla/.test(navigator.userAgent.toLowerCase()) && !/webkit/.test(navigator.userAgent.toLowerCase());
jQuery.browser.webkit = /webkit/.test(navigator.userAgent.toLowerCase());
jQuery.browser.opera = /opera/.test(navigator.userAgent.toLowerCase());
jQuery.browser.msie = /msie/.test(navigator.userAgent.toLowerCase());
if (navigator.appVersion.indexOf("MSIE 6.") != -1) {
  isIE6 = true;
}
if (navigator.appVersion.indexOf("MSIE 7.") != -1) {
  isIE7 = true;
}
if (navigator.appVersion.indexOf("MSIE 8.") != -1) {
  isIE8 = true;
}
if (navigator.appVersion.indexOf("MSIE 9.") != -1) {
  isIE9 = true;
}
var OSName = "";
if (navigator.appVersion.indexOf("Win") != -1) OSName = "win";
if (navigator.appVersion.indexOf("Mac") != -1) OSName = "mac";
if (navigator.appVersion.indexOf("X11") != -1) OSName = "unix";
if (navigator.appVersion.indexOf("Linux") != -1) OSName = "linux";
if (navigator.appName == "Netscape") {
  if (navigator.userAgent.indexOf("Chrome") != -1) {
    whichBrowser = "Chrome";
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    whichBrowser = "Safari";
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    whichBrowser = "Firefox";
  } else if (specialVarForOpera == "Opera") {
    whichBrowser = specialVarForOpera;
  }
} else if (navigator.appName == "Microsoft Internet Explorer") {
  whichBrowser = "IE";
}
whichUserAgent = navigator.userAgent;
browserSpecifics = whichUserAgent;
var mDetect = function mDetect() {
  var N = navigator.appName,
    ua = navigator.userAgent,
    tem;
  var M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
  if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) M[2] = tem[1];
  M = M ? [M[1], M[2]] : [N, navigator.appVersion, '-?'];
  return M + "";
};
$(document).ready(function () {
  if (navigator.appName == "Microsoft Internet Explorer") {
    var out = "";
    try {
      var b = document.getElementsByTagName("body")[0];
      var s = document.createElement("div");
      s.innerHTML = "<div style='behavior:url(#default#clientCaps)' ID='oClientCaps' ></div>";
      b.appendChild(s);
      var clids = Array('{3af36230-a269-11d1-b5bf-0000f8051515}');
      out += oClientCaps.getComponentVersion(clids[0], "ComponentID");
    } catch (e) {
      out += "clientCaps failed" + e;
    }
    var searchOut = out.search("18702");
    if (searchOut != -1) {
      isIE8CO = true;
    } else {
      isIE8CO = false;
    }
  }
  mBrowserVersion = mDetect();
});

/***********************
* sourceid starts here
***********************/

var mSplitVarArray = new Array();
$(document).ready(function () {
  // cypher through url to find directory and file name
  var mReceivedUrl = document.URL;
  mSplitVarArray = mReceivedUrl.split('/');
  if (mSplitVarArray[mSplitVarArray.length - 1] == "" || typeof mSplitVarArray[mSplitVarArray.length - 1] == "undefined") {
    mSplitVarArray[mSplitVarArray.length - 1] = "index.html";
  }
});
var refUrl;
$(document).ready(function () {
  var a = 2;
  setCookies(a);
});

},{"jquery":1}]},{},[2]);
